webpackJsonp([1],{

/***/ 10:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toGMTString();
  document.cookie = cname + "=" + encodeURIComponent(cvalue) + "; " + expires + ";path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i].trim();
    if (c.indexOf(name) == 0) return decodeURIComponent(c.substring(name.length, c.length));
  }
  return "";
}
function getOrderCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for (var i = ca.length - 1; i > 0; i--) {
    var c = ca[i].trim();
    if (c.indexOf(name) == 0) return decodeURIComponent(c.substring(name.length, c.length));
  }
  return "";
}

/* harmony default export */ __webpack_exports__["a"] = ({
  setCookie: setCookie,
  getCookie: getCookie,
  getOrderCookie: getOrderCookie
});

/***/ }),

/***/ 101:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 103:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

module.exports = {
  title: "LesPark- 全球女性直播交友官网 最in闺蜜情感助手",
  description: "LesPark是一款为全球女性提供交友渠道的pc直播和移动社交软件，是女性专属交友泛娱乐平台。在这里，你可以通过网页开启直播，与粉丝好友零距离实时互动；能够依据定位寻找附近她或参加各种活动，与附近人群建立良好、健康的社交关系。",
  header: {
    nav1: "热门直播",
    nav2: "充值",
    nav3: "主播中心",
    nav3_1: "主播管理后台",
    nav3_2: "开始PC直播",
    nav3_3: "成为签约主播",
    nav3_4: "PC直播指南",
    nav3_5: "PC开播",
    nav3_6: "爱豆提现",
    nav4: "联系我们",
    nav5: "关于我们",
    nav6: "登录/注册",
    nav7: "公司简介",
    me1: "在线充值",
    me2: "退出",
    live: "直播",
    topic: "话题",
    baihuaTitle: "百花计划",
    baihuaAward: "千万补贴",
    ContactUs: "联系客服",
    myHome: "我的首页",
    jihua: "悸花乐读"
  },
  login: {
    nav1: "登录",
    nav2: "注册",
    nav3_1: "快速登录",
    nav3_2: "直接登录",
    nav4: "使用第三方直接登录",
    nav5: "扫描二维码",
    nav6: "下载并注册LesPark",
    nav7: "或",
    nav8: "登录",
    input1: "请输入手机号",
    input2: "请输入密码",
    input3: "中国",
    input4: "美国",
    input5: "台湾",
    input6: "香港",
    input7: "澳门",
    input8: "泰国",
    input9: "马来西亚",
    input10: "新加坡",
    input11: "日本",
    input12: "韩国",
    input13: "澳大利亚",
    input14: "英国",
    input15: "菲律宾",
    input16: "越南"
  },
  home: {
    download: "扫码下载",
    download1: "苹果下载",
    download2: "安卓下载",
    download3: "谷歌下载",
    liveTitle1: "我的关注",
    liveTitle1_1: "暂时没有您关注的主播正在直播,去看看热门直播吧",
    liveTitle2: "热门直播",
    liveTitle3: "热门话题",
    liveTitle3_1: "暂时没有推荐话题",
    appProfile: "APP简介",
    more: "查看全部"
  },
  swiper: {
    0: {
      h1Content: "百花计划",
      h2Content: "拍短视频，享千万补贴"
    },
    1: {
      h1Content: "实时直播",
      h2Content: "高颜值主播和你亲密互动"
    },
    2: {
      h1Content: "多人视频",
      h2Content: "视频连麦 还有红娘牵线"
    },
    3: {
      h1Content: "附近的人",
      h2Content: "发现你身边的同好圈"
    },
    4: {
      h1Content: "情侣公园",
      h2Content: "记录相爱点滴"
    },
    5: {
      h1Content: "即时语聊",
      h2Content: "你的声音 甜过初恋"
    },
    6: {
      h1Content: "快速配对",
      h2Content: "交友脱单 心动匹配"
    }
  },
  live: {
    nav1: "关注",
    nav2: "我的关注",
    nav3: "热门直播",
    nav4: "发送",
    nav5: "加载更多",
    nav6: "直播结束",
    nav7: "关注",
    nav8: "热门"
  },
  foot: {
    content1: "粤公网安备 44180202000386号 ",
    content2: " 粤ICP备18016053号",
    content3: "清远市帕克文化传媒有限公司 2016-2020 All Rights Reserved ",
    content4: " 举报邮箱：cs@lespark.us",
    content5: " 友情链接",
    content6: " 粤网文（2018）3153-1052号",
    HelpCenter: "帮助中心",
    PrivacyPolicy: "隐私政策",
    ServiceAgreement: "服务协议",
    ReportPhone: "违法与不良信息举报电话",
    ReportEmail: "违法与不良信息举报邮箱",
    CompanyProfile: "公司简介",
    JoinUs: "加入我们",
    contactUs: "联系我们",
    ServiceTel: "客服电话"
  },
  foot2: {
    content1: "桂公网安备 45050302000153号",
    content2: " 桂ICP备20003447号-1",
    content3: "北海帕克信息科技有限公司 2016-2023 All Rights Reserved",
    content6: "桂网文（2023）1925-390号"
  },
  live_star: {
    pc: "电脑直播",
    account: "LesPark账号:",
    noLogin: "未登录,",
    login: "点击登录",
    liveTitle: "直播标题:",
    liveCover: "直播封面:",
    oldLiveCover: "使用上次直播封面（头像）",
    customimg: "自定义图片",
    plugFlow: "推流地址:",
    copy: "复制",
    secret: "密钥:",
    finishLive: "结束直播",
    getLiveAdd: "获取直播地址",
    liveNote: "开播须知:",
    liveNote1: "1. 根据相关规定，开播前，请在LesPark app内完成实名认证。请您遵守",
    liveNote2: "2. 在本网页登录LesPark账号，输入标题、选择封面后，点击“开播获取地址”按钮",
    liveNote3: "3. 在OBS中配置推流地址和密钥，点击开始推流即可",
    liveNote4: "4. 直播结束时，请务必在本页面点击“结束直播”，否则直播间将处于黑屏影响观看",
    convention: "LesPark直播公约"
  },
  mobile_login: {
    title: "请先登录哦~",
    sendCode: "发送验证码",
    resendCode: "重新发送",
    btnName: "登录",
    agreeLic: "注册即视为同意",
    lic: "《LesPark使用条款》",
    sendCodeFail: "发送验证码失败",
    errPhoneFormat: "手机格式错误",
    errVerifyCodeRequired: "验证码不能为空",
    errVerifyCodeFormat: "验证码格式错误",
    success: "登录成功",
    fail: "登录失败",
    phoneRequired: "请输入手机号",
    verifyCodeRequired: "请输入验证码"
  },
  dynamic: {
    comment: "评论",
    moreComment: "查看更多评论",
    liaoXjj: "去撩小姐姐",
    faXianXjj: "发现更多好看的姐姐",
    nodata: "帖子被发布者删除了，去LesPark发现更多有趣的帖子吧"
  },
  video: {
    comment: "输入评论...",
    more: "更多精彩视频",
    nodata: "短视频被发布者删除了，去LesPark看看他的其他作品吧~",
    notSupport: "此视频暂无法播放，请稍后再试"
  },
  profile: {
    moreFriends: "发现更多有趣的小伙伴",
    years: "岁",
    userId: "ID",
    fans: "粉丝",
    girlSounds: "萝莉音",
    chat: "私聊",
    signature: "个人签名",
    fullText: "全文",
    notSupportAudio: "您的浏览器不支持 audio 元素",
    nodata: "啊哦~这名用户账号注销了，去LesPark发现更多有趣的小姐姐吧"
  },
  common: {
    follow: "关注",
    followed: "已关注",
    followFail: "关注失败",
    goAndSeed: "去看看",
    like: "点赞",
    liked: "被赞",
    unlikeFail: "取消点赞失败",
    likeFail: "点赞失败",
    likedUnit: "人点赞"
  },
  downloadTip: {
    title: "到LesPark查看更多评论吧",
    textBtn: "去LesPark",
    video: "到LesPark App查看更多有趣的视频吧~",
    profile: "到LesPark App了解小姐姐更多信息，跟小姐姐畅聊吧~",
    dynamic: "到LesPark发现更多有趣的帖子"
  },
  bottomBar: {
    video: "到LesPark发现更多有趣的短视频",
    profile: "到LesPark发现更多有趣的小姐姐",
    dynamic: "到LesPark发现更多有趣的帖子"
  },
  error: {
    userNotExist: "用户不存在",
    networkException: "网络错误",
    phoneVerifyException: "号码异常",
    paramInvalid: "参数错误",
    verifyCodeError: "验证码错误",
    unsafeEnv: "当前使用环境有风险（机审）",
    accountRegisted: "号码已注册",
    postNotFound: "贴子不存在或已删除",
    posterNotFound: "发帖人不存在",
    userNotFound: "用户不存在"
  },
  baiHuaTxt: {
    bg1Title: "https://static.lespark.cn/pc_img/images/baihua/title-cn.png",
    award: ["￥", "2", "0", "0", "0", "W"],
    bg1Tips: "短视频创作收益奖励",
    bg1Tips2: "加入“百花计划”发布原创优质视频，享创作收益",
    rule: "规则说明",
    bg2Title: "LesPark全球最大的多元女性视频平台",
    bg2Tips: ["超多", "流量", "丰厚", "收益", "等你拿"],
    bg2Img: "https://static.lespark.cn/pc_img/images/baihua/bg2Img-cn.png",
    bg2Tips2: "现金奖励",
    bg2Tips3: "*成功加入”百花计划“产生有效播放量，即可获得超高收益",
    bg3Title: "LesPark诚邀每一位创作者加入百花计划",
    bg3Tips: ["让每个", "独一无二的你", "都被看见"],
    bg3Img: "https://static.lespark.cn/pc_img/images/baihua/tequan-cn.png",
    bg3Tips2: "以上仅为部分规划，详情请查看完整",
    bg3Tips3: "加入“百花计划”前，请你仔细阅读活动规则及相关条款",
    bg3Tips4: "凡加入本计划，则视为你已阅读，理解并同意规则全部内容",
    tqSvga: "https://static.lespark.cn/pc_img/images/baihua/tequan-cn.svga",
    titleSvga: "https://static.lespark.cn/pc_img/images/baihua/title-cn.svga"
  },
  photowall: {
    title: "全球多元女性社交",
    LaunchedYears: "上线7年+",
    millionsWomen: "2000\u4E07+<br/>\u5973\u6027\u7528\u6237",
    content1: "\u670D\u52A1\u5168\u7403",
    content2: "\u5343\u4E07\u540D\u591A\u5143\u5973\u6027",
    content3: "\u64AE\u540810000+<br/>\u5BF9\u60C5\u4FA3",
    content4: "1000\u591A\u4E2A<br/>\u4EA4\u53CB\u623F"
  },
  liveAll: {
    content1: "热门直播",
    content2: "全部直播"
  },
  topicAll: {
    content1: "热门话题",
    content2: "全部话题",
    join: "人参与"
  },
  headerOptions: [{
    value: "anchor",
    label: "主播管理",
    children: [{
      value: "pc",
      label: "开始PC直播"
    },
    // {
    //   value: 'backend',
    //   label: '主播管理后台',
    // },
    {
      value: "invite",
      label: "优质直播招募"
    }, {
      value: "sign",
      label: "签约信息录入"
      // {
      //   value: 'withdraw',
      //   label: '提现',
      // },
    }]
  }, {
    value: "union",
    label: "公会",
    children: [{
      value: "Trade",
      label: "公会入驻"
    }, {
      value: "management",
      label: "公会管理"
    }]
  }],
  lesApp: {
    content1: "LesPark - 认识超过 2000 万 多元女性",
    content2: "条评论",
    content3: "千万女性记录和分享生活的社交平台，通过直播、语音聊天轻松表达真实自我，每天产生数十万条原创新鲜视频、语音、文字、图片，分享发现真实有趣的世界，让你享受轻松交友的社交体验。",
    content4: "LesPark的使命：链接全球少数人群，让世界更宽容、更快乐",
    content5: "实时直播",
    content6: "这里有陪伴你的高颜值主播，陪你聊天、唱歌，连接真实的你和精彩的世界",
    content7: "多人视频",
    content8: "红娘在线，多人连线模式，让你孤独的寻觅变成你们姻缘的相遇",
    content9: "附近的人",
    content10: "精准的地理位置翻看附近优秀的多元女性，让你一键GET身边的她",
    content11: "视频匹配",
    content12: "一对一视频匹配聊天，真人视频，拒绝伪装，面对面零距离热聊，瞬间了解彼此",
    content13: "情侣公园",
    content14: "多元女性情侣专属空间，记录每个相爱瞬间；完成情侣清单和每日打卡任务，获得积分兑换精美礼品",
    content15: "语音派对",
    content16: "实时在线语音派对，跟众多小姐姐一起连麦聊天、唱歌、相亲约会、玩游戏，带你1秒终结孤单",
    content17: "即时语聊",
    content18: "10秒匹配远方的她，与陌生人畅所欲言，结识新朋友，讲故事，道晚安，发现好听的声音，让声音治愈你",
    content19: "快速配对",
    content20: "交友脱单，单身待解救者，根据你的喜好位置设置快速匹配兴趣相投的她",
    content21: "用户点评",
    content22: "来自29820位用户评分",
    content23: "常见问题",
    content24: "App内会有男性用户吗？",
    content25: "不会，我们有审核客服运营团队7*24小时在线严格审核，谢绝男性用户进入，一经发现将作封禁处理。",
    content26: "为什么使用LesPark？",
    content27: "LesPark 作为专属多元女性社交的应用程序，为女性创造一个安全的空间，目标是提供一个平台来建立友善关系并进行对话，而没有欺凌、偏见和社会风险。",
    content28: "LesPark收费吗？",
    content29: "LesPark是免费的社交应用，可以在 App Store 和 安卓应用商店下载",
    content30: "LesPark会不会透露我的信息？",
    content31: "LesPark不会以任何形式向第三方透露用户信息，以确保大家的隐私安全。",
    commentList: [{
      time: "2021-06-28",
      name: "珍惜",
      content: "在LesPark找到了现在的女朋友是我最幸运的事，一直没在软件里面发过动态，都是默默看别人，缘分就是那么其妙吧，她还是把我找到了，果然还是要主动才行哈哈，祝愿大家都找到属于自己的幸福。"
    }, {
      time: "2021-08-01",
      name: "花开",
      content: "因为这个圈子很小，显示生活中是深柜又不能标明自己的取向去大胆的找对象，用了这个软件之后才发现自己的身边有蛮多这样的唉，还有附近的社群可以找到一个跟你一个圈子的大家庭，感觉有了属于自己的交际圈，很开心~"
    }, {
      time: "2021-08-01",
      name: "Zhang",
      content: "软件界面挺好看的，用来用去还是这个最靠谱，喜欢动态配对功能，好好玩，好多漂亮的小姐姐，因为里面大家都是多元女性， 不必担心别人异样的眼光。良心软件，加油挺好的赞。"
    }, {
      time: "2021-08-13",
      name: "Christian",
      content: "这里可以不用在意异样的眼光，可以无限做自己，找到自己爱的人，找到相投的人做朋友，随着软件的一步步更新，用户体验越来越好，内容也越来越丰富。~"
    }, {
      time: "2021-09-01",
      name: "怡婷",
      content: "作为一个多元女性以前感到很寂寞没有人理解，现在有了朋友和社区真好，已经认识不少新朋友，发现大家颜值都好高呀，支持加油赞赞。"
    }]
  },
  aboutUs: {
    content1: "LesPark \u4E3A\u6E05\u8FDC\u5E02\u5E15\u514B\u6587\u5316\u4F20\u5A92\u6709\u9650\u516C\u53F8\u65D7\u4E0B\u7814\u53D1\u7684\u4E00\u6B3E\u4E3A\u5168\u7403\u5973\u6027\u63D0\u4F9B\u4EA4\u53CB\u6E20\u9053\u7684\u79FB\u52A8\u793E\u4EA4\u8F6F\u4EF6\u3002\u4E0D\u8BBA\u662F\u60F3\u6210\u4E3AKOL\uFF0C\u5750\u62E5\u767E\u4E07\u7C89\u4E1D\uFF1B\u8FD8\u662F\u60F3\u4EA4\u670B\u53CB\u3001\u5206\u4EAB\u60C5\u611F\u3001\u6DA8\u77E5\u8BC6LesPark\u90FD\u6709\u4E13\u4E3A\u8EAB\u4E3A\u5973\u6027\u7684\u4F60\u6253\u9020\u7684\u4FBF\u5229\u5E73\u53F0\u4E0E\u771F\u5B9E\u793E\u533A\u3002",
    content1_1: "LesPark \u4E3A\u5317\u6D77\u5E15\u514B\u4FE1\u606F\u79D1\u6280\u6709\u9650\u516C\u53F8\u65D7\u4E0B\u7814\u53D1\u7684\u4E00\u6B3E\u4E3A\u5168\u7403\u5973\u6027\u63D0\u4F9B\u4EA4\u53CB\u6E20\u9053\u7684\u79FB\u52A8\u793E\u4EA4\u8F6F\u4EF6\u3002\u4E0D\u8BBA\u662F\u60F3\u6210\u4E3AKOL\uFF0C\u5750\u62E5\u767E\u4E07\u7C89\u4E1D\uFF1B\u8FD8\u662F\u60F3\u4EA4\u670B\u53CB\u3001\u5206\u4EAB\u60C5\u611F\u3001\u6DA8\u77E5\u8BC6LesPark\u90FD\u6709\u4E13\u4E3A\u8EAB\u4E3A\u5973\u6027\u7684\u4F60\u6253\u9020\u7684\u4FBF\u5229\u5E73\u53F0\u4E0E\u771F\u5B9E\u793E\u533A\u3002",
    content1_2: "LesPark \u4E3A ORIENT BASIC SCIENCE AND TECHNOLOGY PTE. LTD. \u65D7\u4E0B\u7814\u53D1\u7684\u4E00\u6B3E\u4E3A\u5168\u7403\u5973\u6027\u63D0\u4F9B\u4EA4\u53CB\u6E20\u9053\u7684\u79FB\u52A8\u793E\u4EA4\u8F6F\u4EF6\u3002\u4E0D\u8BBA\u662F\u60F3\u6210\u4E3AKOL\uFF0C\u5750\u62E5\u767E\u4E07\u7C89\u4E1D\uFF1B\u8FD8\u662F\u60F3\u4EA4\u670B\u53CB\u3001\u5206\u4EAB\u60C5\u611F\u3001\u6DA8\u77E5\u8BC6LesPark\u90FD\u6709\u4E13\u4E3A\u8EAB\u4E3A\u5973\u6027\u7684\u4F60\u6253\u9020\u7684\u4FBF\u5229\u5E73\u53F0\u4E0E\u771F\u5B9E\u793E\u533A\u3002",
    content2: "\u5728\u8FD9\u91CC\uFF0C\u4F60\u80FD\u591F\u901A\u8FC7\u793E\u533A\u3001\u76F4\u64AD\u5C55\u793A\u81EA\u5DF1\uFF0C\u4E0E\u7C89\u4E1D\u96F6\u8DDD\u79BB\u5B9E\u65F6\u4E92\u52A8\uFF1B\u80FD\u591F\u4F9D\u636E\u5B9A\u4F4D\u52A0\u5165\u9644\u8FD1\u7FA4\u7EC4\u53C2\u52A0\u5404\u79CD\u6D3B\u52A8\uFF0C\u4E0E\u9644\u8FD1\u4EBA\u7FA4\u5EFA\u7ACB\u826F\u597D\u3001\u5065\u5EB7\u7684\u793E\u4EA4\u5173\u7CFB\u3002",
    content3: "\u201CLive for Love\u2014\u2014\u4E3A\u7231\u800C\u751F\u201D\uFF0C\u4E00\u76F4\u4EE5\u6765\u90FD\u662FLesPark\u7684\u53E3\u53F7\uFF0C\u529B\u4E8E\u6253\u9020\u5973\u6027\u7FA4\u4F53\u8BB0\u5F55\u548C\u5206\u4EAB\u751F\u6D3B\u7684\u5E73\u53F0\u3002",
    content4: "\u76EE\u524D\uFF0CLesPark\u5DF2\u4E0A\u7EBF\u8FD0\u84257\u5E74\uFF0C\u62E5\u6709\u5782\u76F4\u9886\u57DF\u7528\u6237\u6570\u5DF2\u7A81\u78342000\u4E07\uFF0C\u5206\u5E03\u5168\u740334\u4E2A\u56FD\u5BB6\uFF0C\u4E3B\u64AD\u6570\u91CF\u5DF2\u8D8515\u4E07\u3002",
    content5: "\u4F01\u4E1A\u6587\u5316",
    content6: "\u4F7F\u547D",
    content7: "\u94FE\u63A5\u5168\u7403\u5C11\u6570\u4EBA\u7FA4",
    content8: "\u8BA9\u4E16\u754C\u66F4\u52A0\u5BBD\u5BB9\u3001\u66F4\u5FEB\u4E50",
    content9: "\u613F\u666F",
    content10: "\u6210\u4E3A\u5C11\u6570\u4EBA\u7FA4\u6700\u53EF\u4FE1\u8D56\u7684\u5168\u7403\u5316\u516C\u53F8",
    content11: "\u5728\u4E0D\u65AD\u5730\u521B\u65B0\u4E2D\u5EFA\u7ACB\u5C11\u6570\u4EBA",
    content12: "\u7FA4\u666E\u60E0\u4EF7\u503C\u7F51\u7EDC",
    content13: "\u4EF7\u503C\u89C2",
    content14: "\u7528\u6237\u7B2C\u4E00\u3001\u56E2\u961F\u534F\u4F5C",
    content15: "\u7ED3\u679C\u5BFC\u5411\u3001\u8FFD\u6C42\u6781\u81F4",
    content16: "\u79EF\u6781\u4E3B\u52A8\u3001\u52C7\u6562\u65E0\u754F",
    content17: "\u52A0\u5165\u6211\u4EEC",
    content18: "\u6211\u4EEC\u9700\u8981\u4EA7\u54C1\u3001\u8FD0\u8425\u3001\u6280\u672F\u7B49\u5404\u5C97\u4F4D\u4EBA\u624D\uFF0C\u671F\u5F85\u4F60\u7684\u52A0\u5165\uFF01",
    content19: "\u7ACB\u5373\u52A0\u5165",
    content20: "\u8054\u7CFB\u6211\u4EEC",
    content21: "\u8054\u7CFB\u4EBA",
    content22: "\u5F20\u5148\u751F",
    content23: "\u5BA2\u670D\u7535\u8BDD",
    content24: "\u8054\u7CFB\u5730\u5740",
    content25: "\u4E3E\u62A5\u6295\u8BC9",
    content26: "\u5E7F\u4E1C\u6E05\u8FDC\u5E02\u5E7F\u6E05\u5927\u9053\u516B\u5341\u516B\u53F7\u4E91\u5C71\u8BD7\u610F\u82B1\u56ED\u4E91\u5C71\u8BD7\u610F\u5927\u53A614\u5C42\u529E\u516C\u5BA408\u53F7",
    content26_1: "\u5E7F\u897F\u58EE\u65CF\u81EA\u6CBB\u533A\u5317\u6D77\u5E02\u56DB\u5DDD\u8DEF299\u53F7\u7A57\u4E30\u91D1\u6E7E1\u5E620401\u53F7",
    content26_2: "ORIENT BASIC SCIENCE AND TECHNOLOGY PTE. LTD."
  },
  loginHome: {
    content1: "加载更多",
    content2: "粉丝",
    content3: "获赞",
    content4: "动态"
  },
  topicItem: {
    content1: "人赞",
    content2: "查看全部",
    content3: "条评论",
    content4: "回复",
    content5: "评论...",
    content6: "发送"
  },
  baihuaRule: {
    title: "百花计划活动规则",
    ruleSet: ["\u52A0\u5165\u77ED\u89C6\u9891\u767E\u82B1\u8BA1\u5212\uFF08\u4EE5\u4E0B\u7B80\u79F0\u201C\u672C\u8BA1\u5212\u201D\uFF09\u524D\uFF0C\u8BF7\u7528\u6237\u8BE6\u7EC6\u9605\u8BFB\u6D3B\u52A8\u89C4\u5219\u53CA\u76F8\u5173\u6761\u6B3E\u3002\u51E1\u7533\u8BF7\u52A0\u5165\u767E\u82B1\u8BA1\u5212\uFF0C\u5219\u89C6\u4E3A\u7528\u6237\u5DF2\u9605\u8BFB\u3001\u7406\u89E3\u5E76\u540C\u610F\u6D3B\u52A8\u89C4\u5219\u5168\u90E8\u5185\u5BB9\u3002", "<h3 class=\"h3-label\">\u8BA1\u5212\u4ECB\u7ECD</h3>", "\u767E\u82B1\u8BA1\u5212\u662F\u7531LesPark\u5E73\u53F0\u4E3E\u529E\u7684\u6FC0\u52B1\u77ED\u89C6\u9891\u521B\u4F5C\u7684\u6D3B\u52A8\u3002\u6210\u529F\u52A0\u5165\u767E\u82B1\u8BA1\u5212\u7684\u4F5C\u8005\uFF0C\u901A\u8FC7\u7AD9\u5185\u53D1\u5E03\u7684<span>\u539F\u521B\u9AD8\u6E05\u89C6\u9891\uFF08\u65F6\u957F\u226510\u79D2)</span>\uFF0C\u6709\u673A\u4F1A\u4EAB\u53D7\u521B\u4F5C\u6536\u76CA\u3002", "<h3 class=\"h3-label\">\u8BA1\u5212\u7684\u52A0\u5165\u65B9\u5F0F</h3>", "1.\u4F60\u53EF\u901A\u8FC7\u70B9\u51FB\u8BA1\u5212\u4ECB\u7ECD\u9875\u9762\u7684\u201C\u7ACB\u5373\u52A0\u5165\u201D\u6309\u94AE\u5E76\u5B8C\u6210\u76F8\u5E94\u7684\u7533\u8BF7\u4EFB\u52A1\uFF0C\u5373\u53EF\u7533\u8BF7\u52A0\u5165\u767E\u82B1\u8BA1\u5212\u3002", "2.\u7533\u8BF7\u52A0\u5165\u767E\u82B1\u8BA1\u5212\u524D\uFF0C\u9700\u8981\u5B8C\u6210\u4EE5\u4E0B\u7533\u8BF7\u4EFB\u52A1\uFF0C\u5E73\u53F0\u5C06\u6839\u636E\u6D3B\u52A8\u89C4\u5219\u5BF9\u7533\u8BF7\u8005\u7684\u89C6\u9891\u5185\u5BB9\u8D28\u91CF\u8FDB\u884C\u5BA1\u6838\uFF0C\u5BA1\u6838\u901A\u8FC7\u540E\u5373\u53EF\u6210\u529F\u52A0\u5165\u767E\u82B1\u8BA1\u5212\u3002", "1)\u5B8C\u6210\u624B\u673A\u53F7\u7ED1\u5B9A\uFF0C\u4EE5\u53CA\u5B9E\u540D\u8BA4\u8BC1<br/>\n2)\u8FD130\u5929\u5185\uFF0C\u901A\u8FC7LesPark App\u53D1\u5E03\u8FC7\u5927\u4E8E\u7B49\u4E8E5\u7BC7\u516C\u5F00\u53EF\u89C1\u7684\u3001\u539F\u521B\u9AD8\u6E05\u89C6\u9891\uFF08\u6E05\u6670\u5EA6\u2265720P\uFF09\u3001\u65F6\u957F\u226510\u79D2<br/>\n3)\u8FD130\u5929\u5185\uFF0C\u901A\u8FC7LesPark App\u53D1\u5E03\u7684\u6240\u6709\u516C\u5F00\u53EF\u89C1\u7684\u3001\u539F\u521B\u9AD8\u6E05\u89C6\u9891\uFF08\u65F6\u957F\u226510\u79D2)\u7684\u603B\u64AD\u653E\u91CF\u8FBE\u523060000\n", "3.\u5F53\u4F60\u5B8C\u6210\u7533\u8BF7\u4EFB\u52A1\u65F6\uFF0C\u53EF\u70B9\u51FB\u6309\u94AE\uFF0C\u63D0\u4EA4\u5BA1\u6838\u3002\u5B98\u65B9\u5DE5\u4F5C\u4EBA\u5458\u5C06\u6839\u636E\u8D26\u53F7\u53D1\u5E03\u7684\u539F\u521B\u9AD8\u6E05\u89C6\u9891\uFF08\u65F6\u957F\u226510\u79D2) \u4EE5\u53CA\u5185\u5BB9\u8D28\u91CF\u6807\u51C6\uFF08\u8BE6\u89C1\u89C4\u5219\uFF1A<a href=\"/baihuaQualityReview.html\">\u5185\u5BB9\u8D28\u91CF\u5BA1\u6838</a>\uFF09\u7B49\u8981\u6C42\uFF0C\u6765\u786E\u5B9A\u4F60\u662F\u5426\u53EF\u4EE5\u52A0\u5165\u672C\u8BA1\u5212\u3002\u5BA1\u6838\u7ED3\u679C\u5C06\u901A\u8FC7\u8BA1\u5212\u4ECB\u7ECD\u9875\u9762\u548C\u6D88\u606F\u901A\u77E5\u516C\u5E03\u3002", "1)\u5982\u679C\u7531\u4E8E\u4E0D\u7B26\u5408\u5185\u5BB9\u8D28\u91CF\u6807\u51C6\u7B49\u539F\u56E0\u672A\u5BA1\u6838\u901A\u8FC7\uFF0C\u4F60\u53EF\u4EE5\u6839\u636E\u76F8\u5E94\u7684\u63D0\u793A\u539F\u56E0\u6216\u8005\u5EFA\u8BAE\uFF0C\u8FDB\u884C\u8C03\u6574\uFF0C\u6216\u8005\u5C1D\u8BD5\u518D\u6B21\u53D1\u5E03\u81F3\u5C115\u7BC7\u539F\u521B\u9AD8\u6E05\u89C6\u9891\uFF08\u65F6\u957F\u226510\u79D2)\uFF0C\u8C03\u6574\u5B8C\u6210\u540E\u53EF\u518D\u6B21\u63D0\u4EA4\u5BA1\u6838\u7533\u8BF7\u3002\n      2)\u5E73\u53F0\u4F18\u5148\u9F13\u52B1\u81EA\u4E3B\u62CD\u6444\u53CA\u521B\u4F5C\u7684\u521B\u4F5C\u8005\u52A0\u5165\u672C\u8BA1\u5212\u3002\n      3)\u5F53\u524D\u8D26\u53F7\u4E3A\u6CE8\u9500\u3001\u5220\u9664\u3001\u5C01\u7981\u7B49\u5F02\u5E38\u72B6\u6001\u65F6\uFF0C\u65E0\u6CD5\u52A0\u5165\u767E\u82B1\u8BA1\u5212\u3002\n      4)\u521B\u4F5C\u7684\u89C6\u9891\u9700\u6EE1\u8DB3\u5E73\u53F0\u539F\u521B\u6807\u51C6\uFF08\u8BE6\u89C1\u89C4\u5219\uFF1A<a href=\"/baihuaOriginalStandards.html\">\u539F\u521B\u6807\u51C6</a>\uFF09\uFF0C\u4E0D\u5B58\u5728\u8272\u60C5\u3001\u4F4E\u4FD7\u3001\u753B\u9762\u4E0D\u6E05\u6670\u3001\u5237\u7C89\u5237\u64AD\u653E\u91CF\u7B49\u4E0D\u826F\u95EE\u9898\u3002\u4E0D\u6D89\u53CA\u672A\u6210\u5E74\u3001\u5E7F\u544A\u8425\u9500\u3001\u9ED1\u4EA7\u6559\u5B66\u3001\u8A00\u8BBA\u653B\u51FB\u3001\u65E0\u8D44\u8D28\u8BB2\u89E3\u8D22\u7ECF\u7B49\u8D1F\u9762\u5BFC\u5411\u95EE\u9898\u3002\u540C\u65F6\u6CE8\u610F\uFF0C\u82E5\u8D26\u53F7\u4E2D\u5927\u91CF\u90FD\u662F\u65E0\u610F\u4E49\u968F\u62CD\u6216\u57FA\u4E8E\u4E00\u5B9A\u7D20\u6750\u7B80\u6613\u52A0\u5DE5\uFF0C\u521B\u4F5C\u7A0B\u5EA6\u8F83\u4F4E\u7684\u89C6\u9891\uFF0C\u4E5F\u65E0\u6CD5\u52A0\u5165\u767E\u82B1\u8BA1\u5212\u3002\n      ", "<h3 class=\"h3-label\">\u8BA1\u5212\u6536\u76CA</h3>", "1.\u89C6\u9891\u521B\u4F5C\u6536\u76CA<br/>\n        \u6210\u529F\u52A0\u5165\u8BA1\u5212\u540E\uFF0C\u901A\u8FC7LesPark App\u53D1\u5E03\u7684\u539F\u521B\u9AD8\u6E05\u89C6\u9891\uFF08\u65F6\u957F\u226510\u79D2)\uFF0C\u82E5\u64AD\u653E\u91CF\u8FBE\u52302w\u3001\u901A\u8FC7\u5185\u5BB9\u8D28\u91CF\u5BA1\u6838\u3001\u89C6\u9891\u4F5C\u54C1\u5904\u4E8E\u201C\u6536\u76CA\u4E2D\u201D\u72B6\u6001\u4E0B\uFF0C\u8BE5\u4F5C\u54C1\u7684\u6536\u76CA\u64AD\u653E\u91CF\u5747\u53EF\u83B7\u5F97\u521B\u4F5C\u6536\u76CA\u3002\u6CE8\u610F\uFF1A\u5355\u4E2A\u89C6\u9891\u4F5C\u54C1\u7684\u6536\u76CA\u671F\u4E3A\u53D1\u5E03\u5E76\u901A\u8FC7\u5BA1\u6838\u540E\u768490\u5929\u5185\uFF0C\u8D85\u8FC790\u5929\u4F1A\u88AB\u8BBE\u7F6E\u4E3A\u201C\u6536\u76CA\u8FC7\u671F\u201D\uFF1B\u82E5\u89C6\u9891\u4F5C\u54C1\u672A\u901A\u8FC7\u5BA1\u6838\uFF0C\u5219\u4F1A\u88AB\u8BBE\u7F6E\u4E3A\u201C\u5BA1\u6838\u5931\u8D25\u201D\uFF1B\u901A\u8FC7\u5BA1\u6838\uFF0C\u4E14\u672A\u8D85\u8FC790\u5929\u5468\u671F\u5185\uFF0C\u5219\u4F1A\u88AB\u8BBE\u7F6E\u4E3A\u201C\u6536\u76CA\u4E2D\u201D\u72B6\u6001\u3002\n        2.\u6536\u76CA\u67E5\u770B\u4E0E\u63D0\u73B0<br/>\n        1)\u52A0\u5165\u767E\u82B1\u8BA1\u5212\u540E\u83B7\u5F97\u7684\u6536\u76CA\u53EF\u5728LesPark App\u2014\u2014\u6211\u7684\u2014\u2014\u4FA7\u8FB9\u680F\u2014\u2014\u521B\u4F5C\u8005\u4E2D\u5FC3\uFF0C\u67E5\u770B\u76F8\u5173\u6536\u76CA\uFF0C\u4E5F\u53EF\u5728LesPark App\u2014\u2014\u6211\u7684\u2014\u2014\u4FA7\u8FB9\u680F\u2014\u2014\u94BB\u77F3\u94B1\u5305\uFF0C\u8FDB\u884C\u67E5\u770B\u3002<br/>\n        2)\u6536\u76CA\u7684\u63D0\u73B0\uFF0C\u6BCF\u5929\u6700\u591A\u7533\u8BF71\u6B21\uFF0C\u53EF\u4F9D\u636E\u53EF\u63D0\u989D\u5EA6\uFF0C\u9009\u62E9\u5BF9\u5E94\u6863\u4F4D\u91D1\u989D\u4E0E\u5E73\u53F0\uFF0C\u63D0\u4EA4\u63D0\u73B0\u7533\u8BF7\uFF0C\u63D0\u73B0\u5BA1\u6838\u901A\u8FC7\u540E\uFF0C\u4F1A\u8FDB\u884C\u76F8\u5E94\u6253\u6B3E\u64CD\u4F5C\u3002\n        ", "<h3 class=\"h3-label\">\u8BA1\u5212\u8FDD\u89C4\u8BF4\u660E</h3>", "1.LesPark\u5B98\u65B9\u6709\u6743\u5BF9\u53C2\u4E0E\u672C\u6D3B\u52A8\u7684\u7528\u6237\u8FDB\u884C\u5B89\u5168\u9A8C\u8BC1<br/>\n\u5982\u53C2\u4E0E\u672C\u6D3B\u52A8\u7684\u7528\u6237\u66FE\u7ECF\u5B58\u5728\u3001\u51FA\u73B0\u6216\u7ECFLesPark\u5B98\u65B9\u5408\u7406\u6000\u7591\u5B58\u5728\u8FDD\u53CD\u6CD5\u5F8B\u6CD5\u89C4\u6216LesPark\u5E73\u53F0\u89C4\u5219\u3001\u8FDD\u80CC\u8BDA\u5B9E\u4FE1\u7528\u539F\u5219\u7684\u884C\u4E3A\uFF0CLesPark\u5B98\u65B9\u6709\u6743\u91C7\u53D6\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u9650\u5236\u6CE8\u518C/\u767B\u5F55LesPark App\u3001\u7981\u6B62\u53C2\u4E0E\u672C\u6D3B\u52A8\u3001\u64A4\u9500\u6D3B\u52A8\u53C2\u4E0E\u8D44\u683C\u3001\u53D6\u6D88\u6216\u51BB\u7ED3\u83B7\u5F97\u6D3B\u52A8\u6536\u76CA(\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u901A\u8FC7\u53C2\u4E0E\u6D3B\u52A8\u53EF\u80FD\u4F1A\u83B7\u5F97\u7684\u865A\u62DF\u7269\u54C1\u3001\u73B0\u91D1\u3001\u5B9E\u7269\u7B49\u6536\u76CA)\u7684\u8D44\u683C\u3001\u65E0\u6CD5\u83B7\u53D6\u6216\u4EC5\u53EF\u83B7\u53D6\u90E8\u5206\u6D3B\u52A8\u6536\u76CA\u3001\u5DF2\u83B7\u53D6\u7684\u6D3B\u52A8\u6536\u76CA\u4F7F\u7528/\u63D0\u73B0\u53D7\u5230\u5168\u90E8/\u90E8\u5206\u9650\u5236\u3001\u6536\u56DE\u5DF2\u53D1\u653E\u7684\u6D3B\u52A8\u6536\u76CA\u3001\u5C01\u7981\u5E10\u53F7\u7B49\u5904\u7F6E\u63AA\u65BD\uFF0C\u540C\u65F6\u4FDD\u7559\u8FFD\u7A76\u8BE5\u7528\u6237\u76F8\u5173\u6CD5\u5F8B\u8D23\u4EFB\u7684\u6743\u5229\u3002\n\u8FDD\u80CC\u8BDA\u5B9E\u4FE1\u7528\u539F\u5219\u7684\u884C\u4E3A\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\uFF1A<br/>\n1)\u4E0B\u8F7D\u975E\u5B98\u65B9\u5BA2\u6237\u7AEF\uFF1B<br/>\n2)\u4F7F\u7528\u9AD8\u5371\u4F5C\u5F0A\u5ACC\u7591\u7684\u624B\u673A\u53F7\u3001\u865A\u62DF\u624B\u673A\u53F7\u3001QQ\u3001\u5FAE\u4FE1\u53F7\u7B49\u7B2C\u4E09\u65B9\u5E73\u53F0\u5E10\u53F7\u6CE8\u518C/\u767B\u5F55LesPark App\uFF1B<br/>\n3)\u4FEE\u6539\u9875\u9762\u53C2\u6570\u3001\u7BE1\u6539\u8BBE\u5907\u6570\u636E\uFF1B<br/>\n4)\u4EE5\u4EFB\u4F55\u673A\u5668\u4EBA\u8F6F\u4EF6\u3001\u8718\u86DB\u8F6F\u4EF6\u3001\u722C\u866B\u8F6F\u4EF6\u3001\u5237\u5C4F\u8F6F\u4EF6\u6216\u4EFB\u4F55\u975E\u4EBA\u5DE5\u65B9\u5F0F\u53C2\u4E0E\u6D3B\u52A8\uFF1B<br/>\n5)\u4F7F\u7528\u6A21\u62DF\u5668\u3001\u63D2\u4EF6\u3001\u5916\u6302\u3001App\u5206\u8EAB\u8F6F\u4EF6\u7B49\u975E\u6CD5\u5DE5\u5177\u626B\u7801\u3001\u4E0B\u8F7D\u3001\u5B89\u88C5\u3001\u6CE8\u518C\u3001\u767B\u5F55LesPark\u5BA2\u6237\u7AEF\u3001\u53C2\u4E0E\u6D3B\u52A8\u3001\u9886\u53D6\u6D3B\u52A8\u6536\u76CA\u3001\u63D0\u73B0\u3001\u8FDB\u884C\u6D3B\u52A8\u6536\u76CA\u8D60\u4E0E\uFF1B<br/>\n6)\u901A\u8FC7\u6076\u610F\u725F\u5229\u624B\u6BB5\u6270\u4E71\u5E73\u53F0\u79E9\u5E8F\uFF1B<br/>\n7)\u4F7F\u7528\u63D2\u4EF6\u3001\u5916\u6302\u3001\u7FA4\u63A7\u7CFB\u7EDF\u6216\u7B2C\u4E09\u65B9\u5DE5\u5177\u5BF9LesPark\u5E73\u53F0\u53CA\u672C\u6D3B\u52A8\u8FDB\u884C\u5E72\u6270\u3001\u7834\u574F\u3001\u4FEE\u6539\u6216\u65BD\u52A0\u5176\u4ED6\u5F71\u54CD\uFF1B<br/>\n8)\u4E0E\u5176\u4ED6\u7528\u6237\u4E32\u901A\u6216\u5229\u7528\u673A\u5668\u7B49\u65B9\u5F0F\u8FDB\u884C\u4F5C\u5F0A\u3001\u5237\u53D6\u6D3B\u52A8\u6536\u76CA\u7B49\u6270\u4E71\u6D3B\u52A8\u79E9\u5E8F\u7684\u884C\u4E3A\uFF1B<br/>\n9)\u5176\u4ED6LesPark\u5E73\u53F0\u6709\u5408\u7406\u7406\u7531\u6000\u7591\u7684\u8FDD\u80CC\u8BDA\u5B9E\u4FE1\u7528\u539F\u5219\u7684\u884C\u4E3A\u3002<br/>\n<br/>\n2.\u7528\u6237\u5728\u53C2\u52A0\u672C\u7CFB\u5217\u6D3B\u52A8\u8FC7\u7A0B\u4E2D\uFF0C\u5982\u5B58\u5728\u4EE5\u6240\u83B7\u5F97\u7684\u6D3B\u52A8\u5956\u52B1\u8FDB\u884C\u4EFB\u4F55\u76C8\u5229\u6216\u975E\u6CD5\u83B7\u5229\u3001\u4EE5\u4EFB\u4F55\u5F62\u5F0F\u8F6C\u8BA9\u6216\u8F6C\u79FB\u5176\u901A\u8FC7\u6D3B\u52A8\u6240\u83B7\u5F97\u7684\u5956\u52B1\uFF0C\u6216LesPark\u5B98\u65B9\u6709\u5408\u7406\u7406\u7531\u6000\u7591\u7528\u6237\u5B58\u5728\u4E0D\u6B63\u5F53\u4F7F\u7528\u6D3B\u52A8\u5956\u52B1\uFF0C\u6270\u4E71LesPark\u5E73\u53F0\u79E9\u5E8F\u7684\uFF0CLesPark\u5B98\u65B9\u6709\u6743\u53D6\u6D88\u7528\u6237\u7684\u6D3B\u52A8\u53C2\u4E0E\u8D44\u683C\u3001\u6536\u56DE\u5DF2\u53D1\u653E\u7684\u6D3B\u52A8\u5956\u52B1(\u542B\u5DF2\u4F7F\u7528\u53CA\u672A\u4F7F\u7528\u7684) \u540C\u65F6\u4FDD\u7559\u8FFD\u7A76\u8BE5\u7528\u6237\u76F8\u5173\u6CD5\u5F8B\u8D23\u4EFB\u7684\u6743\u5229\u3002\n<br/><br/>\n3.LesPark\u5B98\u65B9\u7279\u522B\u63D0\u793A\u60A8\uFF0C\u8BF7\u60A8\u52A1\u5FC5\u901A\u8FC7LesPark\u5B98\u65B9\u53CALesPark\u5B98\u65B9\u6307\u5B9A\u8DEF\u5F84\u53C2\u4E0E\u672C\u7CFB\u5217\u6D3B\u52A8\uFF0C\u56E0\u7528\u6237\u53C2\u4E0E\u4EFB\u4F55\u975ELesPark\u5B98\u65B9\u6D3B\u52A8\u6216\u5192\u7528LesPark\u540D\u4E49\u5F00\u5C55\u7684\u6D3B\u52A8\uFF0C\u9020\u6210\u7528\u6237\u635F\u5931\u7684\uFF0CLesPark\u5BF9\u6B64\u4E0D\u627F\u62C5\u4EFB\u4F55\u6CD5\u5F8B\u8D23\u4EFB\u3002\n", "<h3 class=\"h3-label\">\u6CE8\u610F\u4E8B\u9879</h3>", "1.\u6309\u7167\u76F8\u5173\u6CD5\u5F8B\u89C4\u5B9A\uFF0C\u4E3B\u529E\u65B9\u9700\u5C31\u83B7\u5956\u8005\u5728\u672C\u6D3B\u52A8\u4E0B\u6240\u5F97\u8FDB\u884C\u4EE3\u6263\u4EE3\u7F34\u4E2A\u4EBA\u6240\u5F97\u7A0E\u7684\uFF0C\u4E3B\u529E\u65B9\u6709\u6743\u4F9D\u6CD5\u4EE3\u6263\u4EE3\u7F34\u3002\u672A\u7ECF\u4E3B\u529E\u65B9\u4E8B\u5148\u4E66\u9762\u8BB8\u53EF\uFF0C\u7528\u6237\u56E0\u53C2\u52A0\u672C\u6D3B\u52A8\u6240\u53D6\u5F97\u7684\u6743\u5229\u6216\u83B7\u5F97\u7684\u5956\u52B1\u5747\u4E0D\u5F97\u8F6C\u8BA9\u3002<br/>\n2.\u7528\u6237\u4E0D\u5F97\u4EE5\u4EFB\u4F55\u4E0D\u6B63\u5F53\u624B\u6BB5\u6216\u821E\u5F0A\u65B9\u5F0F\u53C2\u4E0E\u672C\u6D3B\u52A8\u6216\u5229\u7528\u672C\u6D3B\u52A8\u4ECE\u4E8B\u8FDD\u6CD5\u884C\u4E3A\u3002\u4E00\u7ECF\u53D1\u73B0\uFF0C\u4E3B\u529E\u65B9\u6709\u6743\u91C7\u53D6\u964D\u4F4E\u6D3B\u52A8\u5956\u52B1\u3001\u9650\u5236\u63D0\u73B0\u3001\u8D26\u53F7\u91D1\u989D\u6E05\u96F6\u3001\u64A4\u6D88\u6D3B\u52A8\u8D44\u683C\u3001\u9650\u5236\u767B\u5F55\u3001\u5C01\u7981\u8D26\u53F7\u3001\u9650\u5236\u518D\u6B21\u6CE8\u518C\u4F7F\u7528\u7B49\u63AA\u65BD\uFF0C\u4EA6\u6709\u6743\u6536\u56DE\u7528\u6237\u5DF2\u9886\u53D6\u7684\u5956\u52B1\u3001\u8FFD\u8BA8\u5DF2\u63D0\u73B0\u7684\u91D1\u989D\uFF0C\u5E76\u4FDD\u7559\u8FFD\u7A76\u8BE5\u7528\u6237\u8D23\u4EFB\u7684\u6743\u5229\u3002<br/>\n3.\u4E3B\u529E\u65B9\u4F9D\u6CD5\u8FD0\u8425\u6B64\u6B21\u6D3B\u52A8\uFF0C\u5982\u56E0\u4E0D\u53EF\u6297\u529B\u3001\u60C5\u52BF\u53D8\u66F4\u3001\u76F8\u5173\u653F\u7B56\u53D8\u52A8\u3001\u653F\u5E9C\u673A\u5173\u6307\u4EE4\u8981\u6C42\u3001\u6D3B\u52A8\u53C2\u4E0E\u4EBA\u6570\u4E0D\u8DB3\u3001\u7B2C\u4E09\u65B9\u539F\u56E0\u7B49\u975E\u4E3B\u529E\u65B9\u539F\u56E0\u5BFC\u81F4\u672C\u6B21\u6D3B\u52A8\u8C03\u6574\u3001\u6682\u505C\u4E3E\u529E\u3001\u65E0\u6CD5\u8FDB\u884C\u3001\u7528\u6237\u53C2\u4E0E\u5931\u8D25\u7684\uFF0C\u4E3B\u529E\u65B9\u6709\u6743\u968F\u65F6\u51B3\u5B9A\u4FEE\u6539\u3001\u6682\u505C\u3001\u53D6\u6D88\u6216\u7EC8\u6B62\u672C\u6D3B\u52A8\uFF0C\u5E76\u65E0\u9700\u4E3A\u6B64\u627F\u62C5\u4EFB\u4F55\u6CD5\u5F8B\u8D23\u4EFB\u3002\u7528\u6237\u81EA\u8EAB\u539F\u56E0\u5BFC\u81F4\u53C2\u4E0E\u5931\u8D25\u7684\uFF0C\u4E0D\u5229\u540E\u679C\u7531\u7528\u6237\u81EA\u884C\u627F\u62C5\u3002\u7528\u6237\u53EF\u5728\u672C\u9875\u9762\u968F\u65F6\u67E5\u770B\u4FEE\u6539\u540E\u7684\u6D3B\u52A8\u89C4\u5219\uFF0C\u82E5\u7528\u6237\u5BF9\u4FEE\u6539\u540E\u7684\u6D3B\u52A8\u89C4\u5219\u6709\u5F02\u8BAE\u7684\uFF0C\u8BF7\u505C\u6B62\u7EE7\u7EED\u53C2\u4E0E\uFF0C\u82E5\u7528\u6237\u7EE7\u7EED\u53C2\u52A0\u672C\u6D3B\u52A8\uFF0C\u5219\u89C6\u4E3A\u7528\u6237\u540C\u610F\u672C\u6D3B\u52A8\u89C4\u5219\u7684\u4FEE\u6539\u3002<br/>\n4.\u300ALesPark\u4F7F\u7528\u6761\u6B3E\u300B\u3001\u300ALesPark\u9690\u79C1\u653F\u7B56\u300B\u540C\u6837\u9002\u7528\u4E8E\u672C\u6B21\u6D3B\u52A8\uFF0C\u672C\u6B21\u6D3B\u52A8\u89C4\u5219\u53CA\u76F8\u5173\u6761\u6B3E\u4E0E\u300ALesPark\u4F7F\u7528\u6761\u6B3E\u300B\u3001\u300ALesPark\u9690\u79C1\u653F\u7B56\u300B\u76F8\u51B2\u7A81\u7684\uFF0C\u4EE5\u672C\u6B21\u6D3B\u52A8\u89C4\u5219\u53CA\u76F8\u5173\u6761\u6B3E\u4E3A\u51C6\u3002\u672C\u6B21\u6D3B\u52A8\u89C4\u5219\u53CA\u76F8\u5173\u6761\u6B3E\u672A\u7EA6\u5B9A\u7684\u5185\u5BB9\uFF0C\u4ECD\u4EE5\u300ALesPark\u4F7F\u7528\u6761\u6B3E\u300B\u3001\u300ALesPark\u9690\u79C1\u653F\u7B56\u300B\u4E3A\u51C6\u3002<br/>\n5.\u5982\u679C\u4F60\u5728\u6D3B\u52A8\u4E2D\u9047\u5230\u4EFB\u4F55\u95EE\u9898\uFF0C\u53EF\u4EE5\u6253\u5F00 LesPark App\uFF0C\u901A\u8FC7\u4EBA\u5DE5\u5BA2\u670D\u6216\u8005\u8054\u7CFB\u5FAE\u4FE1\u5B98\u65B9\u53F7\u7B49\u6E20\u9053\uFF0C\u8FDB\u884C\u54A8\u8BE2\u3002<br/>\n6.\u672C\u6D3B\u52A8\u4E0EApple Inc.\u65E0\u5173<br/>\n"]
  },
  baihuaOriginalStandards: {
    title: "百花计划 原创标准说明",
    ruleSet: ["<div class=\"h3-label\">\u539F\u521B\u4F5C\u54C1\u5B9A\u4E49</div>", "1.\u5B9E\u62CD\u7C7B\uFF1A\u4E2A\u4EBA\u6216\u56E2\u961F\u4EB2\u81EA\u72EC\u7ACB\u521B\u4F5C\u7684\u89C6\u9891\uFF0C\u5E76\u62E5\u6709\u4F5C\u54C1\u5185\u6240\u6709\u5185\u5BB9\u7684\u76F8\u5173\u7248\u6743<br/>\n(1)\u89C6\u9891\u5185\u5BB9\u753B\u9762\u5E72\u51C0\u6574\u6D01\uFF0C\u4E3B\u9898\u660E\u786E\u3001\u5185\u5BB9\u5B8C\u6574\u6709\u8BB0\u5FC6\u70B9\uFF0C\u8D26\u53F7\u5185\u5BB9\u98CE\u683C\u7EDF\u4E00\uFF1B<br/>\n(2)\u771F\u4EBA\u51FA\u955C\u7C7B\u89C6\u9891\uFF0C\u9700\u6709\u660E\u786E\u7684\u4EBA\u8BBE\u5C5E\u6027\uFF0C\u51FA\u955C\u4EBA\u4E0E\u8D26\u53F7\u5B9E\u540D\u8BA4\u8BC1\u4FE1\u606F\u9700\u4FDD\u6301\u4E00\u81F4\uFF1B<br/>\n(3)\u975E\u771F\u4EBA\u51FA\u955C\u7684\u89C6\u9891\uFF0C\u9700\u6709\u660E\u786E\u7684\u4E3B\u9898\u5B9A\u4F4D\uFF0C\u53EF\u6839\u636E\u4F5C\u54C1\u7684\u5782\u7C7B\u3001\u98CE\u683C\u3001\u8D26\u53F7\u7279\u5F81\u3001\u4F5C\u8005\u63D0\u4F9B\u7684\u6750\u6599\u7B49\u5224\u65AD\u8D26\u53F7\u4E0B\u5185\u5BB9\u5C5E\u4E8E\u5F53\u524D\u8D26\u53F7\u521B\u4F5C\uFF1B\n", "2.\u4E8C\u6B21\u526A\u8F91\u521B\u4F5C\u7C7B\u4F5C\u54C1<br/>\n(1)\u5728\u9002\u5EA6\u5F15\u7528\u539F\u89C6\u9891\u7D20\u6750\u57FA\u7840\u4E0A\uFF0C\u4E8C\u6B21\u521B\u4F5C\u6210\u4E3A\u4E00\u4E2A\u4E30\u5BCC\u3001\u6709\u4FE1\u606F\u91CF\u3001\u6709\u81EA\u5DF1\u7F16\u8F91\u601D\u8DEF\u3001\u6709\u72EC\u521B\u6027\u7684\u65B0\u89C6\u9891\u4F5C\u54C1\uFF1B<br/>\n(2)\u4E8C\u6B21\u521B\u4F5C\u5F62\u5F0F\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u4F53\u73B0\u81EA\u5DF1\u60F3\u6CD5\u548C\u601D\u8003\u7684\u89E3\u8BF4\u70B9\u8BC4\u3001\u526A\u8F91\u5236\u4F5C\u3001\u7279\u6548\u5305\u88C5\u3001\u97F3\u9891\u5904\u7406\u7B49\uFF1B\n", "3.\u4EE5\u4E0B\u7C7B\u578B\u4E0D\u5C5E\u4E8E\u539F\u521B\u4F5C\u54C1<br/>\n(1)\u4E0A\u4F20\u4E0E\u4ED6\u4EBA\u76F8\u4F3C\u7684\u4F5C\u54C1\uFF1A<br/>\n\u25CF \u76F4\u63A5\u642C\u8FD0\u3001\u5F55\u5C4F\u3001\u5C4F\u62CD\u4ED6\u4EBA\u4F5C\u54C1\u4E0A\u4F20\u53D1\u5E03\uFF1B<br/>\n\u25CF \u5728\u672A\u83B7\u5F97\u7248\u6743\u65B9\u6388\u6743\u6216\u65E0\u7248\u6743\u7684\u60C5\u51B5\u4E0B\uFF0C\u53D1\u5E03\uFF08\u6216\u76F4\u63A5\u4E0A\u4F20\uFF09\u5F71\u89C6\u5267\u3001\u7EFC\u827A\u3001\u52A8\u6F2B\u3001\u97F3\u4E50MV\u3001\u65B0\u95FB\u3001\u6E38\u620F\u4F53\u80B2\u8D5B\u4E8B\u7B49\u7248\u6743\u5185\u5BB9<br/>\n\u25CF \u7EAF\u5F55\u5C4F\u7C7B\u5185\u5BB9\uFF0C\u5BF9\u521B\u4F5C\u4EBA\u6CA1\u6709\u53C2\u4E0E\u6444\u50CF\u3001\u5F55\u5236\u3001\u52A0\u5DE5\u7684\u4F5C\u54C1\u8FDB\u884C\u5F55\u64AD", "(2)\u4E8C\u6B21\u521B\u4F5C\u7A0B\u5EA6\u4E0D\u9AD8\u7684\u5185\u5BB9<br/>\n\u25CF \u5185\u5BB9\u4E30\u5BCC\u5EA6\u4F4E\uFF0C\u5982\u5BF9\u539F\u6709\u7D20\u6750\u8FDB\u884C\u7B80\u5355\u526A\u8F91\u62FC\u63A5\uFF0C\u6216\u7B80\u5355\u6DFB\u52A0\u77ED\u6682\u7684\u5F00\u573A\u767D\u3001\u573A\u666F\u8FC7\u6E21\u4E32\u573A\u8BCD\u3001\u80CC\u666F\u97F3\u4E50\u7B49<br/>\n\u25CF \u4E8C\u521B\u6210\u672C\u8F83\u4F4E\uFF0C\u4EC5\u5BF9\u89C6\u9891\u7D20\u6750\u6216\u6587\u6848\u8FDB\u884C\u7B80\u5355\u7684\u7FFB\u8BD1\u3001\u914D\u97F3\u751F\u786C\u523B\u677F\u7B49\uFF1B\u6216\u4F7F\u7528\u4ED6\u4EBA\u97F3\u9891\u4F5C\u54C1\uFF0C\u4EC5\u7B80\u5355\u914D\u4E0A\u89C6\u9891\u753B\u9762<br/>\n\u25CF \u89E3\u8BF4\u4FE1\u606F\u5355\u8584\uFF0C\u6CA1\u6709\u660E\u786E\u7684\u4E3B\u9898\u548C\u4E2A\u4EBA\u6709\u6548\u4FE1\u606F\u4EF7\u503C\u89C2\u70B9\u8F93\u51FA\uFF0C\u89C6\u9891\u5185\u7684\u89E3\u8BF4\u6587\u6848\u6D89\u5ACC\u6284\u88AD\u3001\u89C2\u70B9\u6765\u81EA\u7F51\u7EDC<br/>\n\u25CF \u5F15\u7528\u7D20\u6750\u4F4E\u8D28\uFF0C\u5982\u5F15\u7528\u89C6\u9891\u548C\u56FE\u50CF\u7D20\u6750\u5B58\u5728\u6A21\u7CCA\u6296\u52A8\u3001\u62C9\u4F38\u653E\u5927/\u7F29\u5C0F\u3001\u660E\u663E\u9ED1\u8FB9\u7B49\u60C5\u51B5<br/>\n\u25CF \u5F15\u7528\u7D20\u6750\u548C\u89C6\u9891\u4E3B\u9898\u7684\u5173\u8054\u6027\u4F4E", "(3)\u4E00\u6587\u591A\u53D1<br/>\n\u25CF \u540C\u4E00\u89C6\u9891\u53D1\u5E03\u5728\u81EA\u5DF1/\u516C\u53F8\u4E0D\u540C\u7684\u8D26\u53F7\uFF0C\u4E14\u5747\u58F0\u660E\u539F\u521B<br/>\n\u25CF \u5728\u540C\u4E00\u8D26\u53F7\u5185\uFF0C\u540C\u4E00\u89C6\u9891\u91CD\u590D\u58F0\u660E\u539F\u521B\uFF0C\u7279\u6B8A\u60C5\u51B5\u4E0B\u53EF\u8C41\u514D\uFF0C\u6BD4\u5982\uFF1A\u7B2C\u4E00\u904D\u53D1\u5E03\u6709\u8BEF\u4F46\u5F88\u5FEB\u5220\u9664\u3001\u5728\u7B2C\u4E00\u6B21\u53D1\u5E03\u89C6\u9891\u7684\u57FA\u7840\u4E0A\u7EE7\u7EED\u5B8C\u5584\u5185\u5BB9\u4E14\u52A0\u5DE5\u70B9\u4E30\u5BCC<br/>", "(4)\u65E0\u6CD5\u8BC1\u660E\u539F\u521B\u6027\u8D28\u7684\u4F5C\u54C1\uFF1A<br/>\n\u25CF \u8D26\u53F7\u53D1\u5E03\u56FE\u96C6\u4F5C\u54C1\uFF0C\u4E14\u65E0\u6CD5\u8BC1\u660E\u539F\u521B\u6027\uFF1A\u8D26\u53F7\u53D1\u5E03\u4F4E\u8D28\u91CF\u56FE\u7247\u4F5C\u54C1\uFF0C\u5982\u6587\u5B57\u4FE1\u606F\u7C7B\u622A\u56FE\u3001\u7A7A\u6D1E\u65E0\u610F\u4E49\u7684\u968F\u624B\u62CD\u3001\u4F24\u611F\u53E5\u5B50\u3001\u7ECF\u5178\u8BED\u5F55\u7B49\u56FE\u7247\u7B49\uFF1B\u8D26\u53F7\u53D1\u5E03\u660E\u663E\u7F51\u56FE\u4F5C\u54C1\uFF0C\u5982\u660E\u661F\u3001\u7F8E\u5973\u3001\u7F51\u7EA2\u4ECB\u7ECD\u7B49\n"]
  },
  baihuaQualityReview: {
    title: "百花计划 内容质量审核规则",
    ruleSet: ["<div class=\"h3-label\">\u4E00\u3001\u4F18\u8D28\u539F\u521B\u4F5C\u8005</div>", "1.\u5177\u5907\u7A33\u5B9A\u751F\u4EA7\u80FD\u529B\uFF0C\u5728LesPark\u6301\u7EED\u3001\u7A33\u5B9A\u66F4\u65B0\u4F5C\u54C1<br/>\n2.\u4F5C\u8005\u751F\u4EA7\u7684\u4F5C\u54C1\u9886\u57DF\u5782\u76F4\uFF0C\u98CE\u683C\u7EDF\u4E00\uFF0C\u6709\u4E2A\u4EBA\u7279\u8272<br/>\n3.\u4F5C\u8005\u575A\u6301\u751F\u4EA7\u539F\u521B\u4F5C\u54C1\uFF0C\u5C0A\u91CD\u521B\u4F5C\u3001\u5C0A\u91CD\u7248\u6743<br/>\n4.\u4F5C\u8005\u6301\u7EED\u751F\u4EA7\u4F18\u8D28\u4F5C\u54C1\uFF0C\u5E26\u7ED9\u7528\u6237\u826F\u597D\u7684\u89C2\u770B\u4F53\u9A8C<br/>\n", "<div class=\"h3-label\">\u4E8C\u3001\u4F18\u8D28\u4F5C\u54C1</div>", "1.\u4F5C\u54C1\u89C2\u770B\u4F53\u9A8C\u597D<br/>\n(1)\u4F5C\u54C1\u8D28\u91CF\u4F18\u8D28\uFF1A<br/>\n\u25CF \u5C01\u9762\uFF1A\u5C01\u9762\u89C6\u89C9\u51B2\u51FB\u611F\u5F3A\uFF0C\u98CE\u683C\u7EDF\u4E00\uFF0C\u7A81\u51FA\u91CD\u70B9\uFF0C\u6709\u52A9\u4E8E\u7528\u6237\u5728\u89C2\u611F\u4E0A\u5F62\u6210\u4E00\u4E2A\u7CFB\u5217\u7684\u8BA4\u77E5<br/>\n\u25CF \u6807\u9898\uFF1A\u6807\u9898\u76F4\u89C2\u7A81\u51FA\uFF0C\u4E0E\u5185\u5BB9\u76F8\u5173\uFF0C\u65E0\u6807\u9898\u5938\u5F20\u7B49\u95EE\u9898<br/>\n\u25CF \u753B\u9762\uFF1A\u89C6\u9891\u753B\u9762\u7F8E\u89C2\u6E05\u6670\u3001\u65E0\u566A\u70B9\uFF0C\u5BF9\u6BD4\u5EA6\u9002\u5B9C\uFF1B\u89C6\u9891\u753B\u9762\u5B8C\u6574\uFF0C\u65E0\u6C34\u5370\u8FC7\u591A\u3001\u62C9\u5347\u3001\u653E\u5927\u88C1\u526A\u5BFC\u81F4\u753B\u9762\u4E0D\u5168\u3001\u9ED1\u8FB9\u7B49\u95EE\u9898<br/>\n\u25CF \u58F0\u97F3\uFF1A\u89C6\u9891\u97F3\u753B\u540C\u6B65\u3001\u65E0\u6742\u97F3\uFF0C\u4EBA\u7269\u53F0\u8BCD\u58F0\u97F3\u6E05\u6670\u3001\u97F3\u91CF\u9002\u5B9C<br/>\n\u25CF \u5B57\u5E55\uFF1A\u89C6\u9891\u5B57\u5E55\u5B8C\u6574\u53EF\u89C1\uFF0C\u5B57\u5E55\u4E0E\u89C6\u9891\u753B\u9762\u3001\u89C6\u9891\u58F0\u97F3\u540C\u6B65<br/>\n\u25CF \u8282\u594F\uFF1A\u89C6\u9891\u6D41\u7545\uFF0C\u64AD\u653E\u4E0D\u5361\u987F\uFF0C\u60C5\u8282\u5B8C\u6574\uFF0C\u6709\u5934\u6709\u5C3E<br/>\n(2)\u4F5C\u54C1\u6EE1\u8DB3\u65F6\u6548\u6027\u3001\u4E13\u4E1A\u6027\u3001\u5B9E\u7528\u6027\u3001\u8DA3\u5473\u6027\u7B49\u5176\u4E00\u7279\u5F81<br/>\n(3)\u4F5C\u54C1\u601D\u60F3\u5B8C\u6574\uFF0C\u8868\u8FBE\u4E3B\u65E8\u660E\u786E\u6E05\u6670\uFF0C\u4F5C\u54C1\u6574\u4F53\u89C2\u611F\u7684\u8212\u9002\u5EA6\u3001\u6109\u60A6\u6027\u3001\u89C2\u8D4F\u6027\u5F3A", "2.\u4F5C\u54C1\u521B\u4F5C\u6210\u672C\u9AD8<br/>\n(1)\u751F\u4EA7\u524D\u671F\uFF1A\u4F5C\u54C1\u6709\u5B8C\u6574\u7684\u6784\u601D\uFF0C\u62CD\u6444\u8FC7\u7A0B\u5B58\u5728\u811A\u672C\u3001\u60C5\u8282\u3001\u6587\u6848\u8BBE\u8BA1\u3001\u6F14\u5458\u7B49<br/>\n(2)\u751F\u4EA7\u540E\u671F\uFF1A\u901A\u8FC7\u6DFB\u52A0\u5B57\u5E55\u3001\u80CC\u666F\u97F3\u4E50\u7B49\u63D0\u5347\u89C6\u9891\u53EF\u770B\u6027\uFF0C\u89C6\u9891\u526A\u8F91\u6D41\u7545\uFF0C\u89C6\u9891\u5B8C\u6574\u5EA6\u9AD8\n", "<div class=\"h3-label\">\u4E09\u3001\u975E\u4F18\u8D28\u4F5C\u54C1</div>", "(1)\u5236\u4F5C\u7B80\u5355\u7C97\u7CD9\uFF1A<br/>\n\u25CF \u65E5\u5E38\u751F\u6D3B\u968F\u624B\u62CD\uFF0C\u5185\u5BB9\u7A7A\u6D1E/\u65E0\u5177\u4F53\u5B9E\u9645\u610F\u4E49/\u968F\u624B\u62CD\u6444/\u65E0\u89C2\u8D4F\u4EF7\u503C/\u7F3A\u4E4F\u53EF\u770B\u6027<br/>\n\u25CF \u76F4\u64AD\u9884\u544A\u3001\u76F4\u64AD\u5F55\u5C4F\u7B49\u5185\u5BB9\uFF0C\u65E0\u518D\u6B21\u52A0\u5DE5\u4E14\u5185\u5BB9\u5355\u8584\u3001\u753B\u9762\u5355\u4E00<br/>\n\u25CF \u7F51\u7EDC\u56FE\u7247\u62FC\u51D1\u7C7B\u56FE\u96C6\u4F5C\u54C1<br/>\n(2)\u753B\u9762\u89C2\u611F\u4E0D\u9002\uFF1A<br/>\n\u25CF \u89C6\u9891\u7ED9\u4EBA\u5E26\u6765\u4E25\u91CD\u7684\u753B\u9762\u51B2\u51FB\u611F\uFF0C\u5F15\u4EBA\u4E0D\u9002\uFF0C\u5982\u8840\u8165\u3001\u5BC6\u96C6\u753B\u9762<br/>\n(3)\u4E0D\u826F\u4EF7\u503C\u89C2:<br/>\n\u25CF \u89C6\u9891\u5BA3\u4F20\u4E0D\u826F\u98CE\u6C14\u548C\u4E0D\u5F53\u884C\u4E3A\uFF0C\u5982\u62DC\u91D1\u3001\u5356\u60E8\u3001\u4E0D\u6587\u660E\u7528\u8BCD\u3001\u6253\u67B6\u6597\u6BB4\u7B49<br/>\n(4)\u8425\u9500\u63A8\u5E7F/\u8BF1\u5BFC\u8981\u8D5E\uFF1A<br/>\n\u25CF \u4EE5\u76C8\u5229\u4E3A\u76EE\u7684\u7684\u7EAF\u5E7F\u544A\u3001\u5F15\u5BFC\u7528\u6237\u7EBF\u4E0B\u4EA4\u6613<br/>\n\u25CF \u901A\u8FC7\u60C5\u611F\u7ED1\u67B6\u6C42\u8D5E\u6C42\u5173\u6CE8\u7684\u6076\u610F\u9A97\u6D41\u884C\u4E3A<br/>\n(5)\u8C23\u8A00\u4F2A\u79D1\u5B66<br/>\n\u25CF \u4F20\u64AD\u672A\u7ECF\u8BC1\u5B9E\u7684\u865A\u5047\u6D88\u606F\u3001\u5C01\u5EFA\u8FF7\u4FE1\u548C\u8FDD\u80CC\u79D1\u5B66\u89C4\u5F8B\u7684\u5185\u5BB9\n"]
  },
  mobleTxt: {
    t1: '优质主播申请',
    download: '一键下载',
    download2: '立即下载',
    more: '查看更多',
    lesAppTitle: '- 认识超过 2000 万 多元女性',
    aboutUsT1: '虽小众 不孤独'
  }
};

/***/ }),

/***/ 122:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(628);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);
var state = {
    isMobile: false
};
var getters = {};
var actions = {};
var mutations = {
    changeView: function changeView(state, value) {
        state.isMobile = value;
    }
};
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    state: state, mutations: mutations, getters: getters, actions: actions
}));

/***/ }),

/***/ 13:
/***/ (function(module, exports) {

module.exports = {
  title: "LesPark- 全球拉拉直播交友官網",
  description: "LesPark為全球les提供交友渠道，集pc直播和移動社交軟體，是拉拉專屬交友泛娛樂平臺。在這裏，妳可以通過網頁開啟直播，與粉絲好友零距離實時互動；能夠依據定位尋找附近她或參加各種活動，與附近人群建立良好、健康的社交關系。",
  header: {
    nav1: "熱門直播",
    nav2: "在線充值",
    nav3: "主播中心",
    nav3_1: "主播管理後台",
    nav3_2: "開始PC直播",
    nav3_3: "成為簽約主播",
    nav3_4: "PC直播指南",
    nav3_5: "PC开播",
    nav3_6: "愛豆提現",
    nav4: "聯繫我們",
    nav5: "關於我們",
    nav6: "登錄/註冊",
    nav7: "公司簡介",
    me1: "在線充值",
    me2: "退出",
    live: "直播",
    topic: "話題",
    baihuaTitle: "百花計劃",
    baihuaAward: "千萬補貼",
    ContactUs: "聯系客服",
    myHome: "我的首頁",
    jihua: "悸花樂讀"
  },
  login: {
    nav1: "登錄",
    nav2: "註冊",
    nav3_1: "快速登錄",
    nav3_2: "直接登錄",
    nav4: "使用第三方直接登錄",
    nav5: "掃描二維碼",
    nav6: "下載并註冊LesPark",
    nav7: "或",
    nav8: "登錄",
    input1: "請輸入手機號",
    input2: "請輸入密碼",
    input3: "中國",
    input4: "美國",
    input5: "臺灣",
    input6: "香港",
    input7: "澳門",
    input8: "泰國",
    input9: "馬來西亞",
    input10: "新加坡",
    input11: "日本",
    input12: "韓國",
    input13: "澳大利亞",
    input14: "英國",
    input15: "菲律賓",
    input16: "越南"
  },
  live: {
    nav1: "關注",
    nav2: "我的關注",
    nav3: "熱門直播",
    nav4: "發送",
    nav5: "加載更多",
    nav6: "直播結束",
    nav7: "關注",
    nav8: "熱門"
  },
  home: {
    download: "掃碼下載",
    download1: "蘋果下載",
    download2: "安卓下載",
    download3: "谷歌下載",
    liveTitle1: "我的關注",
    liveTitle1_1: "暫時沒有您關註的主播正在直播,去看看熱門直播吧",
    liveTitle2: "熱門直播",
    liveTitle3: "熱門话题",
    liveTitle3_1: "暂时没有推荐话题",
    appProfile: "APP簡介",
    more: "查看全部"
  },
  swiper: {
    0: {
      h1Content: "百花計劃",
      h2Content: "拍短視頻，享千萬補貼"
    },
    1: {
      h1Content: "實時直播",
      h2Content: "高顏值主播和妳親密互動"
    },
    2: {
      h1Content: "多人視頻",
      h2Content: "視頻連麥 還有紅娘牽線"
    },
    3: {
      h1Content: "附近的人",
      h2Content: "發現妳身邊的同好圈"
    },
    4: {
      h1Content: "情侶公園",
      h2Content: "記錄相愛點滴"
    },
    5: {
      h1Content: "即時語聊",
      h2Content: "妳的聲音 甜過初戀"
    },
    6: {
      h1Content: "快速配對",
      h2Content: "交友脫單 心動匹配"
    }
  },
  foot: {
    // content1: '京公網安備 11010802023956號 ',
    // content2: ' 京ICP備14047082號-4 ',
    // content3: '北京高梓行远科技有限公司 2013-2017 All Rights Reserved 客服電話：010-56153450 舉報電話：010-56153450',
    // content4: ' 舉報郵箱：cs@lespark.us',
    // content5: ' 友情鏈接',
    // content6: '京網文（2017）1347-096號'
    content1: "粵公網安備 44180202000386號 ",
    content2: " 粵ICP備18016053號",
    content3: "清遠市帕克文化傳媒有限公司 2016-2020 All Rights Reserved ",
    content4: " 舉報郵箱：cs@lespark.us",
    content5: " 友情鏈接",
    content6: " 粵網文（2018）3153-1052號",
    HelpCenter: "幫助中心",
    PrivacyPolicy: "隱私政策",
    ServiceAgreement: "服務協議",
    ReportPhone: "違法與不良信息舉報電話",
    ReportEmail: "違法與不良信息舉報郵箱",
    CompanyProfile: "公司簡介",
    JoinUs: "加入我們",
    contactUs: "聯系我們",
    ServiceTel: "客服電話"
  },
  foot2: {
    content1: "桂公網安備 45050302000153號",
    content2: "桂ICP備20003447號-1",
    content3: "北海帕克信息科技有限公司 2016-2023 All Rights Reserved ",
    content6: "桂網文（2023）1925-390號"
  },

  live_star: {
    pc: "电脑直播",
    account: "LesPark賬號:",
    noLogin: "未登錄,",
    login: "點擊登錄",
    liveTitle: "直播標題:",
    liveCover: "直播封面:",
    oldLiveCover: "使用上次直播封面(頭像)",
    customimg: "自定義圖片",
    plugFlow: "推流地址:",
    copy: "復制",
    secret: "密鑰:",
    finishLive: "結束直播",
    getLiveAdd: "獲取直播地址",
    liveNote: "開播須知:",
    liveNote1: "1. 根據相關規定，開播前，請在LesPark app內完成實名認證。請您遵守",
    liveNote2: "2. 在本網頁登錄LesPark賬號，輸入標題、選擇封面後，點擊“開播獲取地址”按鈕",
    liveNote3: "3. 在OBS中配置推流地址和密鑰，點擊開始推流即可",
    liveNote4: "4. 直播結束時，請務必在本頁面點擊“結束直播”，否則直播間將處於黑屏影響觀看",
    convention: "LesPark直播公約"
  },
  mobile_login: {
    title: "請先登錄哦~",
    sendCode: "發送驗證碼",
    resendCode: "重新發送",
    btnName: "登錄",
    agreeLic: "注冊即視爲同意",
    lic: "《LesPark使用條款》",
    sendCodeFail: "發送驗證碼失敗",
    errPhoneFormat: "手機格式錯誤",
    errVerifyCodeRequired: "驗證碼不能為空",
    errVerifyCodeFormat: "驗證碼格式錯誤",
    success: "登錄成功",
    fail: "登錄失敗",
    phoneRequired: "請輸入手機號碼",
    verifyCodeRequired: "請輸入驗證碼"
  },
  dynamic: {
    comment: "評論",
    moreComment: "查看更多評論",
    liaoXjj: "去撩小姐姐",
    faXianXjj: "發現更多好看的姐姐",
    nodata: "帖子被發佈者刪除了，去LesPark發現更多有趣的帖子吧"
  },
  video: {
    comment: "輸入評論...",
    more: "更多精彩視頻",
    nodata: "短視頻被發佈者刪除了，去LesPark看看他的其他作品吧~",
    notSupport: "此視頻暫無發播放，請稍後再試"
  },
  profile: {
    moreFriends: "發現更多有趣的小夥伴",
    years: "嵗",
    userId: "ID",
    fans: "粉絲",
    girlSounds: "蘿莉音",
    chat: "私聊",
    signature: "個人簽名",
    fullText: "全文",
    notSupportAudio: "您的瀏覽器不支持audio元素",
    nodata: "啊哦~這名用戶賬號注銷了，去LesPark發現更多有趣的小姐姐吧"
  },
  common: {
    follow: "關注",
    followed: "已關注",
    followFail: "關注失敗",
    goAndSeed: "去看看",
    like: "點贊",
    liked: "被讚",
    unlikeFail: "取消點贊失敗",
    likeFail: "點贊失敗",
    likedUnit: "人點贊"
  },
  downloadTip: {
    title: "到LesPark查看更多評論吧",
    textBtn: "去LesPark",
    video: "到LesPark App查看更多有趣的視頻吧~",
    profile: "到LesPark App瞭解小姐姐更多信息，跟小姐姐暢聊吧~",
    dynamic: "到LesPark發現更多有趣的帖子"
  },
  bottomBar: {
    video: "到LesPark發現更多有趣的短視頻",
    profile: "到LesPark發現更多有趣的小姐姐",
    dynamic: "到LesPark發現更多有趣的帖子"
  },
  error: {
    userNotExist: "用戶不存在",
    networkException: "網絡錯誤",
    phoneVerifyException: "號碼異常",
    paramInvalid: "參數錯誤",
    verifyCodeError: "驗證碼錯誤",
    unsafeEnv: "當前使用環境有風險（機審）",
    accountRegisted: "號碼已注冊",
    postNotFound: "帖子不存在或刪除",
    posterNotFound: "發帖人不存在",
    userNotFound: "用戶不存在"
  },
  baiHuaTxt: {
    bg1Title: "https://static.lespark.cn/pc_img/images/baihua/title-tw.png",
    award: ["￥", "2", "0", "0", "0", "W"],
    bg1Tips: "短視頻創作收益獎勵",
    bg1Tips2: "加入“百花計劃”發布原創優質視頻，享創作收益",
    rule: "規則說明",
    bg2Title: "LesPark全球最大的多元女性視頻平臺",
    bg2Tips: ["超多", "流量", "豐厚", "收益", "等妳拿"],
    bg2Img: "https://static.lespark.cn/pc_img/images/baihua/bg2Img-cn.png",
    bg2Tips2: "現金獎勵",
    bg2Tips3: "*成功加入”百花計劃“產生有效播放量，即可獲得超高收益",
    bg3Title: "LesPark誠邀每壹位創作者加入百花計劃",
    bg3Tips: ["讓每個", "獨壹無二的妳", "都被看見"],
    bg3Img: "https://static.lespark.cn/pc_img/images/baihua/tequan-tw.png",
    bg3Tips2: "以上僅為部分規劃，詳情請查看完整",
    bg3Tips3: "加入“百花計劃”前，請妳仔細閱讀活動規則及相關條款",
    bg3Tips4: "凡加入本計劃，則視為妳已閱讀，理解並同意規則全部內容",
    tqSvga: "https://static.lespark.cn/pc_img/images/baihua/tequan-tw.svga",
    titleSvga: "https://static.lespark.cn/pc_img/images/baihua/title-tw.svga"
  },
  photowall: {
    title: "全球多元女性社交",
    LaunchedYears: "上線7年+",
    millionsWomen: "2000\u842C+<br/>\u5973\u6027\u7528\u6236",
    content1: "\u670D\u52D9\u5168\u7403",
    content2: "\u5343\u842C\u540D\u591A\u5143\u5973\u6027",
    content3: "\u64AE\u540810000+<br/>\u5C0D\u60C5\u4FB6",
    content4: "1000\u591A\u500B<br/>\u4EA4\u53CB\u623F"
  },
  liveAll: {
    content1: "熱門直播",
    content2: "全部直播"
  },
  topicAll: {
    content1: "熱門話題",
    content2: "全部話題",
    join: "人參與"
  },
  headerOptions: [{
    value: "anchor",
    label: "主播管理",
    children: [{
      value: "pc",
      label: "開始PC直播"
    },
    // {
    //   value: 'backend',
    //   label: '主播管理後臺',
    // },
    {
      value: "invite",
      label: "優質直播招募"
    }, {
      value: "sign",
      label: "簽約信息錄入"
      // {
      //   value: 'withdraw',
      //   label: '提現',
      // },
    }]
  }, {
    value: "union",
    label: "公會",
    children: [{
      value: "Trade",
      label: "公會入駐"
    }, {
      value: "management",
      label: "公會管理"
    }]
  }],
  lesApp: {
    content1: "LesPark - 認識超過 2000 萬 多元女性",
    content2: "條評論",
    content3: "千萬女性記錄和分享生活的社交平臺，通過直播、語音聊天輕松表達真實自我，每天產生數十萬條原創新鮮視頻、語音、文字、圖片，分享發現真實有趣的世界，讓妳享受輕松交友的社交體驗。",
    content4: "LesPark的使命：鏈接全球少數人群，讓世界更寬容、更快樂",
    content5: "實時直播",
    content6: "這裏有陪伴妳的高顏值主播，陪妳聊天、唱歌，連接真實的妳和精彩的世界",
    content7: "多人視頻",
    content8: "紅娘在線，多人連線模式，讓妳孤獨的尋覓變成妳們姻緣的相遇",
    content9: "附近的人",
    content10: "精準的地理位置翻看附近優秀的多元女性，讓妳壹鍵GET身邊的她",
    content11: "視頻匹配",
    content12: "壹對壹視頻匹配聊天，真人視頻，拒絕偽裝，面對面零距離熱聊，瞬間了解彼此",
    content13: "情侶公園",
    content14: "多元女性情侶專屬空間，記錄每個相愛瞬間；完成情侶清單和每日打卡任務，獲得積分兌換精美禮品",
    content15: "語音派對",
    content16: "實時在線語音派對，跟眾多小姐姐壹起連麥聊天、唱歌、相親約會、玩遊戲，帶妳1秒終結孤單",
    content17: "即時語聊",
    content18: "10秒匹配遠方的她，與陌生人暢所欲言，結識新朋友，講故事，道晚安，發現好聽的聲音，讓聲音治愈妳",
    content19: "快速配對",
    content20: "交友脫單，單身待解救者，根據妳的喜好位置設置快速匹配興趣相投的她",
    content21: "用戶點評",
    content22: "來自29820位用戶評分",
    content23: "常見問題",
    content24: "App內會有男性用戶嗎？",
    content25: "不會，我們有審核客服運營團隊7*24小時在線嚴格審核，謝絕男性用戶進入，壹經發現將作封禁處理。",
    content26: "為什麽使用LesPark？",
    content27: "LesPark 作為專屬多元女性社交的應用程序，為女性創造壹個安全的空間，目標是提供壹個平臺來建立友善關系並進行對話，而沒有欺淩、偏見和社會風險。",
    content28: "LesPark收費嗎？",
    content29: "LesPark是免費的社交應用，可以在 App Store 和 安卓應用商店下載",
    content30: "LesPark會不會透露我的信息？",
    content31: "LesPark不會以任何形式向第三方透露用戶信息，以確保大家的隱私安全。",
    commentList: [{
      time: "2021-06-28",
      name: "珍惜",
      content: "在LesPark找到了現在的女朋友是我最幸運的事，壹直沒在軟件裏面發過動態，都是默默看別人，緣分就是那麽其妙吧，她還是把我找到了，果然還是要主動才行哈哈，祝願大家都找到屬於自己的幸福。"
    }, {
      time: "2021-08-01",
      name: "花開",
      content: "因為這個圈子很小，顯示生活中是深櫃又不能標明自己的取向去大膽的找對象，用了這個軟件之後才發現自己的身邊有蠻多這樣的唉，還有附近的社群可以找到壹個跟妳壹個圈子的大家庭，感覺有了屬於自己的交際圈，很開心~"
    }, {
      time: "2021-08-01",
      name: "Zhang",
      content: "軟件界面挺好看的，用來用去還是這個最靠譜，喜歡動態配對功能，好好玩，好多漂亮的小姐姐，因為裏面大家都是多元女性， 不必擔心別人異樣的眼光。良心軟件，加油挺好的贊。"
    }, {
      time: "2021-08-13",
      name: "Christian",
      content: "這裏可以不用在意異樣的眼光，可以無限做自己，找到自己愛的人，找到相投的人做朋友，隨著軟件的壹步步更新，用戶體驗越來越好，內容也越來越豐富。~"
    }, {
      time: "2021-09-01",
      name: "怡婷",
      content: "作為壹個多元女性以前感到很寂寞沒有人理解，現在有了朋友和社區真好，已經認識不少新朋友，發現大家顏值都好高呀，支持加油贊贊。"
    }]
  },
  aboutUs: {
    content1: "LesPark \u70BA\u6E05\u9060\u5E02\u5E15\u514B\u6587\u5316\u50B3\u5A92\u6709\u9650\u516C\u53F8\u65D7\u4E0B\u7814\u767C\u7684\u58F9\u6B3E\u70BA\u5168\u7403\u5973\u6027\u63D0\u4F9B\u4EA4\u53CB\u6E20\u9053\u7684\u79FB\u52D5\u793E\u4EA4\u8EDF\u4EF6\u3002\u4E0D\u8AD6\u662F\u60F3\u6210\u70BAKOL\uFF0C\u5750\u64C1\u767E\u842C\u7C89\u7D72\uFF1B\u9084\u662F\u60F3\u4EA4\u670B\u53CB\u3001\u5206\u4EAB\u60C5\u611F\u3001\u6F32\u77E5\u8B58LesPark\u90FD\u6709\u5C08\u70BA\u8EAB\u70BA\u5973\u6027\u7684\u59B3\u6253\u9020\u7684\u4FBF\u5229\u5E73\u81FA\u8207\u771F\u5BE6\u793E\u5340\u3002",
    content1_1: "LesPark \u70BA\u5317\u6D77\u5E15\u514B\u4FE1\u606F\u79D1\u6280\u6709\u9650\u516C\u53F8\u65D7\u4E0B\u7814\u767C\u7684\u58F9\u6B3E\u70BA\u5168\u7403\u5973\u6027\u63D0\u4F9B\u4EA4\u53CB\u6E20\u9053\u7684\u79FB\u52D5\u793E\u4EA4\u8EDF\u4EF6\u3002\u4E0D\u8AD6\u662F\u60F3\u6210\u70BAKOL\uFF0C\u5750\u64C1\u767E\u842C\u7C89\u7D72\uFF1B\u9084\u662F\u60F3\u4EA4\u670B\u53CB\u3001\u5206\u4EAB\u60C5\u611F\u3001\u6F32\u77E5\u8B58LesPark\u90FD\u6709\u5C08\u70BA\u8EAB\u70BA\u5973\u6027\u7684\u59B3\u6253\u9020\u7684\u4FBF\u5229\u5E73\u81FA\u8207\u771F\u5BE6\u793E\u5340\u3002",
    content1_2: "LesPark \u70BA ORIENT BASIC SCIENCE AND TECHNOLOGY PTE. LTD. \u65D7\u4E0B\u7814\u767C\u7684\u58F9\u6B3E\u70BA\u5168\u7403\u5973\u6027\u63D0\u4F9B\u4EA4\u53CB\u6E20\u9053\u7684\u79FB\u52D5\u793E\u4EA4\u8EDF\u4EF6\u3002\u4E0D\u8AD6\u662F\u60F3\u6210\u70BAKOL\uFF0C\u5750\u64C1\u767E\u842C\u7C89\u7D72\uFF1B\u9084\u662F\u60F3\u4EA4\u670B\u53CB\u3001\u5206\u4EAB\u60C5\u611F\u3001\u6F32\u77E5\u8B58LesPark\u90FD\u6709\u5C08\u70BA\u8EAB\u70BA\u5973\u6027\u7684\u59B3\u6253\u9020\u7684\u4FBF\u5229\u5E73\u81FA\u8207\u771F\u5BE6\u793E\u5340\u3002",
    content2: "\u5728\u9019\u88CF\uFF0C\u59B3\u80FD\u5920\u901A\u904E\u793E\u5340\u3001\u76F4\u64AD\u5C55\u793A\u81EA\u5DF1\uFF0C\u8207\u7C89\u7D72\u96F6\u8DDD\u96E2\u5BE6\u6642\u4E92\u52D5\uFF1B\u80FD\u5920\u4F9D\u64DA\u5B9A\u4F4D\u52A0\u5165\u9644\u8FD1\u7FA4\u7D44\u53C3\u52A0\u5404\u7A2E\u6D3B\u52D5\uFF0C\u8207\u9644\u8FD1\u4EBA\u7FA4\u5EFA\u7ACB\u826F\u597D\u3001\u5065\u5EB7\u7684\u793E\u4EA4\u95DC\u7CFB\u3002",
    content3: "\u201CLive for Love\u2014\u2014\u70BA\u611B\u800C\u751F\u201D\uFF0C\u58F9\u76F4\u4EE5\u4F86\u90FD\u662FLesPark\u7684\u53E3\u865F\uFF0C\u529B\u65BC\u6253\u9020\u5973\u6027\u7FA4\u9AD4\u8A18\u9304\u548C\u5206\u4EAB\u751F\u6D3B\u7684\u5E73\u81FA\u3002",
    content4: "\u76EE\u524D\uFF0CLesPark\u5DF2\u4E0A\u7DDA\u904B\u71DF7\u5E74\uFF0C\u64C1\u6709\u5782\u76F4\u9818\u57DF\u7528\u6236\u6578\u5DF2\u7A81\u78342000\u842C\uFF0C\u5206\u5E03\u5168\u740334\u500B\u570B\u5BB6\uFF0C\u4E3B\u64AD\u6578\u91CF\u5DF2\u8D8515\u842C\u3002",
    content5: "\u4F01\u696D\u6587\u5316",
    content6: "\u4F7F\u547D",
    content7: "\u93C8\u63A5\u5168\u7403\u5C11\u6578\u4EBA\u7FA4",
    content8: "\u8B93\u4E16\u754C\u66F4\u52A0\u5BEC\u5BB9\u3001\u66F4\u5FEB\u6A02",
    content9: "\u9858\u666F",
    content10: "\u6210\u70BA\u5C11\u6578\u4EBA\u7FA4\u6700\u53EF\u4FE1\u8CF4\u7684\u5168\u7403\u5316\u516C\u53F8",
    content11: "\u5728\u4E0D\u65B7\u5730\u5275\u65B0\u4E2D\u5EFA\u7ACB\u5C11\u6578\u4EBA",
    content12: "\u7FA4\u666E\u60E0\u50F9\u503C\u7DB2\u7D61",
    content13: "\u50F9\u503C\u89C0",
    content14: "\u7528\u6236\u7B2C\u58F9\u3001\u5718\u968A\u5354\u4F5C",
    content15: "\u7D50\u679C\u5C0E\u5411\u3001\u8FFD\u6C42\u6975\u81F4",
    content16: "\u7A4D\u6975\u4E3B\u52D5\u3001\u52C7\u6562\u7121\u754F",
    content17: "\u52A0\u5165\u6211\u5011",
    content18: "\u6211\u5011\u9700\u8981\u7522\u54C1\u3001\u904B\u71DF\u3001\u6280\u8853\u7B49\u5404\u5D17\u4F4D\u4EBA\u624D\uFF0C\u671F\u5F85\u59B3\u7684\u52A0\u5165\uFF01",
    content19: "\u7ACB\u5373\u52A0\u5165",
    content20: "\u806F\u7CFB\u6211\u5011",
    content21: "\u806F\u7CFB\u4EBA",
    content22: "\u5F35\u5148\u751F",
    content23: "\u5BA2\u670D\u96FB\u8A71",
    content24: "\u806F\u7CFB\u5730\u5740",
    content25: "\u8209\u5831\u6295\u8A34",
    content26: "\u5EE3\u6771\u6E05\u9060\u5E02\u5EE3\u6E05\u5927\u9053\u516B\u5341\u516B\u865F\u96F2\u5C71\u8A69\u610F\u82B1\u5712\u96F2\u5C71\u8A69\u610F\u5927\u5EC814\u5C64\u8FA6\u516C\u5BA408\u865F",
    content26_1: "\u5EE3\u897F\u58EF\u65CF\u81EA\u6CBB\u5340\u5317\u6D77\u5E02\u56DB\u5DDD\u8DEF299\u865F\u7A57\u8C50\u91D1\u70631\u5E620401\u865F",
    content26_2: "ORIENT BASIC SCIENCE AND TECHNOLOGY PTE. LTD."
  },
  loginHome: {
    content1: "加載更多",
    content2: "粉絲",
    content3: "獲贊",
    content4: "動態"
  },
  topicItem: {
    content1: "人贊",
    content2: "查看全部",
    content3: "條評論",
    content4: "回復",
    content5: "評論...",
    content6: "發送"
  },
  baihuaRule: {
    title: "百花計劃活動規則",
    ruleSet: ["\u52A0\u5165\u77ED\u8996\u983B\u767E\u82B1\u8A08\u5283\uFF08\u4EE5\u4E0B\u7C21\u7A31\u201C\u672C\u8A08\u5283\u201D\uFF09\u524D\uFF0C\u8ACB\u7528\u6236\u8A73\u7D30\u95B1\u8B80\u6D3B\u52D5\u898F\u5247\u53CA\u76F8\u95DC\u689D\u6B3E\u3002\u51E1\u7533\u8ACB\u52A0\u5165\u767E\u82B1\u8A08\u5283\uFF0C\u5247\u8996\u70BA\u7528\u6236\u5DF2\u95B1\u8B80\u3001\u7406\u89E3\u4E26\u540C\u610F\u6D3B\u52D5\u898F\u5247\u5168\u90E8\u5167\u5BB9\u3002", "<h3 class=\"h3-label\">\u8A08\u5283\u4ECB\u7D39</h3>", "\u767E\u82B1\u8A08\u5283\u662F\u7531LesPark\u5E73\u81FA\u8209\u8FA6\u7684\u6FC0\u52F5\u77ED\u8996\u983B\u5275\u4F5C\u7684\u6D3B\u52D5\u3002\u6210\u529F\u52A0\u5165\u767E\u82B1\u8A08\u5283\u7684\u4F5C\u8005\uFF0C\u901A\u904E\u7AD9\u5167\u767C\u5E03\u7684<span>\u539F\u5275\u9AD8\u6E05\u8996\u983B\uFF08\u6642\u9577\u226510\u79D2)</span>\uFF0C\u6709\u6A5F\u6703\u4EAB\u53D7\u5275\u4F5C\u6536\u76CA\u3002", "<h3 class=\"h3-label\">\u8A08\u5283\u7684\u52A0\u5165\u65B9\u5F0F</h3>", "1.\u59B3\u53EF\u901A\u904E\u9EDE\u64CA\u8A08\u5283\u4ECB\u7D39\u9801\u9762\u7684\u201C\u7ACB\u5373\u52A0\u5165\u201D\u6309\u9215\u4E26\u5B8C\u6210\u76F8\u61C9\u7684\u7533\u8ACB\u4EFB\u52D9\uFF0C\u5373\u53EF\u7533\u8ACB\u52A0\u5165\u767E\u82B1\u8A08\u5283\u3002", "2.\u7533\u8ACB\u52A0\u5165\u767E\u82B1\u8A08\u5283\u524D\uFF0C\u9700\u8981\u5B8C\u6210\u4EE5\u4E0B\u7533\u8ACB\u4EFB\u52D9\uFF0C\u5E73\u81FA\u5C07\u6839\u64DA\u6D3B\u52D5\u898F\u5247\u5C0D\u7533\u8ACB\u8005\u7684\u8996\u983B\u5167\u5BB9\u8CEA\u91CF\u9032\u884C\u5BE9\u6838\uFF0C\u5BE9\u6838\u901A\u904E\u5F8C\u5373\u53EF\u6210\u529F\u52A0\u5165\u767E\u82B1\u8A08\u5283\u3002", "1)\u5B8C\u6210\u624B\u6A5F\u865F\u7D81\u5B9A\uFF0C\u4EE5\u53CA\u5BE6\u540D\u8A8D\u8B49<br/>\n2)\u8FD130\u5929\u5167\uFF0C\u901A\u904ELesPark App\u767C\u5E03\u904E\u5927\u65BC\u7B49\u65BC5\u7BC7\u516C\u958B\u53EF\u898B\u7684\u3001\u539F\u5275\u9AD8\u6E05\u8996\u983B\uFF08\u6E05\u6670\u5EA6\u2265720P\uFF09\u3001\u6642\u9577\u226510\u79D2<br/>\n3)\u8FD130\u5929\u5167\uFF0C\u901A\u904ELesPark App\u767C\u5E03\u7684\u6240\u6709\u516C\u958B\u53EF\u898B\u7684\u3001\u539F\u5275\u9AD8\u6E05\u8996\u983B\uFF08\u6642\u9577\u226510\u79D2)\u7684\u7E3D\u64AD\u653E\u91CF\u9054\u523060000\n", "3.\u7576\u59B3\u5B8C\u6210\u7533\u8ACB\u4EFB\u52D9\u6642\uFF0C\u53EF\u9EDE\u64CA\u6309\u9215\uFF0C\u63D0\u4EA4\u5BE9\u6838\u3002\u5B98\u65B9\u5DE5\u4F5C\u4EBA\u54E1\u5C07\u6839\u64DA\u8CEC\u865F\u767C\u5E03\u7684\u539F\u5275\u9AD8\u6E05\u8996\u983B\uFF08\u6642\u9577\u226510\u79D2) \u4EE5\u53CA\u5167\u5BB9\u8CEA\u91CF\u6A19\u6E96\uFF08\u8A73\u898B\u898F\u5247\uFF1A<a href=\"/baihuaQualityReview.html\">\u5167\u5BB9\u8CEA\u91CF\u5BE9\u6838</a>\uFF09\u7B49\u8981\u6C42\uFF0C\u4F86\u78BA\u5B9A\u59B3\u662F\u5426\u53EF\u4EE5\u52A0\u5165\u672C\u8A08\u5283\u3002\u5BE9\u6838\u7D50\u679C\u5C07\u901A\u904E\u8A08\u5283\u4ECB\u7D39\u9801\u9762\u548C\u6D88\u606F\u901A\u77E5\u516C\u5E03\u3002", "1)\u5982\u679C\u7531\u65BC\u4E0D\u7B26\u5408\u5167\u5BB9\u8CEA\u91CF\u6A19\u6E96\u7B49\u539F\u56E0\u672A\u5BE9\u6838\u901A\u904E\uFF0C\u59B3\u53EF\u4EE5\u6839\u64DA\u76F8\u61C9\u7684\u63D0\u793A\u539F\u56E0\u6216\u8005\u5EFA\u8B70\uFF0C\u9032\u884C\u8ABF\u6574\uFF0C\u6216\u8005\u5617\u8A66\u518D\u6B21\u767C\u5E03\u81F3\u5C115\u7BC7\u539F\u5275\u9AD8\u6E05\u8996\u983B\uFF08\u6642\u9577\u226510\u79D2)\uFF0C\u8ABF\u6574\u5B8C\u6210\u5F8C\u53EF\u518D\u6B21\u63D0\u4EA4\u5BE9\u6838\u7533\u8ACB\u3002\n      2)\u5E73\u81FA\u512A\u5148\u9F13\u52F5\u81EA\u4E3B\u62CD\u651D\u53CA\u5275\u4F5C\u7684\u5275\u4F5C\u8005\u52A0\u5165\u672C\u8A08\u5283\u3002\n      3)\u7576\u524D\u8CEC\u865F\u70BA\u8A3B\u92B7\u3001\u522A\u9664\u3001\u5C01\u7981\u7B49\u7570\u5E38\u72C0\u614B\u6642\uFF0C\u7121\u6CD5\u52A0\u5165\u767E\u82B1\u8A08\u5283\u3002\n      4)\u5275\u4F5C\u7684\u8996\u983B\u9700\u6EFF\u8DB3\u5E73\u81FA\u539F\u5275\u6A19\u6E96\uFF08\u8A73\u898B\u898F\u5247\uFF1A<a href=\"/baihuaOriginalStandards.html\">\u539F\u5275\u6A19\u6E96</a>\uFF09\uFF0C\u4E0D\u5B58\u5728\u8272\u60C5\u3001\u4F4E\u4FD7\u3001\u756B\u9762\u4E0D\u6E05\u6670\u3001\u5237\u7C89\u5237\u64AD\u653E\u91CF\u7B49\u4E0D\u826F\u554F\u984C\u3002\u4E0D\u6D89\u53CA\u672A\u6210\u5E74\u3001\u5EE3\u544A\u71DF\u92B7\u3001\u9ED1\u7522\u6559\u5B78\u3001\u8A00\u8AD6\u653B\u64CA\u3001\u7121\u8CC7\u8CEA\u8B1B\u89E3\u8CA1\u7D93\u7B49\u8CA0\u9762\u5C0E\u5411\u554F\u984C\u3002\u540C\u6642\u8A3B\u610F\uFF0C\u82E5\u8CEC\u865F\u4E2D\u5927\u91CF\u90FD\u662F\u7121\u610F\u7FA9\u96A8\u62CD\u6216\u57FA\u65BC\u58F9\u5B9A\u7D20\u6750\u7C21\u6613\u52A0\u5DE5\uFF0C\u5275\u4F5C\u7A0B\u5EA6\u8F03\u4F4E\u7684\u8996\u983B\uFF0C\u4E5F\u7121\u6CD5\u52A0\u5165\u767E\u82B1\u8A08\u5283\u3002\n      ", "<h3 class=\"h3-label\">\u8A08\u5283\u6536\u76CA</h3>", "1.\u8996\u983B\u5275\u4F5C\u6536\u76CA<br/>\n        \u6210\u529F\u52A0\u5165\u8A08\u5283\u5F8C\uFF0C\u901A\u904ELesPark App\u767C\u5E03\u7684\u539F\u5275\u9AD8\u6E05\u8996\u983B\uFF08\u6642\u9577\u226510\u79D2)\uFF0C\u82E5\u64AD\u653E\u91CF\u9054\u52302w\u3001\u901A\u904E\u5167\u5BB9\u8CEA\u91CF\u5BE9\u6838\u3001\u8996\u983B\u4F5C\u54C1\u8655\u65BC\u201C\u6536\u76CA\u4E2D\u201D\u72C0\u614B\u4E0B\uFF0C\u8A72\u4F5C\u54C1\u7684\u6536\u76CA\u64AD\u653E\u91CF\u5747\u53EF\u7372\u5F97\u5275\u4F5C\u6536\u76CA\u3002\u8A3B\u610F\uFF1A\u55AE\u500B\u8996\u983B\u4F5C\u54C1\u7684\u6536\u76CA\u671F\u70BA\u767C\u5E03\u4E26\u901A\u904E\u5BE9\u6838\u5F8C\u768490\u5929\u5167\uFF0C\u8D85\u904E90\u5929\u6703\u88AB\u8A2D\u7F6E\u70BA\u201C\u6536\u76CA\u904E\u671F\u201D\uFF1B\u82E5\u8996\u983B\u4F5C\u54C1\u672A\u901A\u904E\u5BE9\u6838\uFF0C\u5247\u6703\u88AB\u8A2D\u7F6E\u70BA\u201C\u5BE9\u6838\u5931\u6557\u201D\uFF1B\u901A\u904E\u5BE9\u6838\uFF0C\u4E14\u672A\u8D85\u904E90\u5929\u5468\u671F\u5167\uFF0C\u5247\u6703\u88AB\u8A2D\u7F6E\u70BA\u201C\u6536\u76CA\u4E2D\u201D\u72C0\u614B\u3002\n        2.\u6536\u76CA\u67E5\u770B\u8207\u63D0\u73FE<br/>\n        1)\u52A0\u5165\u767E\u82B1\u8A08\u5283\u5F8C\u7372\u5F97\u7684\u6536\u76CA\u53EF\u5728LesPark App\u2014\u2014\u6211\u7684\u2014\u2014\u5074\u908A\u6B04\u2014\u2014\u5275\u4F5C\u8005\u4E2D\u5FC3\uFF0C\u67E5\u770B\u76F8\u95DC\u6536\u76CA\uFF0C\u4E5F\u53EF\u5728LesPark App\u2014\u2014\u6211\u7684\u2014\u2014\u5074\u908A\u6B04\u2014\u2014\u9246\u77F3\u9322\u5305\uFF0C\u9032\u884C\u67E5\u770B\u3002<br/>\n        2)\u6536\u76CA\u7684\u63D0\u73FE\uFF0C\u6BCF\u5929\u6700\u591A\u7533\u8ACB1\u6B21\uFF0C\u53EF\u4F9D\u64DA\u53EF\u63D0\u984D\u5EA6\uFF0C\u9078\u64C7\u5C0D\u61C9\u6A94\u4F4D\u91D1\u984D\u8207\u5E73\u81FA\uFF0C\u63D0\u4EA4\u63D0\u73FE\u7533\u8ACB\uFF0C\u63D0\u73FE\u5BE9\u6838\u901A\u904E\u5F8C\uFF0C\u6703\u9032\u884C\u76F8\u61C9\u6253\u6B3E\u64CD\u4F5C\u3002\n        ", "<h3 class=\"h3-label\">\u8A08\u5283\u9055\u898F\u8AAA\u660E</h3>", "1.LesPark\u5B98\u65B9\u6709\u6B0A\u5C0D\u53C3\u8207\u672C\u6D3B\u52D5\u7684\u7528\u6236\u9032\u884C\u5B89\u5168\u9A57\u8B49<br/>\n\u5982\u53C3\u8207\u672C\u6D3B\u52D5\u7684\u7528\u6236\u66FE\u7D93\u5B58\u5728\u3001\u51FA\u73FE\u6216\u7D93LesPark\u5B98\u65B9\u5408\u7406\u61F7\u7591\u5B58\u5728\u9055\u53CD\u6CD5\u5F8B\u6CD5\u898F\u6216LesPark\u5E73\u81FA\u898F\u5247\u3001\u9055\u80CC\u8AA0\u5BE6\u4FE1\u7528\u539F\u5247\u7684\u884C\u70BA\uFF0CLesPark\u5B98\u65B9\u6709\u6B0A\u91C7\u53D6\u5305\u62EC\u4F46\u4E0D\u9650\u65BC\u9650\u5236\u8A3B\u518A/\u767B\u9304LesPark App\u3001\u7981\u6B62\u53C3\u8207\u672C\u6D3B\u52D5\u3001\u64A4\u92B7\u6D3B\u52D5\u53C3\u8207\u8CC7\u683C\u3001\u53D6\u6D88\u6216\u51CD\u7D50\u7372\u5F97\u6D3B\u52D5\u6536\u76CA(\u5305\u62EC\u4F46\u4E0D\u9650\u65BC\u901A\u904E\u53C3\u8207\u6D3B\u52D5\u53EF\u80FD\u6703\u7372\u5F97\u7684\u865B\u64EC\u7269\u54C1\u3001\u73FE\u91D1\u3001\u5BE6\u7269\u7B49\u6536\u76CA)\u7684\u8CC7\u683C\u3001\u7121\u6CD5\u7372\u53D6\u6216\u50C5\u53EF\u7372\u53D6\u90E8\u5206\u6D3B\u52D5\u6536\u76CA\u3001\u5DF2\u7372\u53D6\u7684\u6D3B\u52D5\u6536\u76CA\u4F7F\u7528/\u63D0\u73FE\u53D7\u5230\u5168\u90E8/\u90E8\u5206\u9650\u5236\u3001\u6536\u56DE\u5DF2\u767C\u653E\u7684\u6D3B\u52D5\u6536\u76CA\u3001\u5C01\u7981\u5E33\u865F\u7B49\u8655\u7F6E\u63AA\u65BD\uFF0C\u540C\u6642\u4FDD\u7559\u8FFD\u7A76\u8A72\u7528\u6236\u76F8\u95DC\u6CD5\u5F8B\u8CAC\u4EFB\u7684\u6B0A\u5229\u3002\n\u9055\u80CC\u8AA0\u5BE6\u4FE1\u7528\u539F\u5247\u7684\u884C\u70BA\u5305\u62EC\u4F46\u4E0D\u9650\u65BC\uFF1A<br/>\n1)\u4E0B\u8F09\u975E\u5B98\u65B9\u5BA2\u6236\u7AEF\uFF1B<br/>\n2)\u4F7F\u7528\u9AD8\u5371\u4F5C\u5F0A\u5ACC\u7591\u7684\u624B\u6A5F\u865F\u3001\u865B\u64EC\u624B\u6A5F\u865F\u3001QQ\u3001\u5FAE\u4FE1\u865F\u7B49\u7B2C\u4E09\u65B9\u5E73\u81FA\u5E33\u865F\u8A3B\u518A/\u767B\u9304LesPark App\uFF1B<br/>\n3)\u4FEE\u6539\u9801\u9762\u53C3\u6578\u3001\u7BE1\u6539\u8A2D\u5099\u6578\u64DA\uFF1B<br/>\n4)\u4EE5\u4EFB\u4F55\u6A5F\u5668\u4EBA\u8EDF\u4EF6\u3001\u8718\u86DB\u8EDF\u4EF6\u3001\u722C\u87F2\u8EDF\u4EF6\u3001\u5237\u5C4F\u8EDF\u4EF6\u6216\u4EFB\u4F55\u975E\u4EBA\u5DE5\u65B9\u5F0F\u53C3\u8207\u6D3B\u52D5\uFF1B<br/>\n5)\u4F7F\u7528\u6A21\u64EC\u5668\u3001\u63D2\u4EF6\u3001\u5916\u639B\u3001App\u5206\u8EAB\u8EDF\u4EF6\u7B49\u975E\u6CD5\u5DE5\u5177\u6383\u78BC\u3001\u4E0B\u8F09\u3001\u5B89\u88DD\u3001\u8A3B\u518A\u3001\u767B\u9304LesPark\u5BA2\u6236\u7AEF\u3001\u53C3\u8207\u6D3B\u52D5\u3001\u9818\u53D6\u6D3B\u52D5\u6536\u76CA\u3001\u63D0\u73FE\u3001\u9032\u884C\u6D3B\u52D5\u6536\u76CA\u8D08\u8207\uFF1B<br/>\n6)\u901A\u904E\u60E1\u610F\u725F\u5229\u624B\u6BB5\u64FE\u4E82\u5E73\u81FA\u79E9\u5E8F\uFF1B<br/>\n7)\u4F7F\u7528\u63D2\u4EF6\u3001\u5916\u639B\u3001\u7FA4\u63A7\u7CFB\u7D71\u6216\u7B2C\u4E09\u65B9\u5DE5\u5177\u5C0DLesPark\u5E73\u81FA\u53CA\u672C\u6D3B\u52D5\u9032\u884C\u5E79\u64FE\u3001\u7834\u58DE\u3001\u4FEE\u6539\u6216\u65BD\u52A0\u5176\u4ED6\u5F71\u97FF\uFF1B<br/>\n8)\u8207\u5176\u4ED6\u7528\u6236\u4E32\u901A\u6216\u5229\u7528\u6A5F\u5668\u7B49\u65B9\u5F0F\u9032\u884C\u4F5C\u5F0A\u3001\u5237\u53D6\u6D3B\u52D5\u6536\u76CA\u7B49\u64FE\u4E82\u6D3B\u52D5\u79E9\u5E8F\u7684\u884C\u70BA\uFF1B<br/>\n9)\u5176\u4ED6LesPark\u5E73\u81FA\u6709\u5408\u7406\u7406\u7531\u61F7\u7591\u7684\u9055\u80CC\u8AA0\u5BE6\u4FE1\u7528\u539F\u5247\u7684\u884C\u70BA\u3002<br/>\n<br/>\n2.\u7528\u6236\u5728\u53C3\u52A0\u672C\u7CFB\u5217\u6D3B\u52D5\u904E\u7A0B\u4E2D\uFF0C\u5982\u5B58\u5728\u4EE5\u6240\u7372\u5F97\u7684\u6D3B\u52D5\u734E\u52F5\u9032\u884C\u4EFB\u4F55\u76C8\u5229\u6216\u975E\u6CD5\u7372\u5229\u3001\u4EE5\u4EFB\u4F55\u5F62\u5F0F\u8F49\u8B93\u6216\u8F49\u79FB\u5176\u901A\u904E\u6D3B\u52D5\u6240\u7372\u5F97\u7684\u734E\u52F5\uFF0C\u6216LesPark\u5B98\u65B9\u6709\u5408\u7406\u7406\u7531\u61F7\u7591\u7528\u6236\u5B58\u5728\u4E0D\u6B63\u7576\u4F7F\u7528\u6D3B\u52D5\u734E\u52F5\uFF0C\u64FE\u4E82LesPark\u5E73\u81FA\u79E9\u5E8F\u7684\uFF0CLesPark\u5B98\u65B9\u6709\u6B0A\u53D6\u6D88\u7528\u6236\u7684\u6D3B\u52D5\u53C3\u8207\u8CC7\u683C\u3001\u6536\u56DE\u5DF2\u767C\u653E\u7684\u6D3B\u52D5\u734E\u52F5(\u542B\u5DF2\u4F7F\u7528\u53CA\u672A\u4F7F\u7528\u7684) \u540C\u6642\u4FDD\u7559\u8FFD\u7A76\u8A72\u7528\u6236\u76F8\u95DC\u6CD5\u5F8B\u8CAC\u4EFB\u7684\u6B0A\u5229\u3002\n<br/><br/>\n3.LesPark\u5B98\u65B9\u7279\u5225\u63D0\u793A\u60A8\uFF0C\u8ACB\u60A8\u52D9\u5FC5\u901A\u904ELesPark\u5B98\u65B9\u53CALesPark\u5B98\u65B9\u6307\u5B9A\u8DEF\u5F91\u53C3\u8207\u672C\u7CFB\u5217\u6D3B\u52D5\uFF0C\u56E0\u7528\u6236\u53C3\u8207\u4EFB\u4F55\u975ELesPark\u5B98\u65B9\u6D3B\u52D5\u6216\u5192\u7528LesPark\u540D\u7FA9\u958B\u5C55\u7684\u6D3B\u52D5\uFF0C\u9020\u6210\u7528\u6236\u640D\u5931\u7684\uFF0CLesPark\u5C0D\u6B64\u4E0D\u627F\u64D4\u4EFB\u4F55\u6CD5\u5F8B\u8CAC\u4EFB\u3002\n", "<h3 class=\"h3-label\">\u8A3B\u610F\u4E8B\u9805</h3>", "1.\u6309\u7167\u76F8\u95DC\u6CD5\u5F8B\u898F\u5B9A\uFF0C\u4E3B\u8FA6\u65B9\u9700\u5C31\u7372\u734E\u8005\u5728\u672C\u6D3B\u52D5\u4E0B\u6240\u5F97\u9032\u884C\u4EE3\u6263\u4EE3\u7E73\u500B\u4EBA\u6240\u5F97\u7A05\u7684\uFF0C\u4E3B\u8FA6\u65B9\u6709\u6B0A\u4F9D\u6CD5\u4EE3\u6263\u4EE3\u7E73\u3002\u672A\u7D93\u4E3B\u8FA6\u65B9\u4E8B\u5148\u66F8\u9762\u8A31\u53EF\uFF0C\u7528\u6236\u56E0\u53C3\u52A0\u672C\u6D3B\u52D5\u6240\u53D6\u5F97\u7684\u6B0A\u5229\u6216\u7372\u5F97\u7684\u734E\u52F5\u5747\u4E0D\u5F97\u8F49\u8B93\u3002<br/>\n2.\u7528\u6236\u4E0D\u5F97\u4EE5\u4EFB\u4F55\u4E0D\u6B63\u7576\u624B\u6BB5\u6216\u821E\u5F0A\u65B9\u5F0F\u53C3\u8207\u672C\u6D3B\u52D5\u6216\u5229\u7528\u672C\u6D3B\u52D5\u5F9E\u4E8B\u9055\u6CD5\u884C\u70BA\u3002\u58F9\u7D93\u767C\u73FE\uFF0C\u4E3B\u8FA6\u65B9\u6709\u6B0A\u91C7\u53D6\u964D\u4F4E\u6D3B\u52D5\u734E\u52F5\u3001\u9650\u5236\u63D0\u73FE\u3001\u8CEC\u865F\u91D1\u984D\u6E05\u96F6\u3001\u64A4\u6D88\u6D3B\u52D5\u8CC7\u683C\u3001\u9650\u5236\u767B\u9304\u3001\u5C01\u7981\u8CEC\u865F\u3001\u9650\u5236\u518D\u6B21\u8A3B\u518A\u4F7F\u7528\u7B49\u63AA\u65BD\uFF0C\u4EA6\u6709\u6B0A\u6536\u56DE\u7528\u6236\u5DF2\u9818\u53D6\u7684\u734E\u52F5\u3001\u8FFD\u8A0E\u5DF2\u63D0\u73FE\u7684\u91D1\u984D\uFF0C\u4E26\u4FDD\u7559\u8FFD\u7A76\u8A72\u7528\u6236\u8CAC\u4EFB\u7684\u6B0A\u5229\u3002<br/>\n3.\u4E3B\u8FA6\u65B9\u4F9D\u6CD5\u904B\u71DF\u6B64\u6B21\u6D3B\u52D5\uFF0C\u5982\u56E0\u4E0D\u53EF\u6297\u529B\u3001\u60C5\u52E2\u8B8A\u66F4\u3001\u76F8\u95DC\u653F\u7B56\u8B8A\u52D5\u3001\u653F\u5E9C\u6A5F\u95DC\u6307\u4EE4\u8981\u6C42\u3001\u6D3B\u52D5\u53C3\u8207\u4EBA\u6578\u4E0D\u8DB3\u3001\u7B2C\u4E09\u65B9\u539F\u56E0\u7B49\u975E\u4E3B\u8FA6\u65B9\u539F\u56E0\u5C0E\u81F4\u672C\u6B21\u6D3B\u52D5\u8ABF\u6574\u3001\u66AB\u505C\u8209\u8FA6\u3001\u7121\u6CD5\u9032\u884C\u3001\u7528\u6236\u53C3\u8207\u5931\u6557\u7684\uFF0C\u4E3B\u8FA6\u65B9\u6709\u6B0A\u96A8\u6642\u6C7A\u5B9A\u4FEE\u6539\u3001\u66AB\u505C\u3001\u53D6\u6D88\u6216\u7D42\u6B62\u672C\u6D3B\u52D5\uFF0C\u4E26\u7121\u9700\u70BA\u6B64\u627F\u64D4\u4EFB\u4F55\u6CD5\u5F8B\u8CAC\u4EFB\u3002\u7528\u6236\u81EA\u8EAB\u539F\u56E0\u5C0E\u81F4\u53C3\u8207\u5931\u6557\u7684\uFF0C\u4E0D\u5229\u5F8C\u679C\u7531\u7528\u6236\u81EA\u884C\u627F\u64D4\u3002\u7528\u6236\u53EF\u5728\u672C\u9801\u9762\u96A8\u6642\u67E5\u770B\u4FEE\u6539\u5F8C\u7684\u6D3B\u52D5\u898F\u5247\uFF0C\u82E5\u7528\u6236\u5C0D\u4FEE\u6539\u5F8C\u7684\u6D3B\u52D5\u898F\u5247\u6709\u7570\u8B70\u7684\uFF0C\u8ACB\u505C\u6B62\u7E7C\u7E8C\u53C3\u8207\uFF0C\u82E5\u7528\u6236\u7E7C\u7E8C\u53C3\u52A0\u672C\u6D3B\u52D5\uFF0C\u5247\u8996\u70BA\u7528\u6236\u540C\u610F\u672C\u6D3B\u52D5\u898F\u5247\u7684\u4FEE\u6539\u3002<br/>\n4.\u300ALesPark\u4F7F\u7528\u689D\u6B3E\u300B\u3001\u300ALesPark\u96B1\u79C1\u653F\u7B56\u300B\u540C\u6A23\u9069\u7528\u65BC\u672C\u6B21\u6D3B\u52D5\uFF0C\u672C\u6B21\u6D3B\u52D5\u898F\u5247\u53CA\u76F8\u95DC\u689D\u6B3E\u8207\u300ALesPark\u4F7F\u7528\u689D\u6B3E\u300B\u3001\u300ALesPark\u96B1\u79C1\u653F\u7B56\u300B\u76F8\u6C96\u7A81\u7684\uFF0C\u4EE5\u672C\u6B21\u6D3B\u52D5\u898F\u5247\u53CA\u76F8\u95DC\u689D\u6B3E\u70BA\u6E96\u3002\u672C\u6B21\u6D3B\u52D5\u898F\u5247\u53CA\u76F8\u95DC\u689D\u6B3E\u672A\u7D04\u5B9A\u7684\u5167\u5BB9\uFF0C\u4ECD\u4EE5\u300ALesPark\u4F7F\u7528\u689D\u6B3E\u300B\u3001\u300ALesPark\u96B1\u79C1\u653F\u7B56\u300B\u70BA\u6E96\u3002<br/>\n5.\u5982\u679C\u59B3\u5728\u6D3B\u52D5\u4E2D\u9047\u5230\u4EFB\u4F55\u554F\u984C\uFF0C\u53EF\u4EE5\u6253\u958B LesPark App\uFF0C\u901A\u904E\u4EBA\u5DE5\u5BA2\u670D\u6216\u8005\u806F\u7CFB\u5FAE\u4FE1\u5B98\u65B9\u865F\u7B49\u6E20\u9053\uFF0C\u9032\u884C\u54A8\u8A62\u3002<br/>\n6.\u672C\u6D3B\u52D5\u8207Apple Inc.\u7121\u95DC<br/>\n"]
  },
  baihuaOriginalStandards: {
    title: "百花計劃 原創標準說明",
    ruleSet: ["<div class=\"h3-label\">\u539F\u5275\u4F5C\u54C1\u5B9A\u7FA9</div>", "1.\u5BE6\u62CD\u985E\uFF1A\u500B\u4EBA\u6216\u5718\u968A\u89AA\u81EA\u7368\u7ACB\u5275\u4F5C\u7684\u8996\u983B\uFF0C\u4E26\u64C1\u6709\u4F5C\u54C1\u5167\u6240\u6709\u5167\u5BB9\u7684\u76F8\u95DC\u7248\u6B0A<br/>\n(1)\u8996\u983B\u5167\u5BB9\u756B\u9762\u5E79\u51C8\u6574\u6F54\uFF0C\u4E3B\u984C\u660E\u78BA\u3001\u5167\u5BB9\u5B8C\u6574\u6709\u8A18\u61B6\u9EDE\uFF0C\u8CEC\u865F\u5167\u5BB9\u98A8\u683C\u7D71\u58F9\uFF1B<br/>\n(2)\u771F\u4EBA\u51FA\u93E1\u985E\u8996\u983B\uFF0C\u9700\u6709\u660E\u78BA\u7684\u4EBA\u8A2D\u5C6C\u6027\uFF0C\u51FA\u93E1\u4EBA\u8207\u8CEC\u865F\u5BE6\u540D\u8A8D\u8B49\u4FE1\u606F\u9700\u4FDD\u6301\u58F9\u81F4\uFF1B<br/>\n(3)\u975E\u771F\u4EBA\u51FA\u93E1\u7684\u8996\u983B\uFF0C\u9700\u6709\u660E\u78BA\u7684\u4E3B\u984C\u5B9A\u4F4D\uFF0C\u53EF\u6839\u64DA\u4F5C\u54C1\u7684\u5782\u985E\u3001\u98A8\u683C\u3001\u8CEC\u865F\u7279\u5F81\u3001\u4F5C\u8005\u63D0\u4F9B\u7684\u6750\u6599\u7B49\u5224\u65B7\u8CEC\u865F\u4E0B\u5167\u5BB9\u5C6C\u65BC\u7576\u524D\u8CEC\u865F\u5275\u4F5C\uFF1B\n", "2.\u4E8C\u6B21\u526A\u8F2F\u5275\u4F5C\u985E\u4F5C\u54C1<br/>\n(1)\u5728\u9069\u5EA6\u5F15\u7528\u539F\u8996\u983B\u7D20\u6750\u57FA\u790E\u4E0A\uFF0C\u4E8C\u6B21\u5275\u4F5C\u6210\u70BA\u58F9\u500B\u8C50\u5BCC\u3001\u6709\u4FE1\u606F\u91CF\u3001\u6709\u81EA\u5DF1\u7DE8\u8F2F\u601D\u8DEF\u3001\u6709\u7368\u5275\u6027\u7684\u65B0\u8996\u983B\u4F5C\u54C1\uFF1B<br/>\n(2)\u4E8C\u6B21\u5275\u4F5C\u5F62\u5F0F\u5305\u62EC\u4F46\u4E0D\u9650\u65BC\u9AD4\u73FE\u81EA\u5DF1\u60F3\u6CD5\u548C\u601D\u8003\u7684\u89E3\u8AAA\u9EDE\u8A55\u3001\u526A\u8F2F\u5236\u4F5C\u3001\u7279\u6548\u5305\u88DD\u3001\u97F3\u983B\u8655\u7406\u7B49\uFF1B\n", "3.\u4EE5\u4E0B\u985E\u578B\u4E0D\u5C6C\u65BC\u539F\u5275\u4F5C\u54C1<br/>\n(1)\u4E0A\u50B3\u8207\u4ED6\u4EBA\u76F8\u4F3C\u7684\u4F5C\u54C1\uFF1A<br/>\n\u25CF \u76F4\u63A5\u642C\u904B\u3001\u9304\u5C4F\u3001\u5C4F\u62CD\u4ED6\u4EBA\u4F5C\u54C1\u4E0A\u50B3\u767C\u5E03\uFF1B<br/>\n\u25CF \u5728\u672A\u7372\u5F97\u7248\u6B0A\u65B9\u6388\u6B0A\u6216\u7121\u7248\u6B0A\u7684\u60C5\u6CC1\u4E0B\uFF0C\u767C\u5E03\uFF08\u6216\u76F4\u63A5\u4E0A\u50B3\uFF09\u5F71\u8996\u5287\u3001\u7D9C\u85DD\u3001\u52D5\u6F2B\u3001\u97F3\u6A02MV\u3001\u65B0\u805E\u3001\u904A\u6232\u9AD4\u80B2\u8CFD\u4E8B\u7B49\u7248\u6B0A\u5167\u5BB9<br/>\n\u25CF \u7D14\u9304\u5C4F\u985E\u5167\u5BB9\uFF0C\u5C0D\u5275\u4F5C\u4EBA\u6C92\u6709\u53C3\u8207\u651D\u50CF\u3001\u9304\u5236\u3001\u52A0\u5DE5\u7684\u4F5C\u54C1\u9032\u884C\u9304\u64AD", "(2)\u4E8C\u6B21\u5275\u4F5C\u7A0B\u5EA6\u4E0D\u9AD8\u7684\u5167\u5BB9<br/>\n\u25CF \u5167\u5BB9\u8C50\u5BCC\u5EA6\u4F4E\uFF0C\u5982\u5C0D\u539F\u6709\u7D20\u6750\u9032\u884C\u7C21\u55AE\u526A\u8F2F\u62FC\u63A5\uFF0C\u6216\u7C21\u55AE\u6DFB\u52A0\u77ED\u66AB\u7684\u958B\u5834\u767D\u3001\u5834\u666F\u904E\u6E21\u4E32\u5834\u8A5E\u3001\u80CC\u666F\u97F3\u6A02\u7B49<br/>\n\u25CF \u4E8C\u5275\u6210\u672C\u8F03\u4F4E\uFF0C\u50C5\u5C0D\u8996\u983B\u7D20\u6750\u6216\u6587\u6848\u9032\u884C\u7C21\u55AE\u7684\u7FFB\u8B6F\u3001\u914D\u97F3\u751F\u786C\u523B\u677F\u7B49\uFF1B\u6216\u4F7F\u7528\u4ED6\u4EBA\u97F3\u983B\u4F5C\u54C1\uFF0C\u50C5\u7C21\u55AE\u914D\u4E0A\u8996\u983B\u756B\u9762<br/>\n\u25CF \u89E3\u8AAA\u4FE1\u606F\u55AE\u8584\uFF0C\u6C92\u6709\u660E\u78BA\u7684\u4E3B\u984C\u548C\u500B\u4EBA\u6709\u6548\u4FE1\u606F\u50F9\u503C\u89C0\u9EDE\u8F38\u51FA\uFF0C\u8996\u983B\u5167\u7684\u89E3\u8AAA\u6587\u6848\u6D89\u5ACC\u6284\u8972\u3001\u89C0\u9EDE\u4F86\u81EA\u7DB2\u7D61<br/>\n\u25CF \u5F15\u7528\u7D20\u6750\u4F4E\u8CEA\uFF0C\u5982\u5F15\u7528\u8996\u983B\u548C\u5716\u50CF\u7D20\u6750\u5B58\u5728\u6A21\u7CCA\u6296\u52D5\u3001\u62C9\u4F38\u653E\u5927/\u7E2E\u5C0F\u3001\u660E\u986F\u9ED1\u908A\u7B49\u60C5\u6CC1<br/>\n\u25CF \u5F15\u7528\u7D20\u6750\u548C\u8996\u983B\u4E3B\u984C\u7684\u95DC\u806F\u6027\u4F4E", "(3)\u58F9\u6587\u591A\u767C<br/>\n\u25CF \u540C\u58F9\u8996\u983B\u767C\u5E03\u5728\u81EA\u5DF1/\u516C\u53F8\u4E0D\u540C\u7684\u8CEC\u865F\uFF0C\u4E14\u5747\u8072\u660E\u539F\u5275<br/>\n\u25CF \u5728\u540C\u58F9\u8CEC\u865F\u5167\uFF0C\u540C\u58F9\u8996\u983B\u91CD\u5FA9\u8072\u660E\u539F\u5275\uFF0C\u7279\u6B8A\u60C5\u6CC1\u4E0B\u53EF\u8C41\u514D\uFF0C\u6BD4\u5982\uFF1A\u7B2C\u58F9\u904D\u767C\u5E03\u6709\u8AA4\u4F46\u5F88\u5FEB\u522A\u9664\u3001\u5728\u7B2C\u58F9\u6B21\u767C\u5E03\u8996\u983B\u7684\u57FA\u790E\u4E0A\u7E7C\u7E8C\u5B8C\u5584\u5167\u5BB9\u4E14\u52A0\u5DE5\u9EDE\u8C50\u5BCC<br/>", "(4)\u7121\u6CD5\u8B49\u660E\u539F\u5275\u6027\u8CEA\u7684\u4F5C\u54C1\uFF1A<br/>\n\u25CF \u8CEC\u865F\u767C\u5E03\u5716\u96C6\u4F5C\u54C1\uFF0C\u4E14\u7121\u6CD5\u8B49\u660E\u539F\u5275\u6027\uFF1A\u8CEC\u865F\u767C\u5E03\u4F4E\u8CEA\u91CF\u5716\u7247\u4F5C\u54C1\uFF0C\u5982\u6587\u5B57\u4FE1\u606F\u985E\u622A\u5716\u3001\u7A7A\u6D1E\u7121\u610F\u7FA9\u7684\u96A8\u624B\u62CD\u3001\u50B7\u611F\u53E5\u5B50\u3001\u7D93\u5178\u8A9E\u9304\u7B49\u5716\u7247\u7B49\uFF1B\u8CEC\u865F\u767C\u5E03\u660E\u986F\u7DB2\u5716\u4F5C\u54C1\uFF0C\u5982\u660E\u661F\u3001\u7F8E\u5973\u3001\u7DB2\u7D05\u4ECB\u7D39\u7B49\n"]
  },
  baihuaQualityReview: {
    title: "百花計劃 內容質量審核規則",
    ruleSet: ["<div class=\"h3-label\">\u58F9\u3001\u512A\u8CEA\u539F\u5275\u4F5C\u8005</div>", "1.\u5177\u5099\u7A69\u5B9A\u751F\u7522\u80FD\u529B\uFF0C\u5728LesPark\u6301\u7E8C\u3001\u7A69\u5B9A\u66F4\u65B0\u4F5C\u54C1<br/>\n2.\u4F5C\u8005\u751F\u7522\u7684\u4F5C\u54C1\u9818\u57DF\u5782\u76F4\uFF0C\u98A8\u683C\u7D71\u58F9\uFF0C\u6709\u500B\u4EBA\u7279\u8272<br/>\n3.\u4F5C\u8005\u5805\u6301\u751F\u7522\u539F\u5275\u4F5C\u54C1\uFF0C\u5C0A\u91CD\u5275\u4F5C\u3001\u5C0A\u91CD\u7248\u6B0A<br/>\n4.\u4F5C\u8005\u6301\u7E8C\u751F\u7522\u512A\u8CEA\u4F5C\u54C1\uFF0C\u5E36\u7D66\u7528\u6236\u826F\u597D\u7684\u89C0\u770B\u9AD4\u9A57<br/>\n", "<div class=\"h3-label\">\u4E8C\u3001\u512A\u8CEA\u4F5C\u54C1</div>", "1.\u4F5C\u54C1\u89C0\u770B\u9AD4\u9A57\u597D<br/>\n(1)\u4F5C\u54C1\u8CEA\u91CF\u512A\u8CEA\uFF1A<br/>\n\u25CF \u5C01\u9762\uFF1A\u5C01\u9762\u8996\u89BA\u6C96\u64CA\u611F\u5F37\uFF0C\u98A8\u683C\u7D71\u58F9\uFF0C\u7A81\u51FA\u91CD\u9EDE\uFF0C\u6709\u52A9\u65BC\u7528\u6236\u5728\u89C0\u611F\u4E0A\u5F62\u6210\u58F9\u500B\u7CFB\u5217\u7684\u8A8D\u77E5<br/>\n\u25CF \u6A19\u984C\uFF1A\u6A19\u984C\u76F4\u89C0\u7A81\u51FA\uFF0C\u8207\u5167\u5BB9\u76F8\u95DC\uFF0C\u7121\u6A19\u984C\u8A87\u5F35\u7B49\u554F\u984C<br/>\n\u25CF \u756B\u9762\uFF1A\u8996\u983B\u756B\u9762\u7F8E\u89C0\u6E05\u6670\u3001\u7121\u566A\u9EDE\uFF0C\u5C0D\u6BD4\u5EA6\u9069\u5B9C\uFF1B\u8996\u983B\u756B\u9762\u5B8C\u6574\uFF0C\u7121\u6C34\u5370\u904E\u591A\u3001\u62C9\u5347\u3001\u653E\u5927\u88C1\u526A\u5C0E\u81F4\u756B\u9762\u4E0D\u5168\u3001\u9ED1\u908A\u7B49\u554F\u984C<br/>\n\u25CF \u8072\u97F3\uFF1A\u8996\u983B\u97F3\u756B\u540C\u6B65\u3001\u7121\u96DC\u97F3\uFF0C\u4EBA\u7269\u81FA\u8A5E\u8072\u97F3\u6E05\u6670\u3001\u97F3\u91CF\u9069\u5B9C<br/>\n\u25CF \u5B57\u5E55\uFF1A\u8996\u983B\u5B57\u5E55\u5B8C\u6574\u53EF\u898B\uFF0C\u5B57\u5E55\u8207\u8996\u983B\u756B\u9762\u3001\u8996\u983B\u8072\u97F3\u540C\u6B65<br/>\n\u25CF \u7BC0\u594F\uFF1A\u8996\u983B\u6D41\u66A2\uFF0C\u64AD\u653E\u4E0D\u5361\u9813\uFF0C\u60C5\u7BC0\u5B8C\u6574\uFF0C\u6709\u982D\u6709\u5C3E<br/>\n(2)\u4F5C\u54C1\u6EFF\u8DB3\u6642\u6548\u6027\u3001\u5C08\u696D\u6027\u3001\u5BE6\u7528\u6027\u3001\u8DA3\u5473\u6027\u7B49\u5176\u58F9\u7279\u5F81<br/>\n(3)\u4F5C\u54C1\u601D\u60F3\u5B8C\u6574\uFF0C\u8868\u9054\u4E3B\u65E8\u660E\u78BA\u6E05\u6670\uFF0C\u4F5C\u54C1\u6574\u9AD4\u89C0\u611F\u7684\u8212\u9069\u5EA6\u3001\u6109\u6085\u6027\u3001\u89C0\u8CDE\u6027\u5F37", "2.\u4F5C\u54C1\u5275\u4F5C\u6210\u672C\u9AD8<br/>\n(1)\u751F\u7522\u524D\u671F\uFF1A\u4F5C\u54C1\u6709\u5B8C\u6574\u7684\u69CB\u601D\uFF0C\u62CD\u651D\u904E\u7A0B\u5B58\u5728\u8173\u672C\u3001\u60C5\u7BC0\u3001\u6587\u6848\u8A2D\u8A08\u3001\u6F14\u54E1\u7B49<br/>\n(2)\u751F\u7522\u5F8C\u671F\uFF1A\u901A\u904E\u6DFB\u52A0\u5B57\u5E55\u3001\u80CC\u666F\u97F3\u6A02\u7B49\u63D0\u5347\u8996\u983B\u53EF\u770B\u6027\uFF0C\u8996\u983B\u526A\u8F2F\u6D41\u66A2\uFF0C\u8996\u983B\u5B8C\u6574\u5EA6\u9AD8\n", "<div class=\"h3-label\">\u4E09\u3001\u975E\u512A\u8CEA\u4F5C\u54C1</div>", "(1)\u5236\u4F5C\u7C21\u55AE\u7C97\u7CD9\uFF1A<br/>\n\u25CF \u65E5\u5E38\u751F\u6D3B\u96A8\u624B\u62CD\uFF0C\u5167\u5BB9\u7A7A\u6D1E/\u7121\u5177\u9AD4\u5BE6\u969B\u610F\u7FA9/\u96A8\u624B\u62CD\u651D/\u7121\u89C0\u8CDE\u50F9\u503C/\u7F3A\u4E4F\u53EF\u770B\u6027<br/>\n\u25CF \u76F4\u64AD\u9810\u544A\u3001\u76F4\u64AD\u9304\u5C4F\u7B49\u5167\u5BB9\uFF0C\u7121\u518D\u6B21\u52A0\u5DE5\u4E14\u5167\u5BB9\u55AE\u8584\u3001\u756B\u9762\u55AE\u58F9<br/>\n\u25CF \u7DB2\u7D61\u5716\u7247\u62FC\u6E4A\u985E\u5716\u96C6\u4F5C\u54C1<br/>\n(2)\u756B\u9762\u89C0\u611F\u4E0D\u9069\uFF1A<br/>\n\u25CF \u8996\u983B\u7D66\u4EBA\u5E36\u4F86\u56B4\u91CD\u7684\u756B\u9762\u6C96\u64CA\u611F\uFF0C\u5F15\u4EBA\u4E0D\u9069\uFF0C\u5982\u8840\u8165\u3001\u5BC6\u96C6\u756B\u9762<br/>\n(3)\u4E0D\u826F\u50F9\u503C\u89C0:<br/>\n\u25CF \u8996\u983B\u5BA3\u50B3\u4E0D\u826F\u98A8\u6C23\u548C\u4E0D\u7576\u884C\u70BA\uFF0C\u5982\u62DC\u91D1\u3001\u8CE3\u6158\u3001\u4E0D\u6587\u660E\u7528\u8A5E\u3001\u6253\u67B6\u9B25\u6BC6\u7B49<br/>\n(4)\u71DF\u92B7\u63A8\u5EE3/\u8A98\u5C0E\u8981\u8D0A\uFF1A<br/>\n\u25CF \u4EE5\u76C8\u5229\u70BA\u76EE\u7684\u7684\u7D14\u5EE3\u544A\u3001\u5F15\u5C0E\u7528\u6236\u7DDA\u4E0B\u4EA4\u6613<br/>\n\u25CF \u901A\u904E\u60C5\u611F\u7D81\u67B6\u6C42\u8D0A\u6C42\u95DC\u8A3B\u7684\u60E1\u610F\u9A19\u6D41\u884C\u70BA<br/>\n(5)\u8B20\u8A00\u507D\u79D1\u5B78<br/>\n\u25CF \u50B3\u64AD\u672A\u7D93\u8B49\u5BE6\u7684\u865B\u5047\u6D88\u606F\u3001\u5C01\u5EFA\u8FF7\u4FE1\u548C\u9055\u80CC\u79D1\u5B78\u898F\u5F8B\u7684\u5167\u5BB9\n"]
  },
  mobleTxt: {
    t1: '優質主播申請',
    download: '壹鍵下載',
    download2: '立即下載',
    more: '查看更多',
    lesAppTitle: '- 認識超過 2000 萬 多元女性',
    aboutUsT1: '雖小眾 不孤獨'
  }
};

/***/ }),

/***/ 14:
/***/ (function(module, exports) {

module.exports = {
  title: "LesPark-The best APP for lesbians,queer and bisexual women",
  description: "LesPark is a global lesbian live video streaming social network.THE MOST ENJOYABLE LESBIAN APP.",
  header: {
    nav1: "Hot Live",
    nav2: "Subscription",
    nav3: "Anchor Center",
    nav3_1: "Anchor system",
    nav3_2: "Start live on PC",
    nav3_3: "Sign",
    nav3_4: "How to start live on PC",
    nav3_5: "Live",
    nav3_6: "Withdraw",
    nav4: "Service",
    nav5: "About Us",
    nav6: "Login/Register",
    me1: "Subscription",
    me2: "Log Out",
    live: "Live",
    topic: "Topic",
    baihuaTitle: "Baihua Plan",
    baihuaAward: "Subsidies",
    ContactUs: "Contact us",
    myHome: "My Home",
    jihua: "悸花乐读"
  },
  login: {
    nav1: "	Login",
    nav2: "Register",
    nav3_1: "Quick login",
    nav3_2: "Quick login without Registration",
    nav4: "Sign in directly with a third-party account",
    nav5: "Please scan the QR code",
    nav6: "to download and register LesPark",
    nav7: "or",
    nav8: "Login",
    input1: "Phone Number",
    input2: "Enter Number",
    input3: "China",
    input4: "American",
    input5: "Taiwan",
    input6: "HongKong",
    input7: "Macao",
    input8: "Thailand",
    input9: "Malaysia",
    input10: "Singapore",
    input11: "Japan",
    input12: "Korea",
    input13: "Australia",
    input14: "England",
    input15: "Philippines",
    input16: "Vietnam"
  },
  home: {
    download: "Download",
    download1: "IOS",
    download2: "Android",
    download3: "QRcode",
    liveTitle1: "Following",
    liveTitle1_1: "The host that does not have your concern temporarily is live, go to see popular live show",
    liveTitle2: "Hot Live",
    liveTitle3: "Hot Topic",
    liveTitle3_1: "no hot topic",
    appProfile: "App Profile",
    more: "More"
  },
  swiper: {
    0: {
      h1Content: "Baihua Plan",
      h2Content: "Shoot short videos to get millions of subsidies"
    },
    1: {
      h1Content: "Broadcast live",
      h2Content: "Interact with High-class anchor"
    },
    2: {
      h1Content: "Multi-video chat",
      h2Content: "Video chat and Matchmaking"
    },
    3: {
      h1Content: "People nearby",
      h2Content: "Discover the circle of friends"
    },
    4: {
      h1Content: "Loving Park",
      h2Content: "Love Record "
    },
    5: {
      h1Content: "Real-time voice chat",
      h2Content: "Sweet voice than first love"
    },
    6: {
      h1Content: "Fast Parts",
      h2Content: "Match to the soulmate ,goodbye to the single day"
    }
  },
  live: {
    nav1: "Follow",
    nav2: "Followed",
    nav3: "Hot",
    nav4: "send",
    nav5: "Loading...",
    nav6: "End Live",
    nav7: "Follow",
    nav8: "Hot"
  },
  foot: {
    // content1: '',
    // content2: ' ',
    content3: "Orient Basic Science And Technology Co., Limited  ｜ 2013-2020 All Rights Reserved  ｜ Customer service：010-56153450 ",
    // content4: '｜Email：cs@lespark.us',
    // content5: ' Links',
    // content6: ''
    content1: "Guangdong Public Network Security No. 44180202000386",
    content2: "Guangdong ICP No. 18016053",
    content4: " 举报邮箱：cs@lespark.us",
    content5: " 友情链接",
    content6: "Guangdong Wangwen (2018) No. 3153-1052",
    HelpCenter: "Help Center",
    PrivacyPolicy: "Privacy Policy",
    ServiceAgreement: "Service Agreement",
    ReportPhone: "Report Phone",
    ReportEmail: "Report Email",
    CompanyProfile: "Company Profile",
    JoinUs: "Join Us",
    contactUs: "contact Us",
    ServiceTel: "Service Tel"
  },
  foot2: {
    content3: "Orient Basic Science And Technology Co., Limited  ｜ 2016-2023 All Rights Reserved  ｜ Customer service：010-56153450 ",
    content1: "Guangxi Public Network Security No. 45050302000153",
    content2: "Guangxi ICP No. 20003447-1",
    content6: "Guangxi Wangwen（2023）No. 1925-390"
  },
  live_star: {
    pc: "Computer Live Broadcasting",
    account: "LesPark account:",
    noLogin: "Not logged in,",
    login: "Click to Login",
    liveTitle: "Live title:",
    liveCover: "Live Cover:",
    oldLiveCover: "Use the last live cover (avatar)",
    customimg: "Custom Pictures",
    plugFlow: "Push stream address:",
    copy: "copy",
    secret: "key:",
    finishLive: "End Live",
    getLiveAdd: "Get the live address",
    liveNote: "Notes:",
    liveNote1: "1. According to the relevant regulations, please complete the real name certification in the LesPark app before starting the broadcast. Please comply with",
    liveNote2: "2. Log in to the LesPark account on this page, enter the title, select the cover, and click the \"Get Broadcast Address\" button",
    liveNote3: "3. Configure the push stream address and key in the OBS, click Start to push the stream",
    liveNote4: "4. At the end of the live broadcast, please be sure to click \"End Live\" on this page, otherwise the live room will be affected by the black screen",
    convention: "LesPark Live Broadcast Convention"
  },
  mobile_login: {
    title: "Please login first~",
    sendCode: "Send",
    resendCode: "Resend",
    btnName: "Login",
    agreeLic: "Registration is deemed to agree to",
    lic: "\"LesPark Terms of Use\"",
    sendCodeFail: "Failed to send verification code",
    errPhoneFormat: "Phone format error",
    errVerifyCodeRequired: "verification code must be filled",
    errVerifyCodeFormat: "Verification code format error",
    success: "login successful",
    fail: "Login failed",
    phoneRequired: "Please enter phone number",
    verifyCodeRequired: "Enter code"
  },
  dynamic: {
    comment: "Comments",
    moreComment: "View more reviews",
    liaoXjj: "Young ladies", //Go to tease young lady
    faXianXjj: "Find more beautiful sisters",
    nodata: "The post was deleted by the publisher, go to LesPark to find more interesting posts"
  },
  video: {
    comment: "Enter comment...",
    more: "More exciting videos",
    nodata: "The short video was deleted by the publisher. Go to LesPark to post and see his other works~",
    notSupport: "This video is currently unavailable, please try again later"
  },
  profile: {
    moreFriends: "Discover more interesting friends",
    years: "years old",
    userId: "ID",
    fans: "Fan",
    girlSounds: "The girl sounds",
    chat: "Private chat",
    signature: "Personal Signature",
    fullText: "full text",
    notSupportAudio: "Your browser does not support the audio element",
    nodata: "Ah oh ~ this user account is logged out, go to LesPark to find more interesting girls"
  },
  common: {
    follow: "Follow",
    followed: "Followed",
    followFail: "Follow failed",
    goAndSeed: "Go",
    like: "Like",
    liked: "Praised",
    unlikeFail: "Cancel like failed",
    likeFail: "Like failed",
    likedUnit: " Praised"
  },
  downloadTip: {
    title: "Check out more comments at LesPark",
    textBtn: "Go to LesPark",
    video: "Check out more interesting videos on LesPark App~",
    profile: "Go to LesPark App to learn more about Miss Sister，and chat with little Sister~",
    dynamic: "Go to LesPark to find more interesting posts"
  },
  bottomBar: {
    video: "Discover more interesting short videos at LesPark",
    profile: "Discover more interesting young ladies in LesPark",
    dynamic: "Go to LesPark to find more interesting posts"
  },
  error: {
    userNotExist: "Account does not exist",
    networkException: "Network Error",
    phoneVerifyException: "Abnormal mobile number",
    paramInvalid: "Parameter error",
    verifyCodeError: "Verification code error",
    unsafeEnv: "The current use environment is risky（machine review）",
    accountRegisted: "Mobile number is registered",
    postNotFound: "Post does not exist or has been deleted",
    posterNotFound: "Poster does not exist",
    userNotFound: "Account does not exist"
  },
  baiHuaTxt: {
    bg1Title: "https://static.lespark.cn/pc_img/images/baihua/title-en.png",
    award: ["￥", "3", "0", "0", "0", "K"],
    bg1Tips: "Short video creation income reward",
    bg1Tips2: "Join \"Baihua Plan\" and publish original high-quality short videos to enjoy creative income",
    rule: "Rule description",
    bg2Title: "The world's largest female video platform",
    bg2Tips: ["Loads of &nbsp;", "traffic", "and &nbsp;", "profit", "await you"],
    bg2Img: "https://static.lespark.cn/pc_img/images/baihua/bg2Img-en.png",
    bg2Tips2: "Cash rewards",
    bg2Tips3: "*If \"Baihua Plan\" is successfully added to generate effective play volume, super high revenue can be obtained",
    bg3Title: "LesPark invites every creator to join Baihua Plan",
    bg3Tips: ["Each&nbsp;", "unique you&nbsp;", " will be seen"],
    bg3Img: "https://static.lespark.cn/pc_img/images/baihua/tequan-en.png",
    bg3Tips2: "The above is only part of the rules, please check ",
    bg3Tips3: "Please read the rules and terms carefully before joining Baihua Plan",
    bg3Tips4: "By joining the Program, you are deemed to have read, understood and agreed to all the Rules",
    tqSvga: "https://static.lespark.cn/pc_img/images/baihua/tequan-en.svga",
    titleSvga: "https://static.lespark.cn/pc_img/images/baihua/title-en.svga"
  },
  photowall: {
    title: "Dverse women around the world",
    LaunchedYears: "Launched 7 years",
    millionsWomen: "20 millions+<br/> women users",
    content1: "serving millions of ",
    content2: "diverse women around the world",
    content3: "Make matches for<br/> thousands of couples",
    content4: "1000+ <br/>dating room"
  },
  liveAll: {
    content1: "Hot live",
    content2: "All lives"
  },
  topicAll: {
    content1: "Hot topic",
    content2: "All topics",
    join: " people join"
  },
  headerOptions: [{
    value: "anchor",
    label: "Anchor management",
    children: [{
      value: "pc",
      label: "Start PC live"
    },
    // {
    //   value: 'backend',
    //   label: 'Anchor management backstage',
    // },
    {
      value: "invite",
      label: "Recruit quality anchors"
    }, {
      value: "sign",
      label: "input signing info."
      // {
      //   value: 'withdraw',
      //   label: 'withdraw',
      // },
    }]
  }, {
    value: "union",
    label: "GUild",
    children: [{
      value: "Trade",
      label: "Guild enters"
    }, {
      value: "management",
      label: "GUild management backstage"
    }]
  }],
  lesApp: {
    content1: "LesPark - Meet over 20 million women",
    content2: " comments",
    content3: "It is a social platform for thousands of women to record and share their lives,express themselves easily through live broadcast and voice chat,share thousands of fresh videos,voice,text and pics everyday,discover the real and interesting world and let them making friends easily.  ",
    content4: "LesPark mission:To connect women around the world and make a tolerant and happy place.",
    content5: "Brodcast live",
    content6: "High-class anchor will chat and sing with you here",
    content7: "Multi-video chat",
    content8: "Matchmaker online,multiplayer mode,let you find the right person",
    content9: "people nearby",
    content10: "Through the accurate location to find nearby lesbians,let you GET her",
    content11: "Video matching",
    content12: "one-on-one video matching chat,real person video,no pretence,face to face hot chat,get to know each other",
    content13: "Loving Park",
    content14: "Lesbian lovers'exclusive space,recording every moment of love;Complete the couple list and daily clocking tasks,and get points to redeem gifts.",
    content15: "Voice party",
    content16: "Live online voice party,chat,sing,date,play games with beauties,take you away from loneliness.",
    content17: "Real-time voice chat",
    content18: "10s to match the distance of her,speak freely with strangers,make new friends,tell stories,say good night,find a nice voice and let the voice heal you.",
    content19: "Fast Parts",
    content20: "Make friends out of single, the single to be rescued,according to your preferences and location setting,quickly match interests of her.",
    content21: "Users reviews",
    content22: "Rating from 29820 users",
    content23: "Q&A",
    content24: "Will there be any male users in the APP？",
    content25: "No,we have an audit customer service team to strictly audit online 7*24 hours a day.Male users are not allowed to enter.Once found,they will be banned.",
    content26: "Why LesPark?",
    content27: "LesPark is an exclusive lesbian social app that creats a safe apce for women.The gole is to provide a platform for friendly relationships and dialogue without bullying,prejudice,judgement and social risk. ",
    content28: "Does LesPark charge?",
    content29: "LesPark is a free social APP that can be downloaded from the APP Store and Android APP Store.  ",
    content30: "Will LesPark reveal anything about me?",
    content31: "LesPark will not disclose user information to third parties in any way to ensure your privacy and security.",
    commentList: [{
      time: "2021-06-28",
      name: "Kim L ",
      content: "Very good App!!! I like and enjoying my time on this site. It has created an opportunity for me to meet and communicate with likeminded people."
    }, {
      time: "2021-08-01",
      name: "Montoya Byrd",
      content: "Ilike lespark! Personally, I think it's better to use a good-looking lesbian dating app. Watching the live broadcast is also very happy, can meet like-minded friend"
    }, {
      time: "2021-08-01",
      name: "schultewinforda",
      content: "lesbians app. With this software, it provides us with an interactive dating platform, and I also find my true love. Thank you so much!"
    }, {
      time: "2021-08-13",
      name: "Jessia edwardo",
      content: "Great application ! Good comment. I hope I can find a handsome date in it "
    }, {
      time: "2021-09-01",
      name: "Sirena Betancourt ",
      content: "Continue to use~  You can see the dynamic life of different people, participate in different topics to understand everyone's opinion"
    }]
  },
  aboutUs: {
    content1: "LesPark is a mobile social application for global female friends-making by Qingyuan Park Culture Media Co.Ltd., Whether you want to be a KOL with millions of fans, or simply make friends to share your emotion and learn things, LesPark provides a convenient and true community exclusively for ladies.",
    content1_1: "LesPark is a mobile social application for global female friends-making by Park Culture Media Co.,Ltd; Whether you want to be a KOL with millions of fans, or simply make friends to share your emotion and learn things, LesPark provides a convenient and true community exclusively for ladies.",
    content1_2: "LesPark is a mobile social application for global female friends-making by ORIENT BASIC SCIENCE AND TECHNOLOGY PTE. LTD. Whether you want to be a KOL with millions of fans, or simply make friends to share your emotion and learn things, LesPark provides a convenient and true community exclusively for ladies.",
    content2: "Here you can show yourself through community or live broadcast, and interact with fans in real-time. Join nearby groups to participate in various activites according to the location,establish a good and health social relations with nearby people as well.",
    content3: "\u201CLive for Love\u201D has always been LesPark's slogan, aiming to creat platform for women to record and share their lives.",
    content4: "At present, LesPark has been online for 7 years, with more than 20 million vertical users in 34 countries around the world, and more than 150,000 anchors.",
    content5: "Corporate Culture",
    content6: "Mission",
    content7: "Connecting with minorities around the world,making the world more tolerant and happier",
    content8: "",
    content9: "Vision",
    content10: "Become the most reliable global company for minority groups",
    content11: "Build an universal value network for minority groups through continuous innovation ",
    content12: "",
    content13: "Values",
    content14: "User first, team collaboration",
    content15: "Results-oriented, pursuit for perfection",
    content16: "Be proactive and fearless",
    content17: "Join us",
    content18: "We need talents in product, operation, technology and other positions,looking forward to your participation!",
    content19: "Join now",
    content20: "contact us",
    content21: "Contacts",
    content22: "Mr. Zhang",
    content23: "Service Tel",
    content24: "Address: ",
    content25: "Report complaints",
    content26: "No. 08 office, 14th Floor, Yunshan Shiyi Building, Rd 88 Guangqing Avenue, Qingyuan city, Guangdong province",
    content26_1: "No. 0401, Building 1, Suifeng Jinwan, No. 299 Sichuan Road, Beihai City, Guangxi Zhuang Autonomous Region",
    content26_2: "ORIENT BASIC SCIENCE AND TECHNOLOGY PTE. LTD."
  },
  loginHome: {
    content1: "加载更多",
    content2: "粉丝",
    content3: "获赞",
    content4: "动态"
  },
  topicItem: {
    content1: "人赞",
    content2: "查看全部",
    content3: "条评论",
    content4: "回复",
    content5: "评论...",
    content6: "发送"
  },
  baihuaRule: {
    title: "Rules of Baihua Plan",
    ruleSet: ["Before joining the Baihua Plan (hereinafter referred to as \"the plan\"), please read the rules and related terms in detail. Any application to join the Baihua Plan is deemed to have read, understand, and agree to the entire content of the rules.", "<h3 class=\"h3-label\">Plan introduction</h3>", "The Baihua Plan is an activity of incentive short video creation organized by the LesPark. The author who successfully joined the Baihua Plan,<span> through the original high -definition video (duration \u226510 seconds)</span> released in the app, has the opportunity to enjoy creative income.", "<h3 class=\"h3-label\">How to join the plan</h3>", "1. You can apply for the Baihua Plan by clicking the \"Join\" button on the program introduction page and completing the corresponding requirements tasks.", "2. Before applying for the Baihua plan, the following application tasks need to be completed. LesPark will review the video content quality of applicants based on the rules of the plan.", "1)Complete the mobile phone number binding and real-name authentication<br/>\n2)In the past 30 days, it has released no less than 5 publicly visible, original high-definition videos (definition \u2265 720P and duration \u2265 10 seconds) through LesPark App<br/>\n3)In the past 30 days, the total view of all publicly visible and original high-definition videos (duration \u2265 10 seconds) released through LesPark App has reached 60,000\n", "When you complete the application task, you can click the button to submit the review. Official staff will determine whether you can join the plan according to the original high-definition video (duration \u226510 seconds) released by the account and content quality standards (see rules for details: <a href=\"/baihuaQualityReview.html\">content quality review</a>), etc. The result of the review will be announced through the plan introduction page and message notification.", "1) If the review is not passed due to non-compliance with the content quality standards and other reasons, you can adjust according to the corresponding reasons or suggestions, or try to publish at least 5 original high-definition videos (duration \u2265 10 seconds) again. After the adjustment, you can resubmit the review application.<br/>\n2) The platform gives priority to encouraging creators who independently shoot and create to join the program.<br/>\n3) The current account is not an abnormal state such as cancellation, deletion, and banning.<br/>\n4) The created video shall meet the original standard of the platform (see the rule for details: <a href=\"/baihuaOriginalStandards.html\">original standards</a>), and there shall be no pornographic, vulgar, unclear picture, increasing video playback through cheating and other adverse problems. It does not involve such negative guidance issues as minors, advertising and marketing, illegal teaching, speech attacks, and unqualified financial explanation. At the same time, note that if a large number of videos are meaningless in the account or simple processing based on a certain material, and the lowest level of creativity, the applicant cannot join the Baihua Plan.\n      ", "<h3 class=\"h3-label\">income of the plan</h3>", "1. Video creation income<br/>\nAfter successfully joining the program, if video playback volume of the original high-definition video (duration \u2265 10 seconds) released through LesPark App reaches 20,000,  and if the video passes the content quality review and are in the \"revenue review \" state, the revenue playback of the video can obtain creative revenue. Note: The revenue period of a single video work is within 90 days after it is released and passed review, and if it exceeds 90 days, it will be set as \"Expired\"; If the video work fails to pass the review, it will be set as \"Failed\"; If the review is passed and the period does not exceed 90 days, it will be set to \"Profitable\" status.<br/>\n2. Income viewing and withdrawal<br/>\n1) The income obtained after joining the Baihua Plan can be viewed in the LesPark App - My - Sidebar - Creator Center, or in the LesPark App - My - Sidebar - Diamond Wallet.<br/>\n2) The withdrawal of income can be applied for at most once a day. You can select the amount and platform of the corresponding gear according to the withdrawal amount, and submit the withdrawal application. After the withdrawal is approved, the corresponding payment will be made.", "<h3 class=\"h3-label\">Description of violation</h3>", "1. LesPark officials have the right to conduct security verification for users participating in this activity<br/>\nIf the users participating in this activity have or have ever violated laws and regulations or LesPark App rules or the principle of good faith, LesPark officials have the right to take measures, including but not limited to restricting the registration/login to LesPark App, prohibiting participation in this activity, revoking the qualification to participate in the activity, revoking or freezing the qualification to obtain income from the activity (including but not limited to virtual goods, cash, physical benefits, etc. that may be obtained through participating in the activity), inability to obtain or can only obtain part of the activity proceeds, full/partial restrictions on the use/withdrawal of the obtained activity proceeds, withdrawal of the released activity proceeds, closure of the account, etc., and reserve the right to pursue the relevant legal liabilities of the user.\nThe behaviors violating the principle of good faith include but are not limited to:<br/>\n1) Download the unofficial client;<br/>\n2)Use the mobile phone number, virtual mobile phone number, QQ, WeChat and other third-party platform accounts suspected of high-risk cheating to register/log in to LesPark App;<br/>\n3)Modify page parameters and tamper with device data;<br/>\n4)Participate in the activities with any robotic software, spider software, crawler software, screen flooding software or any non-artificial way;<br/>\n5)Using illegal tools such as simulator, plug-in, APP avatars and other illegal tools to scan, download, install, register, log in to LesPark clients, participate in activities, receive activity income, withdraw, and donate activity income to others;<br/>\n6)Disturb the platform order through malicious profit-making means;<br/>\n7)Use plug-ins, group control systems or third-party tools to interfere, destroy, modify or exert other influences on the LesPark platform and this activity;<br/>\n8)Colluding with other users or using machines to cheat, skim the proceeds of activities and other activities that disrupt the order of activities;<br/>\n9)Other behaviors against the principle of good faith that LesPark platform has reasonable grounds to suspect.<br/>\n<br/>\n2.In the process of participating in this activity, if the user makes any profit or illegal profit with the activity reward obtained, trades or transfers the reward obtained through the activity in any form, or the LesPark official has reasonable grounds to suspect that the user improperly uses the activity reward to disturb the order of the LesPark App, LesPark officials have the right to disqualify users from participating in activities, withdraw the issued activity rewards (including those used and unused), and reserve the right to investigate the relevant legal liabilities of users.\n<br/><br/>\n3.The LesPark official specially reminds you that you must participate in this activity through the LesPark official and LesPark official designated path. LesPark will not bear any legal responsibility for user losses caused by users' participation in any non LesPark official activities or activities conducted under the name of LesPark.\n", "<h3 class=\"h3-label\">matters needing attention</h3>", "1.According to relevant laws and regulations, if the sponsor needs to withhold and remit individual income tax on the income of the winners under this activity, the sponsor has the right to withhold and remit according to law. Without the prior written permission of the organizer, the rights or rewards obtained by users for participating in this activity shall not be transferred.<br/>\n2.Users shall not participate in this activity by any improper means or fraud or use this activity to engage in illegal acts. Once found, LesPark has the right to take measures such as reducing the activity reward, restricting withdrawal, clearing the account amount, revoking the activity qualification, restricting login, banning the account, restricting re registration and use, and also has the right to recover the reward received by the user, recover the amount withdrawn, and reserve the right to investigate the responsibility of the user.<br/>\n3.The sponsor operates the event according to law. If the event is adjusted, suspended, unable to be held, or the user fails to participate due to force majeure, changes in circumstances, changes in relevant policies, requirements of government authorities, insufficient number of participants, third party reasons and other non sponsor reasons, the sponsor has the right to decide to modify, suspend, cancel or terminate the event at any time, without any legal liability. If the participation fails due to the user's own reasons, the adverse consequences shall be borne by the user. The user can view the modified activity rules at any time on this page. If the user has any objection to the modified activity rules, please stop participating. If the user continues to participate in the activity, it is deemed that the user agrees to the modification of the activity rules.<br/>\n4.The LesPark Terms of Use and the LesPark Privacy Policy are also applicable to this event. If the rules and relevant provisions of this event conflict with the LesPark Terms of Use and the LesPark Privacy Policy, the rules and relevant provisions of this event shall prevail. The contents not stipulated in the rules and relevant provisions of this activity are still subject to the LesPark Terms of Use and the LesPark Privacy Policy.<br/>\n5.If you encounter any problems during the activity, you can open the LesPark App and consult through manual customer service or contact the official WeChat account.<br/>\n6.Apple Inc. is not a sponsor or involved in this activity in any manner.<br/>\n"]
  },
  baihuaOriginalStandards: {
    title: "Baihua Plan Original Standard Instructions",
    ruleSet: ["<div class=\"h3-label\">Definition of original work</div>", "1.Live shooting: Individual or team independently created videos, and owns the relevant copyright of all contents in the works<br/>\n(1) The video content picture is clean and tidy, the theme is clear, the content is complete and has memory points, and the account content style is unified;<br/>\n(2) Real person videos should have clear human attributes. The real name authentication information of the presenter and the account should be consistent;<br/>\n(3) Videos that are not real people appearing on the camera should have a clear theme orientation, and the content under the account can be judged to belong to the current account creation according to the vertical category, style, account characteristics, and materials provided by the author;\n", "2.Secondary editing works<br/>\n(1) On the basis of moderately quoting the original video materials, create a new video work with rich information, own editing ideas and originality for the second time;<br/>\n(2) The secondary creation forms include but are not limited to commentary, editing, special effects packaging, audio processing, etc. that reflect author's own ideas and thoughts;\n", "3. The following types are not original works<br/>\n(1) Upload works similar to others:<br/>\n\u25CF Upload and publish other people's works directly by transporting, screen recording, and screen shooting;<br/>\n\u25CF Publish (or directly upload) copyrighted content such as film and television plays, variety shows, anime, music videos, news, games and sports events without the authorization of the copyright owner or without copyright<br/>\n\u25CF Pure screen recording content, recording and broadcasting works that the creator did not participate in filming, recording, and processing", "(2)Content with a low level of secondary creation<br/>\n\u25CF Low content richness, such as simple editing and splicing of original materials, or simple addition of short opening remarks, scene transition words, background music, etc.<br/>\n\u25CF The cost of secondary creation is relatively low, and only simple translation of video materials or copy, and the video dubbing is stiff and rigid; Or use other people's audio works, simply with video images<br/>\n\u25CF Narrow interpretation information, no clear theme and output of personal effective information values. The commentary copy in the video is suspected of plagiarism, and the opinions come from the Internet<br/>\n\u25CF The quoted materials are of low quality, such as fuzzy jitter, stretch amplification/reduction, and obvious black edges, etc. in the quoted video and image materials<br/>\n\u25CF The reference material is less relevant to the theme of the video", "(3)Post more than once<br/>\n\u25CF The same video is published in different accounts of the author or the company, and all claim to be original<br/>\n\u25CF Within the same account, the same video is repeatedly declared to be original, which can be exempted under special circumstances, such as: the first release is wrong but it is quickly deleted, and the content is continued to be improved and processed on the basis of the first release<br/>", "(4)Works that cannot prove originality:<br/>\n\u25CF The account publishes atlas works, and the originality cannot be proved: the account publishes low-quality picture works, such as text information screenshots, empty and meaningless snapshots, sentimental sentences, classic quotations, etc.; the account releases obvious network pictures, such as celebrities, beauties, and online influencer introductions, etc.\n"]
  },
  baihuaQualityReview: {
    title: "Content Quality Review Rules",
    ruleSet: ["<div class=\"h3-label\">\u2160. High-quality original author</div>", "1. Have stable production capacity and continuously and steadily update works in LesPark<br/>\n2. The works produced by the author are vertical in field, uniform in style and with personal characteristics<br/>\n3. The author insists on producing original works, respecting creation and copyright<br/>\n4. The author continues to produce high-quality works, bringing users a good viewing experience\n", "<div class=\"h3-label\">\u2161. High-quality works</div>", "1. Good viewing experience<br/>\n(1) High quality works:<br/>\n\u25CF Cover: The covers have a strong sense of visual impact, unified style, and highlight the key points, which helps users to form a series of perceptions in terms of look and feel<br/>\n\u25CF Title: The title is intuitive and prominent, relevant to the content, and there are no problems such as exaggeration of the title<br/>\n\u25CF Picture: The video picture is beautiful and clear, without noise, and with appropriate contrast; the video picture is complete, without excessive watermarks, upscaling, enlargement and cropping resulting in incomplete picture, black borders and other problems<br/>\n\u25CF Sound: The audio and picture of video are synchronized without noise, and the characters' lines have clear sound and appropriate volume<br/>\n\u25CF Subtitles: The video subtitles are completely visible, and the subtitles are synchronized with the video picture and video sound<br/>\n\u25CF Rhythm: The video is smooth, playing is not stuck, and the plot is complete<br/>\n(2) The work meets one of the characteristics of timeliness, professionalism, practicality, and interest, etc.<br/>\n(3) The idea of the work is complete, the expression theme is clear and definite, and the overall perception of the work is comfortable, pleasant, and ornamental.<br/>\n2. High cost of works creation<br/>\n(1) Early stage of production: The work has a complete idea, and the shooting process includes scripts, plots, copywriting design, actors, etc.<br/>\n(2) Later stage of production: improve the viewability of the video by adding subtitles, background music, etc., with smooth video clips and high video integrity", "<div class=\"h3-label\">\u2162. Non-quality works</div>", "(1) Simple and rough fabrication:<br/>\n\u25CF Casually photographed in daily life with empty content/no specific practical meaning/casually photographed/no viewing value/lack of visibility<br/>\n\u25CF Live broadcast preview, live broadcast screen recording and other contents without reprocessing, and the content is thin and the picture is single<br/>\n\u25CF Network picture patchwork atlas<br/>\n(2) Discomfortable video appearance:<br/>\n\u25CF Video brings people a serious image impact and discomfort, such as bloody and dense images<br/>\n(3) Bad values:<br/>\n\u25CF Videos promote bad ethos and inappropriate behaviors, such as money worship, miserable sales, uncivilized words, fights, etc.<br/>\n(4) Marketing promotion/inducing likes:<br/>\n\u25CF Pure advertising for profit, guiding users to trade offline<br/>\n\u25CF Malicious cheating behavior of soliciting favor and attention through emotional kidnapping<br/>\n(5) Rumor and pseudoscience<br/>\n\u25CF Disseminate unconfirmed false information, feudal superstition and content contrary to scientific laws\n"]
  },
  mobleTxt: {
    t1: 'Anchor Recruitment',
    download: 'Download',
    download2: 'Download',
    more: 'More',
    lesAppTitle: '- Meet over 20 million women',
    aboutUsT1: 'Live for Love'
  }
};

/***/ }),

/***/ 158:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 159:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 16:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jsonp__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jsonp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Constans__ = __webpack_require__(5);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var successStatus = __WEBPACK_IMPORTED_MODULE_2_Constans__["a" /* default */].APIS.successStatus;
//获取所有请求信息
function getAllData(options) {
  var url = options.url,
      _options$type = options.type,
      type = _options$type === undefined ? 'get' : _options$type,
      _options$dataType = options.dataType,
      dataType = _options$dataType === undefined ? 'json' : _options$dataType,
      headers = options.headers,
      _options$data = options.data,
      data = _options$data === undefined ? {} : _options$data,
      mock = options.mock;

  return new Promise(function (resolve, reject) {
    if (mock) return resolve(mock);
    __WEBPACK_IMPORTED_MODULE_0_axios___default()(_extends({}, options, {
      url: url,
      method: type,
      data: data,
      dataType: dataType,
      headers: headers
    })).then(function (res) {
      resolve(res);
    }).catch(function (error) {
      reject(error);
    });
  });
}
function Get(options) {
  var url = options.url,
      _options$type2 = options.type,
      type = _options$type2 === undefined ? 'get' : _options$type2,
      _options$dataType2 = options.dataType,
      dataType = _options$dataType2 === undefined ? 'json' : _options$dataType2,
      headers = options.headers,
      _options$data2 = options.data,
      data = _options$data2 === undefined ? {} : _options$data2,
      _options$params = options.params,
      params = _options$params === undefined ? {} : _options$params,
      mock = options.mock;

  return new Promise(function (resolve, reject) {
    if (mock) return resolve(mock);
    __WEBPACK_IMPORTED_MODULE_0_axios___default()(_extends({}, options, {
      url: url,
      method: type,
      data: data,
      params: params,
      dataType: dataType,
      headers: headers
    })).then(function (res) {
      var data = res.data;
      resolve(data);
    }).catch(function (error) {
      reject(error);
    });
  });
}

function Post(options) {
  var url = options.url,
      _options$type3 = options.type,
      type = _options$type3 === undefined ? 'post' : _options$type3,
      _options$dataType3 = options.dataType,
      dataType = _options$dataType3 === undefined ? 'json' : _options$dataType3,
      _options$data3 = options.data,
      data = _options$data3 === undefined ? {} : _options$data3,
      headers = options.headers,
      mock = options.mock;

  return new Promise(function (resolve, reject) {
    if (mock) return resolve(mock);
    var opt = _extends({}, options, {
      url: url,
      method: type,
      data: data,
      dataType: dataType,
      headers: headers,
      transformRequest: [function (data) {
        // axios 在 'Content-Type' 为 'application/x-www-form-urlencoded' 时，Form Data 参数会变为 string 类型
        // 发送数据前，将请求参数转换为 json 对象（transformRequest 允许在向服务器发送前，修改请求数据）
        var ret = '';
        for (var it in data) {
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
        }
        return ret;
      }]
    });
    __WEBPACK_IMPORTED_MODULE_0_axios___default()(opt).then(function (res) {
      var data = res.data;
      if (data.error == 0) {
        resolve(data);
      } else {
        toFail(data);
        reject(data);
      }
    }).catch(function (res) {
      reject(res);
    });
  });
}
function Delete(options) {
  var url = options.url,
      _options$type4 = options.type,
      type = _options$type4 === undefined ? 'delete' : _options$type4,
      _options$dataType4 = options.dataType,
      dataType = _options$dataType4 === undefined ? 'json' : _options$dataType4,
      _options$data4 = options.data,
      data = _options$data4 === undefined ? {} : _options$data4,
      headers = options.headers,
      mock = options.mock;

  return new Promise(function (resolve, reject) {
    if (mock) return resolve(mock);
    var opt = _extends({}, options, {
      url: url,
      method: type,
      data: data,
      dataType: dataType,
      headers: headers,
      transformRequest: [function (data) {
        // axios 在 'Content-Type' 为 'application/x-www-form-urlencoded' 时，Form Data 参数会变为 string 类型
        // 发送数据前，将请求参数转换为 json 对象（transformRequest 允许在向服务器发送前，修改请求数据）
        var ret = '';
        for (var it in data) {
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
        }
        return ret;
      }]
    });
    __WEBPACK_IMPORTED_MODULE_0_axios___default()(opt).then(function (res) {
      var data = res.data;
      if (data.error == 0) {
        resolve(data);
      } else {
        toFail(data);
        reject(data);
      }
    }).catch(function (res) {
      reject(res);
    });
  });
}

function Ajax(options) {
  var url = options.url,
      _options$type5 = options.type,
      type = _options$type5 === undefined ? 'get' : _options$type5,
      _options$dataType5 = options.dataType,
      dataType = _options$dataType5 === undefined ? 'json' : _options$dataType5,
      _options$data5 = options.data,
      data = _options$data5 === undefined ? {} : _options$data5,
      mock = options.mock;

  return new Promise(function (resolve, reject) {
    if (mock) return resolve(mock);
    __WEBPACK_IMPORTED_MODULE_0_axios___default()(_extends({
      traditional: true
    }, options, {
      headers: {
        'Content-Security-Policy': "frame-ancestors 'self' http://www.growingio.com https://www.growingio.com"
      },
      url: url,
      method: type,
      data: data,
      dataType: dataType
    })).then(function (res) {
      var data = res.data;
      if (data.error == 0) {
        resolve(data);
      } else {
        toFail(data);
        reject(data);
      }
    }).catch(function (error) {
      reject(error);
    });
  });
}

function Jsonp(options) {
  var url = options.url,
      data = options.data,
      mock = options.mock;

  return new Promise(function (resolve, reject) {
    if (mock) return resolve(mock);
    if (data) console.log('data请直接以query的形式写到url上：', '参考文档 https://www.npmjs.com/package/jsonp');
    var opt = _extends({}, options);
    __WEBPACK_IMPORTED_MODULE_1_jsonp___default()(url, opt, function (err, data) {
      if (err) {
        console.error(err.message);
        reject(error.message);
      } else {
        if (data.status.succeed === successStatus) {
          resolve(data);
        } else {
          toFail(data);
          reject(data);
        }
      }
    });
  });
}
// 错误统一处理
function toFail(data) {
  console.log('in fail:', data);
}
/* harmony default export */ __webpack_exports__["a"] = ({
  Jsonp: Jsonp,
  Get: Get,
  getAllData: getAllData,
  Post: Post,
  Delete: Delete,
  Ajax: Ajax
});

/***/ }),

/***/ 160:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 164:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 165:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 166:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 167:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 169:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 171:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_topicb_vue__ = __webpack_require__(279);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9bf999aa_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_topicb_vue__ = __webpack_require__(679);
function injectStyle (ssrContext) {
  __webpack_require__(678)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9bf999aa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_topicb_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9bf999aa_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_topicb_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 172:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_topicitem_vue__ = __webpack_require__(280);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a9e8758_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_topicitem_vue__ = __webpack_require__(683);
function injectStyle (ssrContext) {
  __webpack_require__(680)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6a9e8758"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_topicitem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a9e8758_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_topicitem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 173:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 174:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 176:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getLoginErrText;
function getLoginErrText(code) {
  var msg = this.$t('login.fail');
  switch (code) {
    case 9002:
      msg = this.$t('error.userNotExist');
      break;
    case 8017:
      msg = this.$t('error.networkException');
      break;
    case 8018:
      msg = this.$t('error.phoneVerifyException');
      break;
    case 10:
      msg = this.$t('error.paramInvalid');
      break;
    case 50003:
      msg = this.$t('error.verifyCodeError');
      break;
    case 8009:
      msg = this.$t('error.accountRegisted');
      break;
    default:
    //
  }
  return msg;
}

/***/ }),

/***/ 177:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mobileLogin_vue__ = __webpack_require__(300);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42863788_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mobileLogin_vue__ = __webpack_require__(763);
function injectStyle (ssrContext) {
  __webpack_require__(755)
  __webpack_require__(756)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-42863788"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mobileLogin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42863788_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mobileLogin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 178:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_downloadTip_vue__ = __webpack_require__(301);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35b943ca_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_downloadTip_vue__ = __webpack_require__(765);
function injectStyle (ssrContext) {
  __webpack_require__(764)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-35b943ca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_downloadTip_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35b943ca_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_downloadTip_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 179:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bottomBar_vue__ = __webpack_require__(302);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ae36462_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bottomBar_vue__ = __webpack_require__(767);
function injectStyle (ssrContext) {
  __webpack_require__(766)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6ae36462"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bottomBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ae36462_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bottomBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 19:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 225:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            slidesLength: 1,
            _width: 0,
            auto: true,
            slideing: true,
            timer1: '',
            className: '',
            dom: {},
            t: {
                sx: 0,
                s: 0,
                m: 0,
                e: 0
            },
            index: 1
        };
    },

    props: {
        //滑动所需要的时间
        autoPlay: {
            default: true
        },
        //一次滑动需要走多久
        duration: {
            default: 500
        },
        //两次滑动间隔的时间
        interval: {
            default: 2500
        },
        showIndicator: {
            default: true
        }
    },
    mounted: function mounted() {
        var _this = this;

        this.className = 'wh_swiper_' + Math.random().toFixed(3) * 1000;
        setTimeout(function () {
            //克隆dom
            _this.starDom();
            _this.dom.transform = 'translate3d(' + _this._width * -1 + 'px, 0px, 0px)';
            _this.dom['-webkit-transform'] = 'translate3d(' + _this._width * -1 + 'px, 0px, 0px)';
            _this.dom['-ms-transform'] = 'translate3d(' + _this._width * -1 + 'px, 0px, 0px)';
            if (_this.autoPlay) {
                _this.setTime();
            }
        }, 50);
    },

    methods: {
        s: function s(x) {
            if (this.slideing) {
                this.clearTimeOut();
                this.t.sx = this.getTransform();
                this.t.s = x.touches[x.touches.length - 1].clientX;
            }
        },
        m: function m(x) {
            if (this.slideing && this.t.s != -1) {
                this.clearTimeOut();
                this.t.m = x.touches[x.touches.length - 1].clientX - this.t.s;
                this.setTransform(this.t.m + this.t.sx);
            }
        },
        e: function e(x) {
            if (this.slideing && this.t.s != -1) {
                this.clearTimeOut();
                this.setTransform(this.t.m + this.t.sx);
                var x = this.getTransform();
                x += this.t.m > 0 ? this._width * 0.3 : this._width * -0.3;
                this.index = Math.round(x / this._width) * -1;
                this.wh('touch');
            }
        },
        setTransform: function setTransform(num) {
            this.dom.transform = 'translate3d(' + num + 'px, 0px, 0px)';
            this.dom['-webkit-transform'] = 'translate3d(' + num + 'px, 0px, 0px)';
            this.dom['-ms-transform'] = 'translate3d(' + num + 'px, 0px, 0px)';
        },
        getTransform: function getTransform() {
            var x = this.dom.transform || this.dom['-webkit-transform'] || this.dom['-ms-transform'];
            x = x.substring(12);
            x = x.match(/(\S*)px/)[1];
            return Number(x);
        },
        fn: function fn(e) {
            e.preventDefault();
        },
        prevSlide: function prevSlide() {
            this.clearTimeOut();
            this.index--;
            this.wh();
        },
        nextSlide: function nextSlide() {
            this.clearTimeOut();
            this.index++;
            this.wh();
        },
        slideTo: function slideTo(index) {
            this.clearTimeOut();
            this.index = index + 1;
            this.wh();
        },
        wh: function wh(type) {
            var _this2 = this;

            this.slideing = false;
            this.dom.transition = type == 'touch' ? '250ms' : this.duration + 'ms';
            this.setTransform(this.index * -1 * this._width);
            this.t.m = 0;
            this.t.s = -1; //保证下次重新赋值
            if (this.autoPlay) {
                this.setTime();
            }
            var timeDuration = type == 'touch' ? '250' : this.duration;
            setTimeout(function () {
                _this2.dom.transition = '0s';
                if (_this2.index >= _this2.slidesLength + 1) {
                    _this2.index = 1;
                    _this2.setTransform(_this2.index * -1 * _this2._width);
                }
                if (_this2.index <= 0) {
                    _this2.index = _this2.slidesLength;
                    _this2.setTransform(_this2.index * -1 * _this2._width);
                }
                _this2.$emit('transtionend', _this2.index - 1);
                _this2.auto = true;
                _this2.slideing = true;
            }, timeDuration);
        },
        setTime: function setTime() {
            var _this3 = this;

            this.timer1 = window.setTimeout(function () {
                if (_this3.auto) {
                    _this3.index++;
                    _this3.wh();
                } else {
                    window.clearTimeout(_this3.timer1);
                }
            }, this.interval);
        },
        starDom: function starDom() {
            var SlideDom = document.querySelector('.' + this.className).getElementsByClassName('wh_slide');
            this.slidesLength = SlideDom.length;
            if (this.slidesLength > 1) {
                var cloneDom1 = SlideDom[0].cloneNode(true); //向最后append
                var cloneDom2 = SlideDom[this.slidesLength - 1].cloneNode(true); //向最前append
                document.querySelector('.' + this.className).insertBefore(cloneDom2, SlideDom[0]);
                document.querySelector('.' + this.className).appendChild(cloneDom1);
                this._width = document.querySelector('.' + this.className).offsetWidth;
                this.dom = document.querySelector('.' + this.className).style;
            }
        },
        clearTimeOut: function clearTimeOut() {
            this.auto = false;
            window.clearTimeout(this.timer1);
        }
    }
});

/***/ }),

/***/ 226:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    methods: {
        clickSlide: function clickSlide() {
            this.$emit('click');
        }
    }
});

/***/ }),

/***/ 227:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_dropdown_item_css__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_dropdown_item_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_dropdown_item_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_dropdown_item__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_dropdown_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_dropdown_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_dropdown_menu_css__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_dropdown_menu_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_dropdown_menu_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_dropdown_menu__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_dropdown_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_dropdown_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_dropdown_css__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_dropdown_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_dropdown_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_dropdown__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_cascader_css__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_cascader_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_cascader_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_cascader__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_cascader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_cascader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_message_box_css__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_message_box_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_message_box_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_message_box__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_message_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_message_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_Common_cookie__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_Common_util__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_Views_components_login__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_Views_components_lay__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_Common_ajax__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_Constans__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_Common_events_bus__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_meta__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_Views_css_header_css__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_Views_css_header_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_Views_css_header_css__);















//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











__WEBPACK_IMPORTED_MODULE_12_vue__["default"].prototype.$confirm = __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_message_box___default.a.confirm;


__WEBPACK_IMPORTED_MODULE_12_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_19_vue_meta__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_12_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_cascader___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_dropdown___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_dropdown_menu___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_dropdown_item___default.a);
var userUrl = __WEBPACK_IMPORTED_MODULE_17_Constans__["a" /* default */].AllUrl.url.dev;
var goLinkUrl = __WEBPACK_IMPORTED_MODULE_17_Constans__["a" /* default */].UrlLink.goLink.header;
var goLinkeKey = __WEBPACK_IMPORTED_MODULE_17_Constans__["a" /* default */].UrlLink.getUrlKey();

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'myHeader',
  data: function data() {
    return {
      useLanguage: ['简体中文', '繁體中文', 'English'],
      currUseLanguage: '简体中文', //当前用户语言
      simplifyLanguage: ['简体中文', '繁體中文', 'English'],
      traditionalLanguage: ['简体中文', '繁體中文', 'English'],
      englishLanguage: ['简体中文', '繁體中文', 'English'],
      loginShow: false, //登录框是否显示
      layShow: false, //蒙层是否显示
      msglay: false, //从子组件<lay>收到的值
      msglogin: false, //从子组件<login>收到的值
      islogin: false, //判断是否登录
      user_id: __WEBPACK_IMPORTED_MODULE_11_Common_cookie__["a" /* default */].getCookie("lespark_user_id"),
      token: __WEBPACK_IMPORTED_MODULE_11_Common_cookie__["a" /* default */].getCookie("lespark_token") || "",
      avatar: '',
      lgid: __WEBPACK_IMPORTED_MODULE_11_Common_cookie__["a" /* default */].getCookie('lgid') != '' ? __WEBPACK_IMPORTED_MODULE_11_Common_cookie__["a" /* default */].getCookie('lgid') : '',
      nickname: '',
      chaneMode: false,
      author_live: null,
      language: '',
      htmlLang: '',
      options: []
    };
  },

  components: {
    login: __WEBPACK_IMPORTED_MODULE_14_Views_components_login__["a" /* default */],
    lay: __WEBPACK_IMPORTED_MODULE_15_Views_components_lay__["a" /* default */]
  },
  props: {
    color: {
      type: String,
      default: '#fff'
    },
    pageName: {
      type: String,
      default: ''
    }
  },
  metaInfo: function metaInfo() {
    return {
      htmlAttrs: {
        lang: this.htmlLang
        // amp: true
      }
    };
  },
  created: function created() {
    var that = this;
    var _arg = __WEBPACK_IMPORTED_MODULE_13_Common_util__["a" /* default */].getQueryStringArgs();
    if (_arg.lang == 'zh-Hans-TW') {
      that.language = '简体中文';
    } else if (_arg.lang == 'zh-Hant-TW') {
      that.language = '繁體中文';
    } else if (_arg.lang == 'en') {
      that.language = 'English';
    } else {
      that.language = __WEBPACK_IMPORTED_MODULE_11_Common_cookie__["a" /* default */].getCookie('language') || __WEBPACK_IMPORTED_MODULE_13_Common_util__["a" /* default */].getLang();
    }
    if (that.language == '简体中文' || that.language == 'cn') {
      that.$i18n.locale = 'zh';
      that.chaneMode = false;
      that.currUseLanguage = '简体中文';
      __WEBPACK_IMPORTED_MODULE_18_Common_events_bus__["a" /* default */].$emit('CL', 'CL_zh');
      __WEBPACK_IMPORTED_MODULE_11_Common_cookie__["a" /* default */].setCookie('language', '简体中文');
      that.htmlLang = 'zh-Hans-TW';
    } else if (that.language == '繁體中文' || that.language == 'tw') {
      that.$i18n.locale = 'zh-f';
      that.chaneMode = false;
      that.currUseLanguage = '繁體中文';
      __WEBPACK_IMPORTED_MODULE_18_Common_events_bus__["a" /* default */].$emit('CL', 'CL_zh_f');
      __WEBPACK_IMPORTED_MODULE_11_Common_cookie__["a" /* default */].setCookie('language', '繁體中文');
      that.htmlLang = 'zh-Hant-TW';
    } else {
      that.$i18n.locale = 'en';
      that.chaneMode = true;
      that.currUseLanguage = 'English';
      __WEBPACK_IMPORTED_MODULE_18_Common_events_bus__["a" /* default */].$emit('CL', 'CL_en');
      __WEBPACK_IMPORTED_MODULE_11_Common_cookie__["a" /* default */].setCookie('language', 'English');
      that.htmlLang = 'en';
    }
    var urlError = __WEBPACK_IMPORTED_MODULE_13_Common_util__["a" /* default */].getQueryString('error') != '' ? __WEBPACK_IMPORTED_MODULE_13_Common_util__["a" /* default */].getQueryString('error') : '';
    var user_id = __WEBPACK_IMPORTED_MODULE_11_Common_cookie__["a" /* default */].getCookie("lespark_user_id");
    var token = __WEBPACK_IMPORTED_MODULE_11_Common_cookie__["a" /* default */].getCookie("lespark_token") || '';
    var source = __WEBPACK_IMPORTED_MODULE_13_Common_util__["a" /* default */].getQueryString('source') != '' ? __WEBPACK_IMPORTED_MODULE_13_Common_util__["a" /* default */].getQueryString('source') : '';

    __WEBPACK_IMPORTED_MODULE_11_Common_cookie__["a" /* default */].setCookie('source', source);
    if (urlError != '') {
      alert('urlError');
    }
    __WEBPACK_IMPORTED_MODULE_16_Common_ajax__["a" /* default */].getAllData({
      url: userUrl + '/pc_index',
      headers: {
        bundle_id: 'pc',
        'bundle-id': 'pc',
        lang: 'zh-hans',
        user_id: user_id,
        token: token
      },
      params: {
        source: source
      }
    }).then(function (allData) {
      var ref = allData.data;
      that.isbot = allData.headers.from_spider || '';
      that.showMask();
      if (ref.msg == 'ok' && ref.error == 0) {
        if (ref.hasOwnProperty('data') && ref.data.hasOwnProperty('lgid')) {
          that.avatar = ref.data.avatar;
          that.lgid = ref.data.lgid;
          that.nickname = ref.data.nickname;
          that.user_id = user_id;
          that.token = token;
          __WEBPACK_IMPORTED_MODULE_11_Common_cookie__["a" /* default */].setCookie('avatar', ref.data.avatar);
          __WEBPACK_IMPORTED_MODULE_11_Common_cookie__["a" /* default */].setCookie('lgid', ref.data.lgid);
          __WEBPACK_IMPORTED_MODULE_11_Common_cookie__["a" /* default */].setCookie('nickname', ref.data.nickname);
          __WEBPACK_IMPORTED_MODULE_11_Common_cookie__["a" /* default */].setCookie('lespark_token', token);
          __WEBPACK_IMPORTED_MODULE_11_Common_cookie__["a" /* default */].setCookie('lespark_user_id', user_id);
          that.islogin = true;
          __WEBPACK_IMPORTED_MODULE_18_Common_events_bus__["a" /* default */].$emit('userLogin', 'userLogin');
        } else {
          __WEBPACK_IMPORTED_MODULE_11_Common_cookie__["a" /* default */].setCookie('lespark_token', '');
          __WEBPACK_IMPORTED_MODULE_11_Common_cookie__["a" /* default */].setCookie('lespark_user_id', '');
          __WEBPACK_IMPORTED_MODULE_11_Common_cookie__["a" /* default */].setCookie('lgid', '');
          __WEBPACK_IMPORTED_MODULE_11_Common_cookie__["a" /* default */].setCookie('avatar', '');
          __WEBPACK_IMPORTED_MODULE_11_Common_cookie__["a" /* default */].setCookie('nickname', '');
          that.islogin = false;
        }

        var qr_img_url = ref.data.qr_img_url;
        var ios_url = ref.data.ios_url;
        var android_url = ref.data.android_url;
        var google_url = ref.data.google_url;
        var url = {};

        url = {
          'android_url': android_url,
          'google_url': google_url,
          'ios_url': ios_url,
          'qr_img_url': qr_img_url
        };

        if (ref.data.android_url != '' || ref.data.android_url != undefined) {
          __WEBPACK_IMPORTED_MODULE_18_Common_events_bus__["a" /* default */].$emit('url', url);
          __WEBPACK_IMPORTED_MODULE_18_Common_events_bus__["a" /* default */].$emit('regUrl', qr_img_url);
        }
      }
    }).catch(function (ref) {
      __WEBPACK_IMPORTED_MODULE_11_Common_cookie__["a" /* default */].setCookie('lespark_token', '');
      __WEBPACK_IMPORTED_MODULE_11_Common_cookie__["a" /* default */].setCookie('lespark_user_id', '');
      __WEBPACK_IMPORTED_MODULE_11_Common_cookie__["a" /* default */].setCookie('lgid', '');
      __WEBPACK_IMPORTED_MODULE_11_Common_cookie__["a" /* default */].setCookie('avatar', '');
      __WEBPACK_IMPORTED_MODULE_11_Common_cookie__["a" /* default */].setCookie('nickname', '');
      that.islogin = false;
    });
  },
  mounted: function mounted() {
    var that = this;
    var _ = this;
    _.$bus.on('noLoginInfo', function (res) {
      _.appear();
    });
    _.$bus.on('quit', function (res) {
      _.quit();
    });
    var lespark_user_id = '{{ user_id }}' || null;
    var lespark_token = '{{ token }}' || null;
    if (lespark_user_id && String(lespark_user_id).length == 24) {
      __WEBPACK_IMPORTED_MODULE_11_Common_cookie__["a" /* default */].setCookie('lespark_user_id', lespark_user_id);
    }
    if (lespark_token && String(lespark_token).length == 32) {
      __WEBPACK_IMPORTED_MODULE_11_Common_cookie__["a" /* default */].setCookie('lespark_token', lespark_token);
    }
    that.options = that.$t('headerOptions');
  },

  methods: {
    closeWebPage: function closeWebPage() {
      if (navigator.userAgent.indexOf("Firefox") > 0) {
        window.location.href = 'about:blank ';
      } else {
        window.opener = null;
        window.open("about:blank", "_top").close();
      }
    },
    handleChange: function handleChange(value) {
      var flag = value[1];
      if (flag == 'pc') {
        //开始pc直播
        window.location.href = '/live_start.html';
      } else {
        window.location.href = goLinkUrl[flag][goLinkeKey];
      }
    },

    //判断条件，询问用户是否男性
    showMask: function showMask() {
      var that = this;
      var _arg = __WEBPACK_IMPORTED_MODULE_13_Common_util__["a" /* default */].getQueryStringArgs();
      if (_arg.login == 'true') {
        //登陆弹窗
        that.appear();
      } else {
        var lespark_female = localStorage.getItem('lespark_female') || '';
        if (!that.isbot && !lespark_female && !__WEBPACK_IMPORTED_MODULE_13_Common_util__["a" /* default */].liveStartisLogin() && !__WEBPACK_IMPORTED_MODULE_13_Common_util__["a" /* default */].isPhantomjs()) {
          this.$confirm('LesPark是一个成年小姐姐专属的社区，暂不对未成年人和男性用户开放，一经发现会进行封号处理哦！', '提示', {
            confirmButtonText: '我是成年小姐姐',
            cancelButtonText: '关闭',
            showClose: false,
            closeOnClickModal: false,
            type: 'warning'
          }).then(function (res) {
            if (res == 'confirm') {
              localStorage.setItem('lespark_female', true);
            } else {
              that.closeWebPage();
            }
          }).catch(function (ref) {
            that.closeWebPage();
          });
        }
      }
    },
    handleCommand: function handleCommand(command) {
      this.changeLanguage(command);
      window.location.href = '?lang=' + command;
    },

    // 切换语言
    changeLanguage: function changeLanguage(value) {
      var that = this;
      var url = window.document.URL;
      var urlNumber = url.indexOf('live.html');
      if (value == 'zh-Hans-TW') {
        that.language = '简体中文';
        if (urlNumber != -1) {
          that.author_live = __WEBPACK_IMPORTED_MODULE_11_Common_cookie__["a" /* default */].getCookie('author_live');
          window.document.title = '“' + that.author_live + "”的直播间 - LesPark 直播";
        }
        __WEBPACK_IMPORTED_MODULE_11_Common_cookie__["a" /* default */].setCookie('language', '简体中文');
        that.$i18n.locale = 'zh';
        that.chaneMode = false;
        __WEBPACK_IMPORTED_MODULE_18_Common_events_bus__["a" /* default */].$emit('CL', 'CL_zh');
        that.currUseLanguage = '简体中文';
      } else if (value == 'zh-Hant-TW') {
        that.language = '繁體中文';
        if (urlNumber != -1) {
          that.author_live = __WEBPACK_IMPORTED_MODULE_11_Common_cookie__["a" /* default */].getCookie('author_live');
          window.document.title = '“' + that.author_live + "”的直播间 - LesPark 直播";
        }
        __WEBPACK_IMPORTED_MODULE_11_Common_cookie__["a" /* default */].setCookie('language', '繁體中文');
        that.$i18n.locale = 'zh-f';
        that.chaneMode = false;
        __WEBPACK_IMPORTED_MODULE_18_Common_events_bus__["a" /* default */].$emit('CL', 'CL_zh_f');
        that.currUseLanguage = '繁體中文';
      } else {
        that.language = 'English';
        __WEBPACK_IMPORTED_MODULE_11_Common_cookie__["a" /* default */].setCookie('language', 'English');
        if (urlNumber != -1) {
          that.author_live = __WEBPACK_IMPORTED_MODULE_11_Common_cookie__["a" /* default */].getCookie('author_live');
          window.document.title = '“' + that.author_live + "”的直播间 - LesPark Live";
        }
        that.$i18n.locale = 'en';
        that.chaneMode = true;
        __WEBPACK_IMPORTED_MODULE_18_Common_events_bus__["a" /* default */].$emit('CL', 'CL_en');
        that.currUseLanguage = 'English';
      }
    },


    // 登陆组件出现
    appear: function appear(e) {
      var that = this;
      that.loginShow = true;
      that.layShow = true;
    },

    // 登陆组件消失
    disappear: function disappear() {
      var that = this;
      that.loginShow = false;
      that.layShow = false;
      window.document.body.className = '';
    },

    // 登陆组件出现
    showChange: function showChange(msg) {
      var that = this;
      that.msglogin = msg;
      if (msg == false) {
        that.loginShow = msg;
        that.layShow = msg;
        window.document.body.className = '';
      }
      if (msg == 'islogin') {
        __WEBPACK_IMPORTED_MODULE_18_Common_events_bus__["a" /* default */].$emit('attentionShow', 'headerto');
        __WEBPACK_IMPORTED_MODULE_18_Common_events_bus__["a" /* default */].$emit('userLiveShow', 'headerto');
      }
    },

    // 退出登录
    quit: function quit() {
      var that = this;

      __WEBPACK_IMPORTED_MODULE_16_Common_ajax__["a" /* default */].Post({
        url: userUrl + '/setting/logout',
        headers: {
          user_id: __WEBPACK_IMPORTED_MODULE_11_Common_cookie__["a" /* default */].getCookie("lespark_user_id"),
          token: __WEBPACK_IMPORTED_MODULE_11_Common_cookie__["a" /* default */].getCookie("lespark_token") || "",
          'bundle_id': "pc"
        }
      }).then(function (ref) {
        if (ref.error == 0) {
          __WEBPACK_IMPORTED_MODULE_11_Common_cookie__["a" /* default */].setCookie('lespark_token', '');
          __WEBPACK_IMPORTED_MODULE_11_Common_cookie__["a" /* default */].setCookie('lespark_user_id', '');
          __WEBPACK_IMPORTED_MODULE_11_Common_cookie__["a" /* default */].setCookie('lgid', '');
          __WEBPACK_IMPORTED_MODULE_11_Common_cookie__["a" /* default */].setCookie('avatar', '');
          __WEBPACK_IMPORTED_MODULE_11_Common_cookie__["a" /* default */].setCookie('nickname', '');
          __WEBPACK_IMPORTED_MODULE_11_Common_cookie__["a" /* default */].setCookie('user_id', '');
          __WEBPACK_IMPORTED_MODULE_11_Common_cookie__["a" /* default */].setCookie('token', '');
          that.islogin = false;

          // 关注列表显示
          __WEBPACK_IMPORTED_MODULE_18_Common_events_bus__["a" /* default */].$emit('attentionShow', 'noheaderto');
          __WEBPACK_IMPORTED_MODULE_18_Common_events_bus__["a" /* default */].$emit('userLiveShow', 'noheaderto');

          //退出直播间
          __WEBPACK_IMPORTED_MODULE_18_Common_events_bus__["a" /* default */].$emit('quit', 'quit');

          //退出登录
          __WEBPACK_IMPORTED_MODULE_18_Common_events_bus__["a" /* default */].$emit('userLogOut', false);

          //跳回首页
          location.href = '../index.html';
        } else {}
      }).catch(function (ref) {});
    },

    // 充值
    pay: function pay() {
      window.open('//' + goLinkUrl['pay'][goLinkeKey] + '?language=' + encodeURIComponent(encodeURIComponent(this.language)));
    },
    aboutUS: function aboutUS() {
      window.open('//www.lespark.cn/about_us_cn.html?language=' + encodeURIComponent(encodeURIComponent(this.language)));
    }
  },
  watch: {
    msglogin: function msglogin(newVal, oldVal) {
      if (newVal == 'islogin') {
        this.islogin = true;
        this.loginShow = false;
        this.layShow = false;
        window.document.body.className = '';
      }
      this.msglogin = false;
      this.user_id = __WEBPACK_IMPORTED_MODULE_11_Common_cookie__["a" /* default */].getCookie("lespark_user_id");
      this.token = __WEBPACK_IMPORTED_MODULE_11_Common_cookie__["a" /* default */].getCookie("lespark_token") || "";
      this.lgid = __WEBPACK_IMPORTED_MODULE_11_Common_cookie__["a" /* default */].getCookie('lgid') != '' ? __WEBPACK_IMPORTED_MODULE_11_Common_cookie__["a" /* default */].getCookie('lgid') : '';
      var nickname = __WEBPACK_IMPORTED_MODULE_11_Common_cookie__["a" /* default */].getCookie('nickname') != '' ? __WEBPACK_IMPORTED_MODULE_11_Common_cookie__["a" /* default */].getCookie('nickname') : '';
      var avatar = __WEBPACK_IMPORTED_MODULE_11_Common_cookie__["a" /* default */].getCookie('avatar') != '' ? __WEBPACK_IMPORTED_MODULE_11_Common_cookie__["a" /* default */].getCookie('avatar') : '';
      if (nickname.indexOf("\"") == 0) {
        this.nickname = nickname.slice(1, nickname.length - 1);
      } else {
        this.nickname = nickname;
      }
      if (avatar.indexOf("\"") == 0) {
        this.avatar = avatar.slice(1, avatar.length - 1);
      } else {
        this.avatar = avatar;
      }
    }
  }
});

/***/ }),

/***/ 233:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_md5__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Common_events_bus__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Common_cookie__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Common_ajax__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Constans__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_polyfill__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_es6_promise__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_es6_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_es6_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_i18n__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_Views_css_reset_css__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_Views_css_reset_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_Views_css_reset_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_Views_css_login_css__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_Views_css_login_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_Views_css_login_css__);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














var userUrl = __WEBPACK_IMPORTED_MODULE_5_Constans__["a" /* default */].AllUrl.url.dev;
//应用id
var wx_appid = __WEBPACK_IMPORTED_MODULE_5_Constans__["a" /* default */].AllUrl.appid.wx; //微信appid
var qq_client_id = __WEBPACK_IMPORTED_MODULE_5_Constans__["a" /* default */].AllUrl.appid.qq; //QQ client_id
var xinlang_client_id = __WEBPACK_IMPORTED_MODULE_5_Constans__["a" /* default */].AllUrl.appid.xinlang; //新浪client_id
var facebook_client_id = __WEBPACK_IMPORTED_MODULE_5_Constans__["a" /* default */].AllUrl.appid.facebook; //facebook client_id
var ins_client_id = __WEBPACK_IMPORTED_MODULE_5_Constans__["a" /* default */].AllUrl.appid.ins; //ins client_id
var line_client_id = __WEBPACK_IMPORTED_MODULE_5_Constans__["a" /* default */].AllUrl.appid.line; //line client_id
//回调地址
var wx_redirect_uri = __WEBPACK_IMPORTED_MODULE_5_Constans__["a" /* default */].AllUrl.redirect_uri.wx_url; //微信回调地址
var qq_redirect_uri = __WEBPACK_IMPORTED_MODULE_5_Constans__["a" /* default */].AllUrl.redirect_uri.qq_url; //QQ回调地址
var xinlang_redirect_uri = __WEBPACK_IMPORTED_MODULE_5_Constans__["a" /* default */].AllUrl.redirect_uri.xinlang_url; //新浪回调地址
var facebook_redirect_uri = __WEBPACK_IMPORTED_MODULE_5_Constans__["a" /* default */].AllUrl.redirect_uri.facebook_url; //facebook回调地址
var ins_redirect_uri = __WEBPACK_IMPORTED_MODULE_5_Constans__["a" /* default */].AllUrl.redirect_uri.ins_url; //ins回调地址
var line_redirect_uri = __WEBPACK_IMPORTED_MODULE_5_Constans__["a" /* default */].AllUrl.redirect_uri.line_url; //line回调地址

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_i18n__["a" /* default */]);

var i18n = new __WEBPACK_IMPORTED_MODULE_8_vue_i18n__["a" /* default */]({
  locale: 'zh', // 语言标识
  messages: {
    'zh': __webpack_require__(12),
    'zh_f': __webpack_require__(13),
    'en': __webpack_require__(14)
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'login',
  props: ['msglogin'],
  data: function data() {
    var _ref;

    return _ref = {
      dengluShow: true, //显示登录框
      regShow: false, //显示注册框
      close: 'close', //判断子组件传给父组件的值
      screenHeight: '', //屏幕高度
      nationalCode: '中国（+86）', //国家代码
      log_phone: '', //手机号码
      log_password: '', //密码
      language: __WEBPACK_IMPORTED_MODULE_3_Common_cookie__["a" /* default */].getCookie('language') != '' ? __WEBPACK_IMPORTED_MODULE_3_Common_cookie__["a" /* default */].getCookie('language') : '',

      // 判断其他登录入口
      wx: 'wx',
      qq: 'qq',
      xinlang: 'xinlang',
      facebook: 'facebook',
      ins: 'ins',
      line: 'line',
      avatar: '',

      token: '',
      user_id: '',
      nickname: '',
      lgid: '',

      input1: this.$t('login.input1'),
      input2: this.$t('login.input2'),

      msg: '',
      englishLogin: false

    }, _defineProperty(_ref, 'screenHeight', ''), _defineProperty(_ref, 'screenWidth', ''), _defineProperty(_ref, 'regUrl', ''), _defineProperty(_ref, 'regUrlShow', false), _defineProperty(_ref, 'isLiveRoom', false), _ref;
  },
  created: function created() {
    var that = this;
    that.screenWidth = window.screen.availWidth + 'px';
    that.screenHeight = window.screen.availHeight + 'px';
    if (that.language == 'English') {
      that.englishLogin = true;
    } else {
      that.englishLogin = false;
    }

    var start = that.nationalCode.indexOf('（');
    var end = that.nationalCode.length;
    var answer = that.$t('login.input3') + that.nationalCode.slice(start, end);
    that.nationalCode = answer;
    this.isLiveRoom = window.location.href.includes('/live/');
  },
  mounted: function mounted() {
    var that = this;
    __WEBPACK_IMPORTED_MODULE_2_Common_events_bus__["a" /* default */].$on('CL', function (msg) {
      if (msg == 'CL_en') {
        that.englishLogin = true;
      } else {
        that.englishLogin = false;
      }
      that.msg = msg;
      that.input1 = that.$t('login.input1');
      that.input2 = that.$t('login.input2');
      that.input3 = that.$t('login.input3');
      that.input4 = that.$t('login.input4');

      var start = that.nationalCode.indexOf('（');
      var end = that.nationalCode.length;
      var answer = that.$t('login.input3') + that.nationalCode.slice(start, end);
      that.nationalCode = answer;
    });

    __WEBPACK_IMPORTED_MODULE_2_Common_events_bus__["a" /* default */].$on('regUrl', function (msg) {
      if (msg != '' || msg != undefined) {
        // alert(msg)
        that.regUrl = msg;
        that.regUrlShow = true;
      }
    });
  },

  methods: {
    // 切换登录
    denglu: function denglu() {
      var that = this;
      that.dengluShow = true;
      that.regShow = false;
    },

    // 切换注册
    reg: function reg() {
      var that = this;
      that.dengluShow = false;
      that.regShow = true;
    },

    // 弹框消失
    disappear: function disappear(e) {
      var that = this;
      if (e == 'close') {
        if (this.isLiveRoom) {} else {
          that.$emit("showChanged", false);
        }
      } else if (e == undefined) {
        that.$emit("showChanged", 'islogin');
      }
    },

    // 登录按钮(手机号码登录)
    login: function login() {
      var that = this;

      var start = that.nationalCode.indexOf('（') + 2;
      var end = that.nationalCode.indexOf('）');
      var code = that.nationalCode.slice(start, end);

      // 判断手机号码
      // if(that.log_phone.length<11)
      // {
      // alert('输入号码错误')
      // return
      // }
      // 判断是否有输入密码
      if (that.log_password.length < 1) {
        alert('输入密码错误');
        return;
      }

      var phone = code + that.log_phone;
      var password = __WEBPACK_IMPORTED_MODULE_0_js_md5___default()(that.log_password);

      // 登录请求
      __WEBPACK_IMPORTED_MODULE_4_Common_ajax__["a" /* default */].Post({
        url: userUrl + '/phone_login',
        data: {
          phone: phone,
          password: password,
          verion: 1
        },
        headers: {
          bundle_id: 'pc',
          'bundle-id': 'pc',
          lang: 'zh-hans',
          user_id: __WEBPACK_IMPORTED_MODULE_3_Common_cookie__["a" /* default */].getCookie("lespark_user_id") || "",
          token: __WEBPACK_IMPORTED_MODULE_3_Common_cookie__["a" /* default */].getCookie("lespark_token") || ''
        }
      }).then(function (ref) {
        if (ref.error == 0) {
          __WEBPACK_IMPORTED_MODULE_3_Common_cookie__["a" /* default */].setCookie('lespark_token', ref.data.token);
          __WEBPACK_IMPORTED_MODULE_3_Common_cookie__["a" /* default */].setCookie('lespark_user_id', ref.data.user_id);
          __WEBPACK_IMPORTED_MODULE_3_Common_cookie__["a" /* default */].setCookie('avatar', ref.data.avatar);
          __WEBPACK_IMPORTED_MODULE_3_Common_cookie__["a" /* default */].setCookie('lgid', ref.data.lgid);
          __WEBPACK_IMPORTED_MODULE_3_Common_cookie__["a" /* default */].setCookie('nickname', ref.data.nickname);
          __WEBPACK_IMPORTED_MODULE_3_Common_cookie__["a" /* default */].setCookie('phone', phone);
          that.avatar = ref.data.avatar;
          that.token = ref.data.token;
          that.user_id = ref.data.user_id;
          that.lgid = ref.data.lgid;
          that.nickname = ref.data.nickname;
          that.disappear();
          __WEBPACK_IMPORTED_MODULE_2_Common_events_bus__["a" /* default */].$emit("userLogOut", true);
          if (window.location.pathname.indexOf('index.html') !== -1) {
            // location.href = '../loginhome.html?id=' + ref.data.user_id;
            location.href = '/loginhome/' + ref.data.user_id + '.html';
          } else {
            location.reload();
          }
        }
      }).catch(function (ref) {
        console.log(ref);
        if (ref.hasOwnProperty('msg')) {
          alert(ref.msg);
          return;
        } else if (ref.hasOwnProperty('error')) {
          alert('登陆失败，错误码：' + ref.error + '，请联系客服解决');
          return;
        } else {
          alert('登陆失败' + ref.response.status + ref.response.statusText);
        }
        // console.log('not here!===>',ref)
      });
    },

    //监听enter键
    enter: function enter() {
      var that = this;
      this.login();
    },

    // 其他登录
    otherLog: function otherLog(e) {
      var wayName = e;
      var state = window.location.href;

      // 微信登录
      if (wayName == 'wx') {
        // alert('微信登录')
        self.location.href = 'https://open.weixin.qq.com/connect/qrconnect?appid=' + wx_appid + '&redirect_uri=' + wx_redirect_uri + '&response_type=code&scope=snsapi_login&state=' + state + '#wechat_redirect';
      }

      // QQ登录
      if (wayName == 'qq') {
        // alert('抱歉，本站暂未开放QQ登录！')
        // return
        self.location.href = 'https://graph.qq.com/oauth2.0/authorize?client_id=' + qq_client_id + '&redirect_uri=' + qq_redirect_uri + '&response_type=code&state=' + state;
        // self.location.href = 'https://graph.qq.com/oauth2.0/authorize?client_id='+qq_client_id+'&redirect_uri='+qq_redirect_uri+'&response_type=code'
      }

      // 新浪登录
      if (wayName == 'xinlang') {
        self.location.href = 'https://api.weibo.com/oauth2/authorize?client_id=' + xinlang_client_id + '&response_type=code&redirect_uri=' + xinlang_redirect_uri + '&state=' + state;
      }

      // facebook登录
      if (wayName == 'facebook') {
        // alert('facebook登录')
        var SCOPE = "&scope=email";
        self.location.href = 'https://www.facebook.com/dialog/oauth?client_id=' + facebook_client_id + '&redirect_uri=' + facebook_redirect_uri + '&response_type=code' + SCOPE + '&state=' + state;
      }

      // ins登录
      if (wayName == 'ins') {
        // alert('ins登录')
        self.location.href = 'https://api.instagram.com/oauth/authorize/?client_id=' + ins_client_id + '&redirect_uri=' + ins_redirect_uri + '&response_type=code&state=' + state;
      }

      // twitter登录
      if (wayName == 'line') {
        // alert('line登录')
        self.location.href = 'https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=' + line_client_id + '&redirect_uri=' + line_redirect_uri + '&scope=openid%20profile%20email&nonce=' + '&state=' + state;
      }
    }
  }
});

/***/ }),

/***/ 234:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'lay',
	data: function data() {
		return {
			screenHeight: '',
			screenWidth: ''
		};
	},
	created: function created() {
		var that = this;
		that.screenHeight = window.screen.height + 'px';
		that.screenWidth = window.screen.width + 'px';
	}
});

/***/ }),

/***/ 235:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Common_events_bus__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Constans__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Common_util__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'myFooter',
  data: function data() {
    return {
      logoimg: 'https://static.lespark.cn/pc_img/images/logo.png',
      apple: 'https://static.lespark.cn/pc_img/images/apple.png',
      android: 'https://static.lespark.cn/pc_img/images/android.png',
      google: 'https://static.lespark.cn/pc_img/images/Google.png',
      footImg: 'https://static.lespark.cn/pc_img/images/logo-les.png',
      policeImg: 'https://static.lespark.cn/pc_img/images/icon_police.png',
      url: {
        'android_url': "https://dl.lespark.cn/lespark_android/LesPark-release.apk",
        'google_url': "https://play.google.com/store/apps/details?id=com.redwolfama.peonylespark.gp",
        'ios_url': "https://itunes.apple.com/cn/app/id1329843362?mt=8"
      },
      url_2: {
        'android_url': "https://dl.lespark.cn/lespark_android/LesPark-release.apk",
        'google_url': "https://lespark.onelink.me/DPjM/bi0y8b09",
        'ios_url': "https://lespark.onelink.me/sRtA/2saczuub"
      },
      enCenter: false,
      isShowFootTxt: true,
      lesparkLink: 'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44180202000386',
      lestoryLink: 'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=45050302000153',
      goLinkUrl: __WEBPACK_IMPORTED_MODULE_2_Constans__["a" /* default */].UrlLink.goLink.foot,
      goLinkeKey: __WEBPACK_IMPORTED_MODULE_2_Constans__["a" /* default */].UrlLink.getUrlKey(),
      goLang: 'CN'
    };
  },
  created: function created() {
    var that = this;
    if (window.location.host.includes('lespark.us')) {
      this.isShowFootTxt = false;
    } else {
      this.isShowFootTxt = true;
    }

    var _arg = __WEBPACK_IMPORTED_MODULE_3_Common_util__["a" /* default */].getQueryStringArgs();
    if (_arg.lang == 'zh-Hans-TW') {
      that.goLang = 'TW';
    } else if (_arg.lang == 'zh-Hant-TW') {
      that.goLang = 'CN';
    } else if (_arg.lang == 'en') {
      that.goLang = 'US';
    } else {
      that.goLang = 'US';
    }
  },
  mounted: function mounted() {
    var that = this;
    __WEBPACK_IMPORTED_MODULE_1_Common_events_bus__["a" /* default */].$on('url', function (msg) {
      var url = {};
      url = msg;
      if (url != '') {
        that.url = msg;
      }
    });
  },

  methods: {}
});

/***/ }),

/***/ 237:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_attention_vue__ = __webpack_require__(238);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bf0db3f_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_attention_vue__ = __webpack_require__(587);
function injectStyle (ssrContext) {
  __webpack_require__(586)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3bf0db3f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_attention_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bf0db3f_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_attention_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 238:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_message_box_css__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_message_box_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_message_box_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_message_box__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_message_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_message_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_button_css__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_button__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Common_cookie__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Common_util__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_polyfill__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_es6_promise__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_es6_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_es6_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_Common_ajax__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_Constans__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_Common_events_bus__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_i18n__ = __webpack_require__(11);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













__WEBPACK_IMPORTED_MODULE_13_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14_vue_i18n__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_13_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue__["default"].prototype.$message = __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_message_box___default.a;
__WEBPACK_IMPORTED_MODULE_13_vue__["default"].prototype.$prompt = __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_message_box___default.a.prompt;
var DOMAIN = __WEBPACK_IMPORTED_MODULE_11_Constans__["a" /* default */].APIS.domain;
var userUrl = __WEBPACK_IMPORTED_MODULE_11_Constans__["a" /* default */].AllUrl.url.dev;

var i18n = new __WEBPACK_IMPORTED_MODULE_14_vue_i18n__["a" /* default */]({
  locale: "zh", // 语言标识
  messages: {
    zh: __webpack_require__(12),
    "zh-f": __webpack_require__(13),
    en: __webpack_require__(14)
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "attention",
  data: function data() {
    return {
      token: null,
      uid: null,
      attentionList: "",
      noattention: false, //无关注主播显示
      last_index: "",
      showChang: false,
      aattentionMsg: "",
      onemoregetlist: false,
      onemore: ""
    };
  },

  computed: {},
  mounted: function mounted() {
    var that = this;
    __WEBPACK_IMPORTED_MODULE_12_Common_events_bus__["a" /* default */].$on("lastAttentionShow", function (msg) {
      that.aattentionMsg = msg;
      if (msg == "yes") {
        that.showChang = true;
      } else {
        that.showChang = false;
      }
    });

    // 接受传过来的关注以及取消关注
    // $bus.emit('clickFollow','follow');
    __WEBPACK_IMPORTED_MODULE_12_Common_events_bus__["a" /* default */].$on("clickFollow", function (msg) {
      that.onemore = msg;
      if (msg == "follow") {
        that.onemoregetlist = true;
      } else {
        that.onemoregetlist = false;
      }
    });
  },
  created: function created() {
    this.token = __WEBPACK_IMPORTED_MODULE_5_Common_cookie__["a" /* default */].getCookie("lespark_token") || '';
    this.uid = __WEBPACK_IMPORTED_MODULE_5_Common_cookie__["a" /* default */].getCookie("lespark_user_id");
    if (this.token != "" && this.uid != "") {
      this.showChang = true;
    } else {
      this.showChang = false;
    }
    this.getList();
  },

  methods: {
    toLive: function toLive(lgid, live_id) {
      window.open("/live/" + lgid + ".html", "_blank");
      // window.open('../live.html?id=' + lgid + '&live_id=' +live_id , '_blank');
    },
    getList: function getList() {
      var _this = this;

      if (__WEBPACK_IMPORTED_MODULE_5_Common_cookie__["a" /* default */].getCookie("lespark_token") != "" && __WEBPACK_IMPORTED_MODULE_5_Common_cookie__["a" /* default */].getCookie("lespark_user_id") != "") {
        __WEBPACK_IMPORTED_MODULE_9_Common_ajax__["a" /* default */].Get({
          // url: userUrl + "/user_online_lives?live_view_type="+3+'&_t='+new Date().getTime(),
          url: userUrl + "/pc_user_online_lives?live_view_type=" + 3 + "&_t=" + new Date().getTime(),
          headers: {
            bundle_id: "pc",
            'bundle-id': 'pc',
            lang: "zh-hans",
            token: __WEBPACK_IMPORTED_MODULE_5_Common_cookie__["a" /* default */].getCookie("lespark_token") || "",
            user_id: __WEBPACK_IMPORTED_MODULE_5_Common_cookie__["a" /* default */].getCookie("lespark_user_id") || ''
          }
        }).then(function (ref) {
          var data = ref.data;
          _this.attentionList = data.online_list;
          if (_this.attentionList.length == 0) {
            _this.noattention = false;
          } else {
            _this.noattention = true;
          }
        }).catch(function (ref) {
          console.log(ref);
        });
      }
    }

  },
  watch: {
    showChang: "getList",
    onemoregetlist: "getList"
  }
});

/***/ }),

/***/ 24:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__ = __webpack_require__(227);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d7be6fc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__ = __webpack_require__(580);
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d7be6fc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 25:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_foot_vue__ = __webpack_require__(235);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14eda4e4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_foot_vue__ = __webpack_require__(582);
function injectStyle (ssrContext) {
  __webpack_require__(581)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-14eda4e4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_foot_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14eda4e4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_foot_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 256:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 259:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vant_es_popup_style__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vant_es_popup__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Common_util__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Constans__ = __webpack_require__(5);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vant_es_popup__["a" /* default */]);

var goLinkUrl = __WEBPACK_IMPORTED_MODULE_4_Constans__["a" /* default */].UrlLink.goLink.menu;
var goLinkeKey = __WEBPACK_IMPORTED_MODULE_4_Constans__["a" /* default */].UrlLink.getUrlKey();

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'myMenu',
  props: {
    color: {
      type: String,
      default: '#fff'
    }
  },
  data: function data() {
    return {
      showPopup: false,
      langWindow: __WEBPACK_IMPORTED_MODULE_3_Common_util__["a" /* default */].getLang(),
      goLinkUrl: __WEBPACK_IMPORTED_MODULE_4_Constans__["a" /* default */].UrlLink.goLink.header,
      goLinkeKey: goLinkeKey
    };
  },
  created: function created() {
    if (document.documentElement.clientWidth < 960) {
      if (this.langWindow == 'cn') {
        this.$i18n.locale = 'zh';
      } else if (this.langWindow == 'tw') {
        this.$i18n.locale = 'zh-f';
      } else {
        this.$i18n.locale = 'en';
      }
    }
  },

  methods: {
    // 充值
    rechargeApp: function rechargeApp() {
      var ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        // window.location.href = 'http://wx.lespark.cn/wx/buy_diamonds'
        window.location.href = goLinkUrl['wx_buy_diamonds'][goLinkeKey];
      } else {
        // window.location.href = 'http://api.lespark.cn/pay_web_order'
        window.location.href = goLinkUrl['rechargeApp'][goLinkeKey];
      }
    },

    // VIP
    rechargeVip: function rechargeVip() {
      // window.location.href = 'http://api.lespark.cn/pay_web_order?tab=vip'
      window.location.href = goLinkUrl['rechargeVip'][goLinkeKey];
    },
    goBaiHua: function goBaiHua() {
      // window.location.href = 'http://api.lespark.cn/baihua/index?fromPage=pc'
      window.location.href = goLinkUrl['goBaiHua'][goLinkeKey];
    }
  }
});

/***/ }),

/***/ 260:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_Constans__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Common_util__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'foot',
  data: function data() {
    return {
      goLinkUrl: __WEBPACK_IMPORTED_MODULE_0_Constans__["a" /* default */].UrlLink.goLink.foot,
      goLinkeKey: __WEBPACK_IMPORTED_MODULE_0_Constans__["a" /* default */].UrlLink.getUrlKey(),
      goLang: 'CN',
      isShowFootTxt: true
    };
  },
  created: function created() {
    var _arg = __WEBPACK_IMPORTED_MODULE_1_Common_util__["a" /* default */].getLang();
    if (_arg.lang == 'tw') {
      this.goLang = 'TW';
    } else if (_arg.lang == 'cn') {
      this.goLang = 'CN';
    } else {
      this.goLang = 'US';
    }

    if (window.location.host.includes('lespark.us')) {
      this.isShowFootTxt = false;
    } else {
      this.isShowFootTxt = true;
    }
  },

  methods: {
    // 下载app
    downloadApp: function downloadApp() {
      var uL = navigator.language;
      if (uL == "zh-CN") {
        if (this.isShowFootTxt) {
          window.location.href = "https://go.onelink.me/iAGK/lovepark";
        } else {
          window.location.href = "https://lespark.onelink.me/ewJF/xhb1upr6";
        }
      } else {
        if (this.isShowFootTxt) {
          window.location.href = "https://go.onelink.me/KJsf/lovepark";
        } else {
          window.location.href = "https://lespark.onelink.me/ewJF/xhb1upr6";
        }
      }
    }
  }
});

/***/ }),

/***/ 263:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 265:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 267:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 269:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 279:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_message_box_css__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_message_box_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_message_box_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_message_box__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_message_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_message_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_button_css__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_button__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Common_cookie__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Common_util__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_polyfill__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_es6_promise__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_es6_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_es6_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_Common_ajax__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_Constans__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_Common_events_bus__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_i18n__ = __webpack_require__(11);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













__WEBPACK_IMPORTED_MODULE_13_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14_vue_i18n__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_13_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue__["default"].prototype.$message = __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_message_box___default.a;
__WEBPACK_IMPORTED_MODULE_13_vue__["default"].prototype.$prompt = __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_message_box___default.a.prompt;
var DOMAIN = __WEBPACK_IMPORTED_MODULE_11_Constans__["a" /* default */].APIS.domain;
var userUrl = __WEBPACK_IMPORTED_MODULE_11_Constans__["a" /* default */].AllUrl.url.dev;

var i18n = new __WEBPACK_IMPORTED_MODULE_14_vue_i18n__["a" /* default */]({
  locale: "zh", // 语言标识
  messages: {
    zh: __webpack_require__(12),
    "zh-f": __webpack_require__(13),
    en: __webpack_require__(14)
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "topicb",
  props: {
    ttype: {
      type: String,
      default: '1'
    }
  },
  data: function data() {
    return {
      token: null,
      uid: null,
      attentionList: "",
      noattention: false, //无关注主播显示
      last_index: "",
      showChang: false,
      aattentionMsg: "",
      onemoregetlist: false,
      onemore: ""
    };
  },

  computed: {},
  mounted: function mounted() {
    var that = this;
  },
  created: function created() {
    this.token = __WEBPACK_IMPORTED_MODULE_5_Common_cookie__["a" /* default */].getCookie("lespark_token") || '';
    this.uid = __WEBPACK_IMPORTED_MODULE_5_Common_cookie__["a" /* default */].getCookie("lespark_user_id");
    if (this.token != "" && this.uid != "") {
      this.showChang = true;
    } else {
      this.showChang = false;
    }
    this.getList();
  },

  methods: {
    toLive: function toLive(live_id) {
      window.open("/topic/" + live_id, "_blank");
      // window.open('../topic.html?id=' + live_id, '_blank');
    },
    getList: function getList() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_9_Common_ajax__["a" /* default */].Get({
        // url: userUrl + "/user_online_lives?live_view_type="+3+'&_t='+new Date().getTime(),
        url: userUrl + "/v2/get_hot_tags?_t=" + new Date().getTime(),
        headers: {
          bundle_id: "pc",
          'bundle-id': 'pc',
          lang: "zh-hans",
          token: __WEBPACK_IMPORTED_MODULE_5_Common_cookie__["a" /* default */].getCookie("lespark_token") || "",
          user_id: __WEBPACK_IMPORTED_MODULE_5_Common_cookie__["a" /* default */].getCookie("lespark_user_id") || ''
        }
      }).then(function (ref) {
        var data = ref.data;
        _this.attentionList = data.tags || [];
        // this.attentionList = [
        //   { avatar: "http://img2.lespark.cn/aliclient86YzhEvAsVNucKtDjBYO", description: "🌟四月之星", is_live: false, nickname: "20077人参与", user_id: "5a02978ca2e3a95a4e738f11" },
        //   { avatar: "http://img2.lespark.cn/aliclient86YzhEvAsVNucKtDjBYO", description: "🌟四月之星", is_live: false, nickname: "20077人参与", user_id: "5a02978ca2e3a95a4e738f11" },
        //   { avatar: "http://img2.lespark.cn/aliclient86YzhEvAsVNucKtDjBYO", description: "🌟四月之星", is_live: false, nickname: "20077人参与", user_id: "5a02978ca2e3a95a4e738f11" },
        //   { avatar: "http://img2.lespark.cn/aliclient86YzhEvAsVNucKtDjBYO", description: "🌟四月之星", is_live: false, nickname: "20077人参与", user_id: "5a02978ca2e3a95a4e738f11" },
        //   { avatar: "http://img2.lespark.cn/aliclient86YzhEvAsVNucKtDjBYO", description: "🌟四月之星", is_live: false, nickname: "20077人参与", user_id: "5a02978ca2e3a95a4e738f11" },
        //   { avatar: "http://img2.lespark.cn/aliclient86YzhEvAsVNucKtDjBYO", description: "🌟四月之星", is_live: false, nickname: "20077人参与", user_id: "5a02978ca2e3a95a4e738f11" },
        // ];
        if (_this.attentionList.length == 0) {
          _this.noattention = false;
        } else {
          _this.noattention = true;
        }
      }).catch(function (ref) {
        console.log(ref);
      });
    }

  }
  // watch: {
  //   showChang: "getList",
  //   onemoregetlist: "getList"
  // }
});

/***/ }),

/***/ 280:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_message_box_css__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_message_box_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_message_box_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_message_box__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_message_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_message_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_tag_css__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_tag_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_tag_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_tag__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_badge_css__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_badge_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_badge_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_badge__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_badge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_badge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_input_css__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_image_css__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_image_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_image_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_image__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_col_css__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_col_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_col_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_col__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_row_css__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_row_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_row_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_row__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_button_css__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_button__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_Common_cookie__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_Common_util__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_babel_polyfill__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_es6_promise__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_es6_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_es6_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_Common_ajax__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_axios__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_Constans__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_Common_events_bus__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vue_i18n__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_vue_video_player__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_vue_video_player___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_vue_video_player__);

























function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











// import imglike from "Views/images/like.png";
// import imgliked from "Views/images/liked.png";


__webpack_require__(281);
__webpack_require__(166);

__WEBPACK_IMPORTED_MODULE_25_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_26_vue_i18n__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_25_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_25_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_row___default.a);
__WEBPACK_IMPORTED_MODULE_25_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_col___default.a);
__WEBPACK_IMPORTED_MODULE_25_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_image___default.a);
__WEBPACK_IMPORTED_MODULE_25_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_25_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_badge___default.a);
__WEBPACK_IMPORTED_MODULE_25_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_tag___default.a);
__WEBPACK_IMPORTED_MODULE_25_vue__["default"].prototype.$message = __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_message_box___default.a;
__WEBPACK_IMPORTED_MODULE_25_vue__["default"].prototype.$prompt = __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_message_box___default.a.prompt;
var DOMAIN = __WEBPACK_IMPORTED_MODULE_23_Constans__["a" /* default */].APIS.domain;
var userUrl = __WEBPACK_IMPORTED_MODULE_23_Constans__["a" /* default */].AllUrl.url.dev;

var _ctList = [];

var i18n = new __WEBPACK_IMPORTED_MODULE_26_vue_i18n__["a" /* default */]({
  locale: "zh", // 语言标识
  messages: {
    zh: __webpack_require__(12),
    "zh-f": __webpack_require__(13),
    en: __webpack_require__(14)
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "topicitem",
  components: {
    videoPlayer: __WEBPACK_IMPORTED_MODULE_27_vue_video_player__["videoPlayer"]
  },
  filters: {
    format: function format(v) {
      var timeDistance = (new Date().getTime() - new Date(parseInt(v) * 1000).getTime()) / 1000;
      if (timeDistance / 60 < 1) {
        return "1\u5206\u949F\u524D";
      } else if (timeDistance / 60 < 60) {
        return Math.floor(timeDistance / 60) + "\u5206\u949F\u524D";
      } else if (timeDistance / 60 / 60 < 24) {
        return Math.floor(timeDistance / 60 / 60) + "\u5C0F\u65F6\u524D";
      } else if (timeDistance / 60 / 60 / 24 < 30) {
        return Math.floor(timeDistance / 60 / 60 / 24) + "\u5929\u524D";
      } else if (timeDistance / 60 / 60 / 24 / 30 < 12) {
        return Math.floor(timeDistance / 60 / 60 / 24 / 30) + "\u6708\u524D";
      } else {
        return Math.floor(timeDistance / 60 / 60 / 24 / 30 / 12) + "\u5E74\u524D";
      }
    }
  },
  props: {
    topicinfo: {
      type: Object
    }
  },
  data: function data() {
    return {
      token: null,
      uid: null,
      useravatar: '',
      contentIsLong: false,
      contentAllShow: false,
      commentsAllShow: false,
      commentsInput: '',
      isLike: false,
      commentslist: [],
      replyid: '',
      replyname: '',
      commentsindex: -1,
      commentscount: 0,
      isallc: false,
      isPhantomjs: false, //是否服务端渲染
      videowidth: 500,
      videoHeight: 300,
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        // preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "简体中文",
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          type: "video/mp4", //这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
          src: "" //url地址
        }],
        poster: "", //你的封面地址
        // width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true //全屏按钮
        }
      },
      contentTopArray: [] // 内容中含有话题的列表

    };
  },

  computed: {
    player: function player() {
      return this.$refs.videoPlayer.player;
    },


    getLikeUrl: function getLikeUrl() {
      var _n = 'https://static.lespark.cn/pc_img/images/like.png';
      this.isLike && (_n = 'https://static.lespark.cn/pc_img/images/liked.png');
      return _n;
    }

  },
  mounted: function mounted() {
    var that = this;
  },
  created: function created() {
    this.token = __WEBPACK_IMPORTED_MODULE_17_Common_cookie__["a" /* default */].getCookie("lespark_token") || '';
    this.uid = __WEBPACK_IMPORTED_MODULE_17_Common_cookie__["a" /* default */].getCookie("lespark_user_id");
    this.useravatar = __WEBPACK_IMPORTED_MODULE_17_Common_cookie__["a" /* default */].getCookie("avatar");
    this.isLike = this.topicinfo.liked || false;
    this.commentslist = this.topicinfo.comments_list_new || [];
    this.commentscount = this.topicinfo.comments_count || 0;
    _ctList = [];
    this.isPhantomjs = __WEBPACK_IMPORTED_MODULE_18_Common_util__["a" /* default */].isPhantomjs();
    // if (this.topicinfo.recommend_reason) {
    // }

    // 判断视频逻辑：video_id、video_url、ali_video_id其中一个有值，就是视频帖子。如果有值，都是取video_url的，video_url是播放地址
    if (this.topicinfo.video_id || this.topicinfo.video_url || this.topicinfo.ali_video_id) {
      this.playerOptions.sources[0].src = this.topicinfo.video_url;
    }

    // 模拟置顶
    // this.topicinfo.is_top_post = true;
  },

  methods: {
    getRole: function getRole(_nu) {
      // "new_role": 2,  //性别 0P 1T 2H 3Bi 4不愿透露
      var _n = '';
      _nu === '0' && (_n = 'P');
      _nu === '1' && (_n = 'T');
      _nu === '2' && (_n = 'H');
      _nu === '3' && (_n = 'Bi');
      return _n;
    },
    getRoleColor: function getRoleColor(_nu) {
      // "new_role": 2,  //性别 0P 1T 2H 3Bi 4不愿透露
      var _n = 'success';
      _nu === '0' && (_n = 'success');
      _nu === '1' && (_n = 'primary');
      _nu === '2' && (_n = 'warning');
      _nu === '3' && (_n = 'success');
      return _n;
    },
    gotoUserInfo: function gotoUserInfo() {
      location.href = '../userinfo.html?id=' + this.topicinfo.user_id;
      // location.href = '/userinfo/' +  this.topicinfo.user_id + '.html';
    },

    // 点赞
    btnLike: function btnLike() {
      // if (this.isLike) return;
      // return;
      var _ = this;
      //没登录，弹出登录框
      _.is_login();
      var user_id = __WEBPACK_IMPORTED_MODULE_17_Common_cookie__["a" /* default */].getCookie("lespark_user_id");
      if (user_id == "") {
        _.is_login();
        return;
      }
      //是否有点赞
      var url = userUrl + "/like/" + this.topicinfo.id;

      if (this.isLike) {
        __WEBPACK_IMPORTED_MODULE_21_Common_ajax__["a" /* default */].Delete({
          url: url,

          headers: {
            bundle_id: "com.redwolfama.peonylespark",
            'bundle-id': 'com.redwolfama.peonylespark',
            version: '7.9.2',
            lang: "zh-hans",
            token: __WEBPACK_IMPORTED_MODULE_17_Common_cookie__["a" /* default */].getCookie("lespark_token"),
            user_id: __WEBPACK_IMPORTED_MODULE_17_Common_cookie__["a" /* default */].getCookie("lespark_user_id")
          }
        }).then(function (res) {
          _.isLike = false;
          _.topicinfo.like--;
          var _fdata = _.topicinfo.like_list_to_return.filter(function (_item) {
            return _item.user_id !== user_id;
          });
          // _.topicinfo.like_list_to_return.push({ 'id': user_id, 'avatar': cookie.getCookie("avatar") || '' });
          _.topicinfo.like_list_to_return = _fdata;
        }).catch(function (error) {});
      } else {
        __WEBPACK_IMPORTED_MODULE_21_Common_ajax__["a" /* default */].Post({
          url: url,
          data: {
            "action_type": "like", //固定参数
            "source": 3, //固定参数
            "time": Math.random()
          },
          headers: {
            bundle_id: "com.redwolfama.peonylespark",
            'bundle-id': 'com.redwolfama.peonylespark',
            version: '7.9.2',
            lang: "zh-hans",
            token: __WEBPACK_IMPORTED_MODULE_17_Common_cookie__["a" /* default */].getCookie("lespark_token"),
            user_id: __WEBPACK_IMPORTED_MODULE_17_Common_cookie__["a" /* default */].getCookie("lespark_user_id"),
            // token: "8e56647f892c0a42d0e215cdb1f29e2d",
            // user_id: "5ba06ceed3b46465cc2130f8",
            "content-type": "application/x-www-form-urlencoded"
          }
        }).then(function (res) {
          _.isLike = true;
          _.topicinfo.like++;
          _.topicinfo.like_list_to_return.unshift({ 'id': user_id, 'user_id': user_id, 'avatar': __WEBPACK_IMPORTED_MODULE_17_Common_cookie__["a" /* default */].getCookie("avatar") || '' });
        }).catch(function (error) {});
      }
    },


    //是否登录
    is_login: function is_login() {
      var _ = this;
      var token = __WEBPACK_IMPORTED_MODULE_17_Common_cookie__["a" /* default */].getCookie("lespark_token");
      var user_id = __WEBPACK_IMPORTED_MODULE_17_Common_cookie__["a" /* default */].getCookie("lespark_user_id");
      if (token == null || token == "") {
        _.$bus.emit("noLoginInfo", true);
      }
      if (user_id == null || user_id == "") {
        _.$bus.emit("noLoginInfo", true);
      }
    },
    getShowAllComments: function getShowAllComments(_l) {
      if (!this.commentsAllShow && _l > 1) {
        return false;
      } else {
        return true;
      }
    },
    showAllComments: function showAllComments() {
      this.commentsAllShow = !this.commentsAllShow;
    },
    itemBackComments: function itemBackComments(_item) {
      this.replyid = _item.user_id;
      this.commentsindex = _item.comments_index;
      this.replyname = _item.nickname;
    },
    closeReply: function closeReply() {
      this.replyid = "";
      this.replyname = "";
      this.commentsindex = -1;
    },

    // 评论
    btnBackComments: function btnBackComments() {
      if (this.commentsInput === '') return;
      // return;
      var _ = this;
      //没登录，弹出登录框
      _.is_login();
      var user_id = __WEBPACK_IMPORTED_MODULE_17_Common_cookie__["a" /* default */].getCookie("lespark_user_id");
      if (user_id == "") {
        _.is_login();
        return;
      }

      var url = userUrl + "/comments";
      var _pr = {
        "comments": _.commentsInput, //评论内容
        "post_id": _.topicinfo.id, //评论的帖子id
        // "reply_id": "5d393775a19ea613b5d6e56c", //回复的用户id
        // "previous_index": "4",  //回复的评论的下标
        "time": Math.random()
      };
      _.replyid && (_pr.reply_id = _.replyid, _pr.previous_index = _.commentsindex);
      __WEBPACK_IMPORTED_MODULE_21_Common_ajax__["a" /* default */].Post({
        url: url,
        data: _pr,
        headers: {
          bundle_id: "pc",
          'bundle-id': 'pc',
          lang: "zh-hans",
          token: __WEBPACK_IMPORTED_MODULE_17_Common_cookie__["a" /* default */].getCookie("lespark_token"),
          user_id: __WEBPACK_IMPORTED_MODULE_17_Common_cookie__["a" /* default */].getCookie("lespark_user_id"),
          // token: "8e56647f892c0a42d0e215cdb1f29e2d",
          // user_id: "5ba06ceed3b46465cc2130f8",
          "content-type": "application/x-www-form-urlencoded"
        }
      }).then(function (res) {
        if (res.error === 0) {
          _.commentsInput = "";
          _.commentslist = [].concat(_toConsumableArray(_.commentslist), [res.data]);
          _.commentscount = _.commentscount + 1;
        }
      }).catch(function (error) {});
    },

    // 获取更多评论
    showAllComments2: function showAllComments2() {
      var _ = this;
      _.commentsAllShow = true;
      if (_.commentscount < 10) return;
      //没登录，弹出登录框
      _.is_login();
      var user_id = __WEBPACK_IMPORTED_MODULE_17_Common_cookie__["a" /* default */].getCookie("lespark_user_id");
      if (user_id == "") {
        _.is_login();
        return;
      }
      //是否有点赞
      __WEBPACK_IMPORTED_MODULE_21_Common_ajax__["a" /* default */].Get({
        url: userUrl + "/comments/" + _.topicinfo.id + "?_t=" + new Date().getTime(),
        headers: {
          bundle_id: "pc",
          'bundle-id': 'pc',
          lang: "zh-hans",
          token: __WEBPACK_IMPORTED_MODULE_17_Common_cookie__["a" /* default */].getCookie("lespark_token") || "",
          user_id: __WEBPACK_IMPORTED_MODULE_17_Common_cookie__["a" /* default */].getCookie("lespark_user_id") || ''
        }
      }).then(function (ref) {
        var data = ref.data;
        _.commentslist = data.info;
        _.isallc = true;
      }).catch(function (ref) {
        console.log(ref);
      });
    },
    playerReadied: function playerReadied(player) {},


    //转换类容用户名
    tcReplaceContent: function tcReplaceContent(_text, _uid, _uname) {
      if (!_text) return;
      var _txt = ' target="_blank"';
      var s = _text.replace(_uid, function (a) {
        // return '<a href="/userinfo/' + a + '.html' + _txt + '  onclick="(function(event) { event.stopPropagation(); })" >' + _uname + '</a>';
        return '<a href="/userinfo.html?id' + a + '"' + _txt + '  onclick="(function(event) { event.stopPropagation(); })" >' + _uname + '</a>';
      });
      return s;
    },

    //转换类容话题
    tcReplaceContentTop: function tcReplaceContentTop(_text) {
      if (!_text) return;
      var _newhtml = _text;
      this.getContTopArr(_text);
      if (_ctList.length) {
        _ctList.map(function (_item, _idx) {
          if (_newhtml.indexOf(_item) !== -1) {
            var _target = ' target="_blank"';
            _newhtml = _newhtml.replace("#" + _item + "#", function (a) {
              return '<a href="/topic/' + _item + '" ' + _target + '  onclick="(function(event) { event.stopPropagation(); })" style="color: #008ee5;" >' + a + '</a>';
            });
          }
        });
      }

      return _newhtml;
    },
    getContTopArr: function getContTopArr(_text) {
      var _oldhtml = '';
      var t_first_character = _text.indexOf('#');
      var t_second_character = _text.replace('#', '@').indexOf('#');
      var _txt = _text.substring(t_first_character + 1, t_second_character);

      if (_txt && _txt.indexOf('\n') < 0 && _txt.indexOf('#') < 0) {
        _ctList = [].concat(_toConsumableArray(_ctList), [_txt]);

        _oldhtml = _text.substring(t_second_character + 1);
        _oldhtml && this.getContTopArr(_oldhtml);
      }
    },
    contentShowAll: function contentShowAll() {
      this.contentAllShow = !this.contentAllShow;
    },
    getContentHtml: function getContentHtml(_cont) {
      var _this = this;

      var _html = this.getTxtLength(_cont);
      if (this.topicinfo.friends_id.length > 0) {
        this.topicinfo.friends_id.map(function (_item, _idx) {
          if (_html.indexOf(_item) !== -1) {
            _html = _this.tcReplaceContent(_html, _item, _this.topicinfo.friends_nickname[_idx]);
          }
        });
      }
      _html = this.tcReplaceContentTop(_html);
      return _html;
    },
    getTxtLength: function getTxtLength(_t) {
      var _lenghtcount = 0,
          _isno = true;
      var _txt = '';
      for (var i = 0; i < _t.length; i++) {
        if (_isno) {
          if (_t.charCodeAt(i) > 128) {
            _lenghtcount = _lenghtcount + 2;
          } else {
            _lenghtcount = _lenghtcount + 1;
          }
          if (_lenghtcount >= 240 && !this.contentAllShow) {
            _txt = _txt + '...';
            _isno = false;
            this.contentIsLong = true;
          } else {
            _txt = _txt + _t[i];
          }
        };
      }
      return _txt;
    },
    getCol: function getCol(_idx) {
      var _n = 12;
      switch (this.topicinfo.pics.length) {
        case 1:
          _n = 14;
          break;
        case 2:
          _n = 12;
          break;
        case 3:
          _n = 8;
          break;
        case 4:
          _n = 6;
          break;
        case 5:
          _idx === 0 || _idx === 1 ? _n = 12 : _n = 8;
          break;
        case 6:
          _n = 8;
        case 7:
          _idx === 0 || _idx === 1 || _idx === 2 ? _n = 8 : _n = 6;
          break;
        case 8:
          _n = 6;
          break;
        case 9:
          _n = 8;
          break;
        default:
          _n = 6;
          break;
      }
      // this.topicinfo.pics.length === 3 && (_n = 8);
      // this.topicinfo.pics.length >= 4 && (_n = 6);
      return _n;
    },
    getScope: function getScope() {
      // scope  （0是所有人，1是好友，2是我自己，3是24小时，4是情侣，5是粉丝）
      var _n = '';
      switch (this.topicinfo.scope) {
        case 0:
          _n = '所有人';
          break;
        case 1:
          _n = '好友';
          break;
        case 2:
          _n = '自己';
          break;
        case 3:
          _n = '24小时';
          break;
        case 4:
          _n = '情侣';
          break;
        case 5:
          _n = '粉丝';
          break;

      }
      // this.topicinfo.pics.length === 3 && (_n = 8);
      // this.topicinfo.pics.length >= 4 && (_n = 6);
      return _n;
    },
    getUserInfoTxt: function getUserInfoTxt() {
      // <span>{{getScope()}}</span>
      //     <span v-if="topicinfo.recommend_reason">{{topicinfo.recommend_reason||''}}</span>
      //     <span v-if="topicinfo.source==1">{{'来自情侣空间'}}</span>
      // 共用一个逻辑：就是遍历的时候判断user_id，如果是自己，就处理scope 和 source 和 recommend_reason，如果不是自己，就只处理source 和 recommend_reason
      var user_id = __WEBPACK_IMPORTED_MODULE_17_Common_cookie__["a" /* default */].getCookie("lespark_user_id");
      var _txt = '';
      if (this.topicinfo.user_id == user_id) {
        _txt = this.getScope();
        this.topicinfo.source == 1 && (_txt = _txt + ' 来自情侣空间');
        this.topicinfo.recommend_reason && (_txt = _txt + ' ' + this.topicinfo.recommend_reason);
      } else {
        this.topicinfo.source == 1 && (_txt = _txt + ' 来自情侣空间');
        this.topicinfo.recommend_reason && (_txt = _txt + ' ' + this.topicinfo.recommend_reason);
      }
      return _txt;
    }
  }

});

/***/ }),

/***/ 281:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 30:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]());

/***/ }),

/***/ 300:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_image_css__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_image_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_image_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_image__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_button_css__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_button__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_input_css__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_dialog_css__ = __webpack_require__(757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_dialog_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_dialog_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_dialog__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_Constans__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_Common_cookie__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_Common_ajax__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_country_intl__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_country_intl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_country_intl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_country_intl_lib_vue_country_intl_css__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_country_intl_lib_vue_country_intl_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_country_intl_lib_vue_country_intl_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_country_intl_src_components_vue_country_intl_data__ = __webpack_require__(761);












//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






// import facebookIcon from '../images/fb.png';
// import qqIcon from '../images/qq.png';
// import weixinIcon from '../images/weixin.png';





var userUrl = __WEBPACK_IMPORTED_MODULE_10_Constans__["a" /* default */].AllUrl.url.dev;
//应用id
var wx_appid = __WEBPACK_IMPORTED_MODULE_10_Constans__["a" /* default */].AllUrl.appid.wx; //微信appid
var qq_client_id = __WEBPACK_IMPORTED_MODULE_10_Constans__["a" /* default */].AllUrl.appid.qq; //QQ client_id
var facebook_client_id = __WEBPACK_IMPORTED_MODULE_10_Constans__["a" /* default */].AllUrl.appid.facebook; //facebook client_id
//回调地址
var wx_redirect_uri = __WEBPACK_IMPORTED_MODULE_10_Constans__["a" /* default */].AllUrl.redirect_uri.wx_url; //微信回调地址
var qq_redirect_uri = __WEBPACK_IMPORTED_MODULE_10_Constans__["a" /* default */].AllUrl.redirect_uri.qq_url; //QQ回调地址
var facebook_redirect_uri = __WEBPACK_IMPORTED_MODULE_10_Constans__["a" /* default */].AllUrl.redirect_uri.facebook_url; //facebook回调地址

// Vue.use(VueI18n)
__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_dialog___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_vue_country_intl___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'login',
  components: {
    elDialog: __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_dialog___default.a,
    elInput: __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_input___default.a,
    Button: __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_button___default.a,
    elImage: __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_image___default.a,
    VueCountryIntl: __WEBPACK_IMPORTED_MODULE_13_vue_country_intl___default.a
  },
  props: {},
  data: function data() {
    return {
      visible: false,
      phoneErrMsg: '',
      errMsg: '',
      isZh: false,
      form: {
        phone: '',
        code: '',
        nationalCode: '86', //手机区号
        verifyCode: ''
      },
      iso2: 'cn',
      codeModalStatus: false,
      sendCodeText: this.$t('mobile_login.sendCode'),
      sendCodeDisable: false,
      countDownTimer: null,
      facebookIcon: 'https://static.lespark.cn/pc_img/images/fb.png',
      qqIcon: 'https://static.lespark.cn/pc_img/images/qq.png',
      weixinIcon: 'https://static.lespark.cn/pc_img/images/weixin.png',
      refId: '',
      registered: true,
      goLinkUrl: __WEBPACK_IMPORTED_MODULE_10_Constans__["a" /* default */].UrlLink.goLink.mobileLogin,
      goLinkeKey: __WEBPACK_IMPORTED_MODULE_10_Constans__["a" /* default */].UrlLink.getUrlKey()
    };
  },
  created: function created() {
    var lanMap = {
      'zh-cn': 'cn',
      'en-us': 'us',
      'zh-tw': 'tw',
      'zh-hk': 'hk',
      'zh-mo': 'mo', //澳门
      'th': 'th', //泰国
      'ms': 'my', //马来西亚
      'ms-my': 'my', //马来西亚
      'en-my': 'my', //马来西亚
      'en-sg': 'sg', //新加坡
      'zh-sg': 'sg', //新加坡
      'ja': 'jp', //日本
      'ko': 'kr', //韩国
      'ko-kr': 'kr', //韩国
      'en-au': 'au', //澳大利亚
      'en-gb': 'gb', //英国
      'en-gb-oxendict': 'gb', //英国
      'fil': 'ph', //菲律宾
      'vi': 'vn' //越南
    };
    var country = __WEBPACK_IMPORTED_MODULE_15_vue_country_intl_src_components_vue_country_intl_data__["a" /* countriesData */].find(function (item) {
      return item.iso2 == lanMap[(window.navigator.language || window.navigator.userLanguage).toLowerCase()];
    });
    if (country) {
      this.form.nationalCode = country.dialCode;
      this.iso2 = country.iso2;
    }

    var _lan = window.navigator.language.toLowerCase();
    if (_lan.startsWith('zh-')) {
      this.isZh = true;
    } else {
      this.isZh = false;
    }

    // this.showLogin()
  },
  mounted: function mounted() {},

  methods: {
    //发送验证码
    sendCode: function sendCode() {
      if (this.sendCodeDisable) {
        return;
      }
      if (this.validPhone()) {
        this.sendCodeDisable = true;
        this.getVerifyCode();
      }
    },
    nationalCode: function nationalCode() {
      this.codeModalStatus = true;
    },
    countDown: function countDown() {
      var _this = this;

      var delay = 60;
      var text = this.sendCodeText;
      this.sendCodeText = this.$t('mobile_login.resendCode') + ('(' + delay + ')');
      this.countDownTimer = setInterval(function () {
        if (delay <= 1) {
          _this.resetSendCodeBtn();
        } else {
          _this.sendCodeText = _this.$t('mobile_login.resendCode') + ('(' + --delay + ')');
        }
      }, 1e3);
    },

    //调用发送验证码接口
    getVerifyCode: function getVerifyCode() {
      var _this2 = this;

      try {
        __WEBPACK_IMPORTED_MODULE_12_Common_ajax__["a" /* default */].Get({
          url: userUrl + '/v2/verify_code',
          params: {
            phone_number: '' + this.form.nationalCode + this.form.phone,
            source: 'h5_register',
            code_type: 0
          }
          /* mock: {
            "msg": "Verification code is  sent",
            "data": {
              "token": null,
              "user_id": "61a71fe74df379171dd02ae9",
              "reference_id": "ba076676-53fc-11ec-84cf-00163e03ab95"
            },
            "error": 0
          } */
        }).then(function (res) {
          _this2.errMsg = '';
          if (res.error == 0) {
            _this2.refId = res.data.reference_id;
            __WEBPACK_IMPORTED_MODULE_11_Common_cookie__["a" /* default */].setCookie('lespark_user_id', res.data.user_id);
            // cookie.setCookie('lespark_token', res.data.token)
            _this2.registered = res.data.user_id ? true : false;
            _this2.countDown();
          } else {
            _this2.resetSendCodeBtn();
            var msg = _this2.$t('mobile_login.sendCodeFail');
            if (res.error == 8012) {
              msg = _this2.$t('error.unsafeEnv');
            }
            _this2.errMsg = msg;
          }
        });
        return true;
      } catch (e) {
        console.log(e);
        this.resetSendCodeBtn();
        this.errMsg = this.$t('mobile_login.sendCodeFail');
        return false;
      }
    },
    userReg: function userReg() {
      var _this3 = this;

      try {
        __WEBPACK_IMPORTED_MODULE_12_Common_ajax__["a" /* default */].Post({
          url: userUrl + '/v3/register_invite',
          params: {
            phone: '' + this.form.nationalCode + this.form.phone,
            verify_code: this.form.verifyCode,
            bundle_id: 'co.cc.lespro',
            client_version: '7.6.0',
            reference_id: this.refId
          }
          /* mock: {
            "msg": "ok",
            "data": {
              "lgid": 8031996,
              "token": {
                "access_token": "6afa83a763455e7e247550dd5d2230f8",
                "refresh_token_expire_in": 86400,
                "token_type": "bearer",
                "access_token_expire_in": 7200,
                "scope": "user",
                "refresh_token": "9c8376bc1ff5b57a93e4e6bcf269a54f"
              },
              "user_id": "61a713eed8964f59f862a572",
              "avatar": "http://img2.lespark.cn/avatar/ali86defaultavatarchicken.png_150x150",
              "verify": 0,
              "nickname": "les75417964",
              "email": "883b1cc3@lespark.us",
              "shumei_token_id": "a212851c-526e-11ec-926c-00163e0a5fec_1638339566",
              "device_id": ""
            },
            "error": 0
          } */
        }).then(function (res) {
          if (res.error == 0) {
            // cookie.setCookie('lespark_token', res.data.token.access_token)
            __WEBPACK_IMPORTED_MODULE_11_Common_cookie__["a" /* default */].setCookie('lespark_user_id', res.data.user_id);
          }
          _this3.$emit('completed', res);
        });
        return true;
      } catch (e) {
        console.log(e);
        e.error = -1;
        this.$emit('completed', e);
        return false;
      }
    },
    validPhone: function validPhone() {
      this.phoneErrMsg = '';
      if (!this.form.phone || isNaN(this.form.phone)) {
        this.phoneErrMsg = this.$t('mobile_login.errPhoneFormat');
        return false;
      }
      return true;
    },
    validCode: function validCode() {
      this.errMsg = '';
      if (this.form.verifyCode) {
        if (!/^[a-z0-9A-Z]+$/.test(this.form.verifyCode)) {
          this.errMsg = this.$t('mobile_login.errVerifyCodeFormat');
          return false;
        }
        return true;
      } else {
        this.errMsg = this.$t('mobile_login.errVerifyCodeRequired');
        return false;
      }
    },
    resetSendCodeBtn: function resetSendCodeBtn() {
      if (this.countDownTimer) {
        clearInterval(this.countDownTimer);
      }
      this.sendCodeDisable = false;
      this.sendCodeText = this.$t('mobile_login.sendCode');
    },

    // 切换登录
    wxLogin: function wxLogin() {
      var state = window.location.href;
      self.location.href = 'https://open.weixin.qq.com/connect/qrconnect?appid=' + wx_appid + '&redirect_uri=' + wx_redirect_uri + '&response_type=code&scope=snsapi_login&state=' + state + '#wechat_redirect';
    },
    qqLogin: function qqLogin() {
      var state = window.location.href;
      self.location.href = 'https://graph.qq.com/oauth2.0/authorize?client_id=' + qq_client_id + '&redirect_uri=' + qq_redirect_uri + '&response_type=code&state=' + state;
    },
    fbLogin: function fbLogin() {
      var state = window.location.href;
      var SCOPE = "&scope=email";
      self.location.href = 'https://www.facebook.com/dialog/oauth?client_id=' + facebook_client_id + '&redirect_uri=' + facebook_redirect_uri + '&response_type=code' + SCOPE + '&state=' + state;
    },
    showLogin: function showLogin() {
      this.visible = true;
    },
    hideLogin: function hideLogin() {
      this.visible = false;
    },

    // 登录按钮(手机号码登录)
    login: function login() {
      var _this4 = this;

      if (!this.validPhone() || !this.validCode()) {
        return false;
      }
      if (!this.registered) {
        this.userReg();
        return;
      }
      try {
        __WEBPACK_IMPORTED_MODULE_12_Common_ajax__["a" /* default */].Post({
          url: userUrl + '/v2/verify_code',
          params: {
            verify_code: this.form.verifyCode,
            reference_id: this.refId,
            phone_number: this.form.nationalCode + this.form.phone,
            area_code: this.form.nationalCode,
            user_id: __WEBPACK_IMPORTED_MODULE_11_Common_cookie__["a" /* default */].getCookie("lespark_user_id") || ""
          }
        }).then(function (res) {
          if (res.error == 0) {
            __WEBPACK_IMPORTED_MODULE_11_Common_cookie__["a" /* default */].setCookie('lespark_token', res.data.token);
            __WEBPACK_IMPORTED_MODULE_11_Common_cookie__["a" /* default */].setCookie('lespark_user_id', res.data.user_id);
          }
          _this4.$emit('completed', res);
        }).catch(function (e) {
          _this4.$emit('completed', e);
        });
      } catch (e) {
        e.error = -1;
        this.$emit('completed', e);
      }
    }
  }
});

/***/ }),

/***/ 301:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_Common_util_js__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'downloadTip',
  props: {},
  data: function data() {
    return {
      visible: false,
      isMask: false
    };
  },
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    show: function show() {
      this.visible = true;
    },
    hide: function hide() {
      this.visible = false;
    },
    gotoApp: function gotoApp() {
      var weixin = navigator.userAgent.indexOf('MicroMessenger') > -1; //是否为微信浏览器
      var qq = navigator.userAgent.match(/\sQQ/i) !== null; //是否QQ
      if (weixin || qq) {
        this.isMask = true;
        return;
      }
      __WEBPACK_IMPORTED_MODULE_0_Common_util_js__["a" /* default */].gotoApp();
    }
  }
});

/***/ }),

/***/ 302:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_image_css__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_image_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_image_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_image__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Common_util_js__ = __webpack_require__(6);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import lesparkIcon from '../images/lespark.png';
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_image___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'bottomBar',
  components: {
    elImage: __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_image___default.a
  },
  data: function data() {
    return {
      lesparkIcon: 'https://static.lespark.cn/pc_img/images/lespark.png',
      isMask: false
    };
  },

  methods: {
    gotoApp: function gotoApp() {
      var weixin = navigator.userAgent.indexOf('MicroMessenger') > -1; //是否为微信浏览器
      var qq = navigator.userAgent.match(/\sQQ/i) !== null; //是否QQ
      if (weixin || qq) {
        this.isMask = true;
        return;
      }
      __WEBPACK_IMPORTED_MODULE_4_Common_util_js__["a" /* default */].gotoApp();
    }
  }
});

/***/ }),

/***/ 31:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 319:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var constants = {
	// 主机域名
	url: {
		dev: 'https://api.lespark.cn' // 本地私有开发环境
	}
};

/* harmony default export */ __webpack_exports__["a"] = (constants);

/***/ }),

/***/ 320:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var IN_DEVELOPMENT = "production" === 'development';
var DOMAIN = "http://wx.lespark.cn";

var DATA = {
    // 接口域名
    domain: DOMAIN,
    // 成功状态码
    successStatus: 1,
    apis: {
        // 按页面区分链接
        home: {
            getData: filterApi('/mock/5b1d1b2c46416950933ee518/xsy/getData')
        }
    }

    // 配合本地服务器的代理功能，'/api'开头的链接会进入域名代理，防止跨域
};function filterApi(src) {
    if (IN_DEVELOPMENT) {
        return '/api' + src;
    } else {
        return DOMAIN + src;
    }
};

/* harmony default export */ __webpack_exports__["a"] = (DATA);

/***/ }),

/***/ 321:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var url = window.location.origin;
var AllUrl = {
  url: {
    dev: ""
    // dev: "http://www.lestory.cn",
  },
  appid: {
    wx: "be1e352ef0d15a01fcdc4bacf429e5b9",
    qq: "101510896",
    xinlang: "2829403593",
    facebook: "1397507653823766",
    ins: "d539702e66884929810e3ccd0ff4d059",
    line: "1514382018"
  },
  redirect_uri: {
    wx_url: url + "/pc_login_callback/wx",
    qq_url: url + "/pc_login_callback/qq",
    xinlang_url: url + "/pc_login_callback/sina",
    facebook_url: url + "/pc_login_callback/facebook",
    ins_url: url + "/pc_login_callback/instagram",
    line_url: url + "/pc_login_callback/line"
  }
};

/* harmony default export */ __webpack_exports__["a"] = (AllUrl);

/***/ }),

/***/ 322:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// lespark.us
// api.lespark.cn->api3.lespark.us
// h5.lespark.cn->h5.lespark.us

// lestory.cn
// api.lespark.cn->api3.lestory.cn
// h5.lespark.cn->h5.lestory.cn

var goLink = {
  //header.vue
  header: {
    //主播管理后台
    backend: {
      lespark_cn: "/live_start.html",
      lespark_us: "/live_start.html",
      lestory_cn: "/live_start.html"
    },
    //优质主播招募
    invite: {
      lespark_cn: "http://h5.lespark.cn/good_anchor_join",
      lespark_us: "http://h5.lespark.us/good_anchor_join",
      lestory_cn: "http://h5.lestory.cn/good_anchor_join"
    },
    //签约信息录入
    sign: {
      lespark_cn: "http://h5.lespark.cn/sign_anchor_abroad",
      lespark_us: "http://h5.lespark.us/sign_anchor_abroad",
      lestory_cn: "http://h5.lestory.cn/sign_anchor_abroad"
    },
    //提现
    withdraw: {
      lespark_cn: "/withdraw.html",
      lespark_us: "/withdraw.html",
      lestory_cn: "/withdraw.html"
    },
    //工会入驻
    Trade: {
      lespark_cn: "http://h5.lespark.cn/union_registration",
      lespark_us: "http://h5.lespark.us/union_registration",
      lestory_cn: "http://h5.lestory.cn/union_registration"
    },
    //工会管理
    management: {
      lespark_cn: "http://api.lespark.cn/guild/index",
      lespark_us: "http://api3.lespark.us/guild/index",
      lestory_cn: "http://api3.lestory.cn/guild/index"
    },
    //移动端提现
    non_contract_anchor_withdraw: {
      lespark_cn: "http://api.lespark.cn/non_contract_anchor_withdraw",
      lespark_us: "http://api3.lespark.us/non_contract_anchor_withdraw",
      lestory_cn: "http://api3.lestory.cn/non_contract_anchor_withdraw"
    },
    //pc充值页面
    pay: {
      lespark_cn: "api.lespark.cn/paynow_order",
      lespark_us: "api3.lespark.us/paynow_order",
      lestory_cn: "api3.lestory.cn/paynow_order"
    }
  },
  //menu.vue
  menu: {
    rechargeApp: {
      lespark_cn: "http://api.lespark.cn/pay_web_order",
      lespark_us: "http://api3.lespark.us/pay_web_order",
      lestory_cn: "http://api3.lestory.cn/pay_web_order"
    },
    rechargeVip: {
      lespark_cn: "http://api.lespark.cn/pay_web_order?tab=vip",
      lespark_us: "http://api3.lespark.us/pay_web_order?tab=vip",
      lestory_cn: "http://api3.lestory.cn/pay_web_order?tab=vip"
    },
    goBaiHua: {
      lespark_cn: "http://api.lespark.cn/baihua/index?fromPage=pc",
      lespark_us: "http://api3.lespark.us/baihua/index?fromPage=pc",
      lestory_cn: "http://api3.lestory.cn/baihua/index?fromPage=pc"
    },
    wx_buy_diamonds: {
      lespark_cn: "http://wx.lespark.cn/wx/buy_diamonds",
      lespark_us: "http://wx.lespark.us/wx/buy_diamonds",
      lestory_cn: "http://wx.lestory.cn/wx/buy_diamonds"
    }
  },
  //foot.vue
  foot: {
    rule_privacy: {
      lespark_cn: "http://h5.lespark.cn/rule_privacy",
      lespark_us: "http://h5.lespark.us/rule_privacy",
      lestory_cn: "http://h5.lestory.cn/rule_privacy"
    },
    auto_extend_agreement: {
      lespark_cn: "http://h5.lespark.cn/auto_extend_agreement",
      lespark_us: "http://h5.lespark.us/auto_extend_agreement",
      lestory_cn: "http://h5.lestory.cn/auto_extend_agreement"
    }
  },
  //mobileLogin.vue
  mobileLogin: {
    terms: {
      lespark_cn: "http://api.lespark.cn/terms",
      lespark_us: "http://api3.lespark.us/terms",
      lestory_cn: "http://api3.lestory.cn/terms"
    }
  },
  //liveStart.vue
  liveStart: {
    live_rule_one_page: {
      lespark_cn: "http://h5.lespark.cn/live_rule_one_page",
      lespark_us: "http://h5.lespark.us/live_rule_one_page",
      lestory_cn: "http://h5.lestory.cn/live_rule_one_page"
    }
  }
};

function getUrlKey() {
  var key_txt = void 0;
  if (window.location.host.includes("lestory.cn")) {
    key_txt = "lestory_cn";
  } else if (window.location.host.includes("lespark.us")) {
    key_txt = "lespark_us";
  } else {
    key_txt = "lestory_cn";
  }
  return key_txt;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  goLink: goLink,
  getUrlKey: getUrlKey
});

/***/ }),

/***/ 35:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 5:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apis__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__url__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__urlLink__ = __webpack_require__(322);





/* harmony default export */ __webpack_exports__["a"] = ({
    CONSTANTS: __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* default */],
    APIS: __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */],
    AllUrl: __WEBPACK_IMPORTED_MODULE_2__url__["a" /* default */],
    UrlLink: __WEBPACK_IMPORTED_MODULE_3__urlLink__["a" /* default */]
});

/***/ }),

/***/ 52:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 545:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_swiper_vue__ = __webpack_require__(225);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_24765e69_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_swiper_vue__ = __webpack_require__(547);
function injectStyle (ssrContext) {
  __webpack_require__(546)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_swiper_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_24765e69_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_swiper_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 546:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 547:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"wh_content",on:{"touchmove":_vm.fn}},[_c('div',{staticClass:"wh_swiper",class:_vm.className,on:{"touchstart":_vm.s,"touchmove":_vm.m,"touchend":_vm.e}},[_vm._t("default")],2),_vm._v(" "),(_vm.showIndicator)?_c('div',{staticClass:"wh_indicator"},_vm._l((_vm.slidesLength),function(tag,$index){return _c('div',{staticClass:"wh_indicator_item",class:{ wh_show_bgcolor: _vm.index-1==$index }})}),0):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 548:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_slide_vue__ = __webpack_require__(226);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_946ebcde_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_slide_vue__ = __webpack_require__(550);
function injectStyle (ssrContext) {
  __webpack_require__(549)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_slide_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_946ebcde_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_slide_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 549:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 550:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wh_slide",on:{"click":_vm.clickSlide}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 552:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 554:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 558:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 561:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 572:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue__ = __webpack_require__(233);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_938416c6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_vue__ = __webpack_require__(576);
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_938416c6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 575:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 576:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"layer",style:({height:_vm.screenHeight,width:_vm.screenWidth}),on:{"click":function($event){return _vm.disappear(_vm.close)}}}),_vm._v(" "),_c('div',{staticClass:"login"},[_c('div',{staticClass:"login_this"},[_c('div',{staticClass:"mode"},[_c('p',{class:_vm.dengluShow==true?'choose':'',on:{"click":_vm.denglu}},[_vm._v(_vm._s(_vm.$t('login.nav1')))]),_vm._v(" "),_c('p',{class:_vm.regShow==true?'choose':'',on:{"click":_vm.reg}},[_vm._v(_vm._s(_vm.$t('login.nav2')))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.dengluShow),expression:"dengluShow"}],staticClass:"this_log",on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.enter.apply(null, arguments)}}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.nationalCode),expression:"nationalCode"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.nationalCode=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"selected":""}},[_vm._v(_vm._s(_vm.$t('login.input3'))+"（+86）")]),_vm._v(" "),_c('option',[_vm._v(_vm._s(_vm.$t('login.input4'))+"（+1）")]),_vm._v(" "),_c('option',[_vm._v(_vm._s(_vm.$t('login.input5'))+"（+886）")]),_vm._v(" "),_c('option',[_vm._v(_vm._s(_vm.$t('login.input6'))+"（+852）")]),_vm._v(" "),_c('option',[_vm._v(_vm._s(_vm.$t('login.input7'))+"（+853）")]),_vm._v(" "),_c('option',[_vm._v(_vm._s(_vm.$t('login.input8'))+"（+66）")]),_vm._v(" "),_c('option',[_vm._v(_vm._s(_vm.$t('login.input9'))+"（+60）")]),_vm._v(" "),_c('option',[_vm._v(_vm._s(_vm.$t('login.input10'))+"（+65）")]),_vm._v(" "),_c('option',[_vm._v(_vm._s(_vm.$t('login.input11'))+"（+81）")]),_vm._v(" "),_c('option',[_vm._v(_vm._s(_vm.$t('login.input12'))+"（+82）")]),_vm._v(" "),_c('option',[_vm._v(_vm._s(_vm.$t('login.input13'))+"（+61）")]),_vm._v(" "),_c('option',[_vm._v(_vm._s(_vm.$t('login.input14'))+"（+44）")]),_vm._v(" "),_c('option',[_vm._v(_vm._s(_vm.$t('login.input15'))+"（+63）")]),_vm._v(" "),_c('option',[_vm._v(_vm._s(_vm.$t('login.input16'))+"（+84）")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.log_phone),expression:"log_phone"}],staticClass:"this_log_phone",attrs:{"type":"text","placeholder":_vm.input1},domProps:{"value":(_vm.log_phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.log_phone=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.log_password),expression:"log_password"}],staticClass:"this_log_password",attrs:{"type":"password","placeholder":_vm.input2},domProps:{"value":(_vm.log_password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.log_password=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"this_log_button",on:{"click":_vm.login}},[_c('img',{attrs:{"src":"https://static.lespark.cn/pc_img/images/login_button.png"}}),_vm._v(" "),_c('a',[_vm._v(_vm._s(_vm.$t('login.nav8')))])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.regShow),expression:"regShow"}],staticClass:"this_reg"},[_c('div',{staticClass:"this_reg_download"},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.regUrlShow),expression:"regUrlShow"}],staticClass:"download_img",attrs:{"src":_vm.regUrl}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(!_vm.regUrlShow),expression:"!regUrlShow"}],staticClass:"download_img",attrs:{"src":"https://static.lespark.cn/pc_img/images/download.png"}})]),_vm._v(" "),_c('div',{staticClass:"this_reg_download_tips"},[_c('p',[_vm._v(_vm._s(_vm.$t('login.nav5')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('login.nav6')))])])])]),_vm._v(" "),_c('div',{staticClass:"line"},[_c('span'),_vm._v(" "),_c('a',[_vm._v(_vm._s(_vm.$t('login.nav7')))]),_vm._v(" "),_c('span')]),_vm._v(" "),_c('div',{staticClass:"login_other"},[(!_vm.isLiveRoom)?_c('div',{staticClass:"close",on:{"click":function($event){return _vm.disappear(_vm.close)}}},[_c('img',{attrs:{"src":"https://static.lespark.cn/pc_img/images/close.png"}})]):_vm._e(),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.dengluShow),expression:"dengluShow"}],staticClass:"other"},[_vm._v(_vm._s(_vm.$t('login.nav3_1')))]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.regShow),expression:"regShow"}],staticClass:"other"},[_vm._v(_vm._s(_vm.$t('login.nav3_2')))]),_vm._v(" "),_c('div',{staticClass:"other_mode"},[_c('ul',[_c('li',{staticClass:"other_mode_ul_li",attrs:{"href":""},on:{"click":function($event){return _vm.otherLog(_vm.wx)}}},[_c('img',{attrs:{"src":"https://static.lespark.cn/pc_img/images/wx.png"}})]),_vm._v(" "),_c('li',{attrs:{"href":""},on:{"click":function($event){return _vm.otherLog(_vm.qq)}}},[_c('img',{attrs:{"src":"https://static.lespark.cn/pc_img/images/QQ_default.png"}})]),_vm._v(" "),_c('li',{staticClass:"other_mode_ul_li",attrs:{"href":""},on:{"click":function($event){return _vm.otherLog(_vm.xinlang)}}},[_c('img',{attrs:{"src":"https://static.lespark.cn/pc_img/images/xinlang.png"}})])]),_vm._v(" "),_c('ul',[_c('li',{staticClass:"other_mode_ul_li",attrs:{"href":""},on:{"click":function($event){return _vm.otherLog(_vm.facebook)}}},[_c('img',{attrs:{"src":"https://static.lespark.cn/pc_img/images/facebook.png"}})]),_vm._v(" "),_c('li',{staticClass:"other_mode_ul_li",attrs:{"href":""},on:{"click":function($event){return _vm.otherLog(_vm.line)}}},[_c('img',{attrs:{"src":"https://static.lespark.cn/pc_img/images/line.png"}})])])]),_vm._v(" "),_c('div',{staticClass:"other_tips"},[_c('p',[_vm._v(_vm._s(_vm.$t('login.nav4')))])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 577:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_lay_vue__ = __webpack_require__(234);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a5bff48e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_lay_vue__ = __webpack_require__(578);
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_lay_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a5bff48e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_lay_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 578:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lay",style:({height:_vm.screenHeight,width:_vm.screenWidth})})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 579:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 580:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-container"},[_c('lay',{directives:[{name:"show",rawName:"v-show",value:(_vm.layShow),expression:"layShow"}],attrs:{"msglay":_vm.msglay},nativeOn:{"click":function($event){return _vm.disappear.apply(null, arguments)}}}),_vm._v(" "),_c('login',{directives:[{name:"show",rawName:"v-show",value:(_vm.loginShow),expression:"loginShow"}],staticClass:"content_login",attrs:{"msglogin":_vm.msglogin},on:{"showChanged":function($event){return _vm.showChange($event)}}}),_vm._v(" "),_c('div',{staticClass:"header"},[_c('a',{class:['logo',{'logo-red':_vm.color!='#fff'}],attrs:{"href":"../index.html"}}),_vm._v(" "),_c('div',[_c('ul',{staticClass:"header-tab",style:({color:_vm.color})},[(_vm.pageName != 'baihua')?_c('li',{staticClass:" header-tab-li"},[_c('div',{staticClass:"bai-hua"},[_vm._v(_vm._s(_vm.$t('header.baihuaAward')))]),_vm._v(" "),_c('a',{style:({cursor: 'pointer',color:_vm.color}),attrs:{"href":"../baihua.html"}},[_vm._v(_vm._s(_vm.$t('header.baihuaTitle')))])]):_vm._e(),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.islogin),expression:"islogin"}],staticClass:" header-tab-li"},[_c('a',{staticStyle:{"cursor":"pointer"},style:({cursor: 'pointer',color:_vm.color}),attrs:{"href":'/loginhome.html?id=' + _vm.user_id}},[_vm._v(_vm._s(_vm.$t('header.myHome')))])]),_vm._v(" "),_c('li',{staticClass:" header-tab-li"},[_c('a',{style:({cursor: 'pointer',color:_vm.color}),attrs:{"href":"../live-all.html"}},[_vm._v(_vm._s(_vm.$t('header.live')))])]),_vm._v(" "),_c('li',{staticClass:" header-tab-li"},[_c('a',{style:({cursor: 'pointer',color:_vm.color}),attrs:{"href":"../topic-all.html"}},[_vm._v(_vm._s(_vm.$t('header.topic')))])]),_vm._v(" "),_c('li',{staticClass:"header-tab-li",on:{"click":_vm.pay}},[_c('a',{style:({color:_vm.color})},[_vm._v(_vm._s(_vm.$t('header.nav2')))])]),_vm._v(" "),_c('li',[_c('a',{style:({cursor: 'default',color:_vm.color})},[_vm._v(_vm._s(_vm.$t('header.nav3')))]),_vm._v(" "),_c('div',{staticClass:"pc-liver",staticStyle:{"cursor":"default"}},[_vm._v(_vm._s(_vm.$t('header.nav3_5')))]),_vm._v(" "),_c('el-cascader',{attrs:{"id":"cascader","options":_vm.options,"props":{ expandTrigger: 'hover' }},on:{"change":_vm.handleChange}})],1),_vm._v(" "),_c('li',[_c('el-dropdown',{style:({color:_vm.color}),attrs:{"trigger":"click"},on:{"command":_vm.handleCommand}},[_c('span',{staticClass:"el-dropdown-link"},[_vm._v("\n              "+_vm._s(_vm.currUseLanguage)),_c('i',{staticClass:"el-icon-arrow-down el-icon--right"})]),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{attrs:{"command":"zh-Hans-TW"}},[_vm._v("简体中文")]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":"zh-Hant-TW"}},[_vm._v("繁體中文")]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":"en"}},[_vm._v("English")])],1)],1)],1),_vm._v(" "),_c('li',[_c('el-dropdown',{style:({color:_vm.color}),attrs:{"trigger":"click"}},[_c('span',{staticClass:"el-dropdown-link"},[_vm._v("\n              "+_vm._s(_vm.$t('header.nav5'))),_c('i',{staticClass:"el-icon-arrow-down el-icon--right"})]),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',[_c('a',{attrs:{"href":"/les-app.html"}},[_vm._v(_vm._s(_vm.$t('home.appProfile')))])]),_vm._v(" "),_c('el-dropdown-item',[_c('a',{attrs:{"href":"/about-us.html"}},[_vm._v(_vm._s(_vm.$t('header.nav5')))])]),_vm._v(" "),_c('el-dropdown-item',[_c('a',{attrs:{"href":"http://rela.cn"}},[_vm._v(_vm._s(_vm.$t('header.jihua')))])]),_vm._v(" "),_c('el-dropdown-item',[_c('a',{attrs:{"href":"https://www.sobot.com/chat/pc/index.html?sysNum=4717b63070614a289c61072945a75770"}},[_vm._v(_vm._s(_vm.$t('header.ContactUs')))])])],1)],1)],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(!_vm.islogin),expression:"!islogin"}],staticClass:"header-tab-li",on:{"click":_vm.appear}},[_c('a',{style:({color:_vm.color}),attrs:{"href":"#"}},[_vm._v(_vm._s(_vm.$t('header.nav6')))])]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.islogin),expression:"islogin"}],staticClass:"user",staticStyle:{"border-radius":"50%","padding-right":"30px"},style:({color:_vm.color})},[_c('img',{staticStyle:{"height":"100%","border-radius":"50%"},attrs:{"src":_vm.avatar}}),_vm._v(" "),_c('div',{staticClass:"user_info"},[_c('div',{staticClass:"user_info_lay"}),_vm._v(" "),_c('div',{staticClass:"user_info_little"},[_c('div',{staticClass:"user_info_little_avatar"},[_c('img',{staticStyle:{"width":"100%","height":"100%","border-radius":"50%"},attrs:{"src":_vm.avatar}})]),_vm._v(" "),_c('div',{staticClass:"user_info_little_avatar_info"},[_c('p',[_vm._v(_vm._s(_vm.nickname))]),_vm._v(" "),_c('p',[_vm._v("LesPark ID: "+_vm._s(_vm.lgid))])])]),_vm._v(" "),_c('div',{staticClass:"user_info_recharge user_info_quit",on:{"click":_vm.quit}},[_c('a',[_vm._v(_vm._s(_vm.$t('header.me2')))])])])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 581:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 582:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"foot-container"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"foot-logo"},[_c('img',{attrs:{"src":_vm.footImg,"alt":""}}),_vm._v(" "),_c('ul',[_c('a',{staticClass:"logo-item",attrs:{"href":_vm.isShowFootTxt?_vm.url.ios_url:_vm.url_2.ios_url}},[_c('img',{attrs:{"src":_vm.apple,"alt":""}}),_vm._v(" "),_c('span',[_vm._v("AppStore")])]),_vm._v(" "),(_vm.isShowFootTxt)?_c('a',{staticClass:"logo-item",attrs:{"href":_vm.isShowFootTxt?_vm.url.android_url:_vm.url_2.android_url}},[_c('img',{attrs:{"src":_vm.android,"alt":""}}),_vm._v(" "),_c('span',[_vm._v("Android")])]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"logo-item",attrs:{"href":_vm.isShowFootTxt?_vm.url.google_url:_vm.url_2.google_url}},[_c('img',{attrs:{"src":_vm.google,"alt":""}}),_vm._v(" "),_c('span',[_vm._v("Google")])]),_vm._v(" "),(!_vm.isShowFootTxt)?_c('a',{staticClass:"logo-item",staticStyle:{"opacity":"0"},attrs:{"href":""}}):_vm._e()])]),_vm._v(" "),(_vm.isShowFootTxt)?_c('div',{staticClass:"foot-content"},[_c('ul',{staticClass:"foot-txt"},[_c('li',[_c('a',{attrs:{"href":"/help.html"}},[_vm._v(_vm._s(_vm.$t('foot.HelpCenter')))])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"target":"_blank","href":_vm.goLinkUrl['rule_privacy'][_vm.goLinkeKey]+'?locale='+_vm.goLang+'&fromPage='+_vm.goLinkeKey}},[_vm._v(_vm._s(_vm.$t('foot.PrivacyPolicy')))])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":_vm.goLinkUrl['auto_extend_agreement'][_vm.goLinkeKey]+'?fromPage='+this.goLinkeKey,"target":"_blank"}},[_vm._v(_vm._s(_vm.$t('foot.ServiceAgreement')))])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"/about-us.html"}},[_vm._v(_vm._s(_vm.$t('foot.CompanyProfile')))])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"/about-us.html#join"}},[_vm._v(_vm._s(_vm.$t('foot.JoinUs')))])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"/about-us.html#contact"}},[_vm._v(_vm._s(_vm.$t('foot.contactUs')))])])]),_vm._v(" "),_c('ul',{staticClass:"foot-record"},[_c('li',[_vm._v("\n            "+_vm._s(_vm.$t('foot.ServiceTel'))+"："+_vm._s(_vm.isShowFootTxt?'0779 - 2681747':'0763 - 3664162')),_c('span'),_vm._v(" "+_vm._s(_vm.$t('foot.ReportPhone'))+"："+_vm._s(_vm.isShowFootTxt?'0779 - 2681747':'0763 - 3664162')+" "),_c('span'),_c('br'),_vm._v("\n            "+_vm._s(_vm.$t('foot.ReportEmail'))+"： "),_c('a',{attrs:{"href":"mailto:cs@lespark.us"}},[_vm._v("cs@lespark.us")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":_vm.isShowFootTxt?_vm.lestoryLink:_vm.lesparkLink}},[_c('img',{attrs:{"src":_vm.policeImg,"alt":""}})]),_vm._v(" "),_c('a',{attrs:{"href":_vm.isShowFootTxt?_vm.lestoryLink:_vm.lesparkLink}},[_vm._v(" "+_vm._s(_vm.isShowFootTxt?_vm.$t('foot2.content1'):_vm.$t('foot.content1')))]),_vm._v(" "),_c('a',{attrs:{"href":"https://beian.miit.gov.cn"}},[_vm._v(_vm._s(_vm.isShowFootTxt?_vm.$t('foot2.content2'):_vm.$t('foot.content2')))]),_vm._v(" "),(_vm.isShowFootTxt)?_c('span',[_vm._v(_vm._s(_vm.$t('foot2.content6')))]):_vm._e()]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.isShowFootTxt?_vm.$t('foot2.content3'):_vm.$t('foot.content3')))])])]):_c('div',{staticClass:"foot-content"},[_c('ul',{staticClass:"foot-txt"},[_c('li',[_c('a',{attrs:{"href":"/help.html"}},[_vm._v(_vm._s(_vm.$t('foot.HelpCenter')))])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":_vm.goLinkUrl['auto_extend_agreement'][_vm.goLinkeKey]+'?fromPage='+this.goLinkeKey,"target":"_blank"}},[_vm._v(_vm._s(_vm.$t('foot.ServiceAgreement')))])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"/about-us.html"}},[_vm._v(_vm._s(_vm.$t('foot.CompanyProfile')))])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"/about-us.html#join"}},[_vm._v(_vm._s(_vm.$t('foot.JoinUs')))])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"/about-us.html#contact"}},[_vm._v(_vm._s(_vm.$t('foot.contactUs')))])])]),_vm._v(" "),_vm._m(0)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"foot-record"},[_c('li',[_vm._v("\n\t          Email: "),_c('a',{attrs:{"href":"mailto:cs@lespark.us"}},[_vm._v("cs@lespark.us")])]),_vm._v(" "),_c('li',[_vm._v("\n            ORIENT BASIC SCIENCE AND TECHNOLOGY PTE. LTD.\n          ")]),_vm._v(" "),_c('li',[_vm._v("\n\t\t        Address: 112 ROBINSON ROAD #03-01ROBINSON 112 SINGAPORE(068902)\n          ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 586:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 587:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showChang),expression:"showChang"}],staticClass:"attention",attrs:{"id":"attention"}},[_c('div',{staticClass:"att-title clearflow"},[_c('div',{staticClass:"word"},[_vm._v(_vm._s(_vm.$t('home.liveTitle1')))])]),_vm._v(" "),(_vm.noattention)?_c('div',{staticClass:"wrap"},_vm._l((_vm.attentionList),function(item,index){return _c('div',{key:index,staticClass:"imgboxing"},[_c('a',{staticClass:"outimg",attrs:{"href":'/live/' + item.lgid +'.html'}},[_c('div',{staticClass:"imgbox",staticStyle:{"display":"table-cell","vertical-align":"middle","text-align":"center"}},[(item.live_pic)?_c('img',{staticClass:"picavatar",attrs:{"src":item.live_pic + '_200x200'}}):_c('img',{staticClass:"picavatar",attrs:{"src":item.avatar + '_200x200'}})]),_vm._v(" "),_vm._m(0,true)]),_vm._v(" "),_c('div',{staticClass:"clearflow nic-view"},[_c('div',{staticClass:"fl nickname"},[_vm._v(_vm._s(item.nickname))]),_vm._v(" "),(item.is_secret_live == '1')?_c('div',{staticClass:"lock fl"},[_c('img',{attrs:{"src":"https://static.lespark.cn/pc_img/images/lock.png"}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"fr"},[_vm._m(1,true),_vm._v(" "),_c('div',{staticClass:"fr view",staticStyle:{"line-height":"23px"}},[_vm._v(_vm._s(item.view_num))])])])])}),0):_c('div',[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"novideo"},[_vm._v(_vm._s(_vm.$t('home.liveTitle1_1')))])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"img-bg"},[_c('div',{staticClass:"img-bg-box"},[_c('div',{staticClass:"out-box"},[_c('img',{staticClass:"auto-img",attrs:{"src":"https://static.lespark.cn/pc_img/images/play.png"}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fl",staticStyle:{"margin-right":"5px","line-height":"23px"}},[_c('img',{attrs:{"src":"https://static.lespark.cn/pc_img/images/view.png"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"novideoimg"},[_c('img',{attrs:{"src":"https://static.lespark.cn/pc_img/images/novideo.png"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 597:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 6:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonp__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jsonp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Constans__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Common_cookie__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Common_ajax__ = __webpack_require__(16);






var successStatus = __WEBPACK_IMPORTED_MODULE_3_Constans__["a" /* default */].APIS.successStatus;
var appid = '1255310861';
var bucket = 'edumap';
var Region = 'ap-guangzhou';
var that = this;

function is_login() {
  var token = __WEBPACK_IMPORTED_MODULE_4_Common_cookie__["a" /* default */].getCookie('lespark_token');
  var user_id = __WEBPACK_IMPORTED_MODULE_4_Common_cookie__["a" /* default */].getCookie('lespark_user_id');

  if (token == null || token == '') {
    alert('登录状态失效,请重新登陆');
  }
  if (user_id == null || user_id == '') {
    alert('登录状态失效,请重新登陆');
  }
}

function liveStartisLogin() {
  var token = __WEBPACK_IMPORTED_MODULE_4_Common_cookie__["a" /* default */].getCookie('lespark_token');
  var user_id = __WEBPACK_IMPORTED_MODULE_4_Common_cookie__["a" /* default */].getCookie('lespark_user_id');
  if (token == null || token == '' || user_id == null || user_id == '') {
    return false;
  } else {
    return true;
  }
}

//判断是否在Phantomjs
function isPhantomjs() {
  if (!(navigator.plugins instanceof PluginArray) || navigator.plugins.length == 0) {
    return true;
  } else {
    return false;
  }
}

function getQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return "";
}

/**
 * 解析查询字符串，返回包含所有参数的对象
 */
function getQueryStringArgs() {
  var qs = location.search.length > 0 ? location.search.substring(1) : "",
      args = {},
      items = qs.length > 0 ? qs.split("&") : [],
      item = null,
      name = null,
      value = null;
  items.map(function (arg, index) {

    var _sub = '=',
        _v = '';
    var _urlindex = arg.indexOf(_sub);
    _v = arg.substring(_urlindex + _sub.length, arg.length);
    _v && (value = decodeURIComponent(_v));

    item = arg.split("=");
    name = decodeURIComponent(item[0]);
    // value = item[1] && decodeURIComponent(item[1]);
    if (name.length) {
      args[name] = value;
    }
  });
  return args;
}

function getNowTime() {
  var now = new Date();
  var time = now.getFullYear() + "-" + (now.getMonth() + 1 < 10 ? "0" : "") + (now.getMonth() + 1) + "-" + (now.getDate() < 10 ? "0" : "") + now.getDate();
  return time + " 00:00:00";
}

function getNowTimeHM() {
  var now = new Date();
  var time = now.getFullYear() + "-" + (now.getMonth() + 1 < 10 ? "0" : "") + (now.getMonth() + 1) + "-" + (now.getDate() < 10 ? "0" : "") + now.getDate() + " " + now.getHours() + ":" + now.getMinutes();
  return time;
}

//返回年月日  00：00:00 格式：04/30：00:00:00
function formatDayTime(time) {
  var time_format = time.replace(/-/g, '/');
  var now = new Date(time_format + ":00");
  var time = now.getFullYear() + "-" + (now.getMonth() + 1 < 10 ? "0" : "") + (now.getMonth() + 1) + "-" + (now.getDate() < 10 ? "0" : "") + now.getDate();
  return time + " 00:00:00";
}

function ieVersion() {
  var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串

  var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器

  if (isIE) {
    var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
    reIE.test(userAgent);
    var fIEVersion = parseFloat(RegExp["$1"]);
    if (fIEVersion == 9) {
      // console.log("当前IE版本为9")
      __WEBPACK_IMPORTED_MODULE_4_Common_cookie__["a" /* default */].setCookie("ie", "9");
    } else if (fIEVersion > 9) {
      // console.log("大于9版本可正常使用")
    } else {
      __WEBPACK_IMPORTED_MODULE_4_Common_cookie__["a" /* default */].setCookie("ie", "9");
      alert("请将IE浏览器升级到IE9版本");
    }
  } else {}
}

// 数据转化
function formatNumber(n) {
  n = n.toString();
  return n[1] ? n : '0' + n;
}
// 时间格式化
function formatTime(number, format) {
  if (!number) return '--';

  var formateArr = ['Y', 'M', 'D', 'h', 'm', 's'];
  var returnArr = [];
  var date = new Date(number * 1000);
  returnArr.push(date.getFullYear());
  returnArr.push(formatNumber(date.getMonth() + 1));
  returnArr.push(formatNumber(date.getDate()));

  returnArr.push(formatNumber(date.getHours()));
  returnArr.push(formatNumber(date.getMinutes()));
  returnArr.push(formatNumber(date.getSeconds()));

  for (var i in returnArr) {
    format = format.replace(formateArr[i], returnArr[i]);
  }
  return format;
}
//防抖函数
function debounce(fn, wait) {
  var timeout = null;
  return function () {
    if (timeout !== null) clearTimeout(timeout);
    timeout = setTimeout(fn, wait);
  };
}

function gotoApp() {
  window.location.href = 'lesparkapp://h5_detail';
  setTimeout(function () {
    window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.redwolfama.peonylespark';
  }, 2000);
}

function getLang() {
  var _lan = (window.navigator.language || window.navigator.userLanguage).toLowerCase();
  var _locale = 'cn';
  if (_lan.startsWith('zh-')) {
    if (_lan != 'zh-cn') {
      _locale = 'tw';
    }
  } else {
    _locale = 'en';
  }
  return _locale;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  getQueryString: getQueryString,
  getQueryStringArgs: getQueryStringArgs,
  getNowTime: getNowTime,
  getNowTimeHM: getNowTimeHM,
  formatDayTime: formatDayTime,
  is_login: is_login,
  ieVersion: ieVersion,
  liveStartisLogin: liveStartisLogin,
  formatTime: formatTime,
  isPhantomjs: isPhantomjs,
  debounce: debounce,
  gotoApp: gotoApp,
  getLang: getLang
});

/***/ }),

/***/ 615:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 617:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 622:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 623:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"menu",style:({'borderColor':_vm.color}),on:{"click":function($event){_vm.showPopup = true}}}),_vm._v(" "),_c('van-popup',{style:({ width: '50%',height:'100%' }),attrs:{"position":"right"},model:{value:(_vm.showPopup),callback:function ($$v) {_vm.showPopup=$$v},expression:"showPopup"}},[_c('span',{staticClass:"baihua-m",attrs:{"data-txt":_vm.$t('header.baihuaAward')},on:{"click":_vm.goBaiHua}},[_vm._v(_vm._s(_vm.$t("header.baihuaTitle")))]),_vm._v(" "),_c('span',{on:{"click":_vm.rechargeApp}},[_vm._v(_vm._s(_vm.$t("header.nav2")))]),_vm._v(" "),_c('span',[_c('a',{attrs:{"href":"/live-all.html"}},[_vm._v(_vm._s(_vm.$t("header.live")))])]),_vm._v(" "),_c('span',[_c('a',{attrs:{"href":"/topic-all.html"}},[_vm._v(_vm._s(_vm.$t("header.topic")))])]),_vm._v(" "),_c('span',[_c('a',{attrs:{"target":"_blank","href":_vm.goLinkUrl['Trade'][_vm.goLinkeKey]}},[_vm._v(_vm._s(_vm.$t("headerOptions")[1].children[0].label))])]),_vm._v(" "),_c('span',[_c('a',{attrs:{"href":"/les-app.html"}},[_vm._v(_vm._s(_vm.$t("home.appProfile")))])]),_vm._v(" "),_c('span',[_c('a',{attrs:{"href":"/about-us.html"}},[_vm._v(_vm._s(_vm.$t("header.nav5")))])]),_vm._v(" "),_c('span',[_c('a',{attrs:{"target":"_blank","href":_vm.goLinkUrl['invite'][_vm.goLinkeKey]}},[_vm._v(_vm._s(_vm.$t("mobleTxt.t1")))])]),_vm._v(" "),_c('span',[_c('a',{attrs:{"target":"_blank","href":_vm.goLinkUrl['sign'][_vm.goLinkeKey]}},[_vm._v(_vm._s(_vm.$t("headerOptions")[0].children[2].label))])]),_vm._v(" "),_c('span',[_c('a',{attrs:{"target":"_blank","href":_vm.goLinkUrl['management'][_vm.goLinkeKey]}},[_vm._v(_vm._s(_vm.$t("headerOptions")[1].children[1].label))])]),_vm._v(" "),_c('span',[_c('a',{attrs:{"target":"_blank","href":"https://www.sobot.com/chat/pc/index.html?sysNum=4717b63070614a289c61072945a75770"}},[_vm._v(_vm._s(_vm.$t("header.ContactUs")))])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 624:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 625:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile-foot"},[_c('div',{staticClass:"btn",on:{"click":_vm.downloadApp}},[_vm._v(_vm._s(_vm.$t("mobleTxt.download2"))+" LesPark")]),_vm._v(" "),(_vm.isShowFootTxt)?_c('p',[_vm._v(_vm._s(_vm.$t('foot2.content1'))+" "+_vm._s(_vm.$t('foot2.content2'))+" ")]):_vm._e(),_vm._v(" "),(_vm.isShowFootTxt)?_c('p',[_vm._v(_vm._s(_vm.$t('foot2.content6')))]):_vm._e(),_vm._v(" "),(_vm.isShowFootTxt)?_c('p',[_vm._v(_vm._s(_vm.$t('foot2.content3')))]):_vm._e(),_vm._v(" "),(!_vm.isShowFootTxt)?_c('p',[_vm._v("ORIENT BASIC SCIENCE AND TECHNOLOGY PTE. LTD. ")]):_vm._e(),_vm._v(" "),_c('ul',{staticClass:"foot-link"},[_c('li',{staticClass:"link-iterm"},[_c('a',{attrs:{"href":"/help.html"}},[_vm._v(_vm._s(_vm.$t('foot.HelpCenter')))])]),_vm._v(" "),(_vm.isShowFootTxt)?_c('li',{staticClass:"link-iterm"},[_c('a',{attrs:{"target":"_blank","href":_vm.goLinkUrl['rule_privacy'][_vm.goLinkeKey]+'?locale='+_vm.goLang+'&fromPage='+_vm.goLinkeKey}},[_vm._v(_vm._s(_vm.$t('foot.PrivacyPolicy')))])]):_vm._e(),_vm._v(" "),_c('li',{staticClass:"link-iterm"},[_c('a',{attrs:{"target":"_blank","href":_vm.goLinkUrl['auto_extend_agreement'][_vm.goLinkeKey]+'?fromPage='+this.goLinkeKey}},[_vm._v(_vm._s(_vm.$t('foot.ServiceAgreement')))])]),_vm._v(" "),_c('li',{staticClass:"link-iterm"},[_c('a',{attrs:{"href":"/about-us.html"}},[_vm._v(_vm._s(_vm.$t('foot.CompanyProfile')))])]),_vm._v(" "),_c('li',{staticClass:"link-iterm"},[_c('a',{attrs:{"href":"/about-us.html#joinmobile"}},[_vm._v(_vm._s(_vm.$t('foot.JoinUs')))])]),_vm._v(" "),_c('li',{staticClass:"link-iterm"},[_c('a',{attrs:{"href":"/about-us.html#contactmobile"}},[_vm._v(_vm._s(_vm.$t('foot.contactUs')))])]),_vm._v(" "),(!_vm.isShowFootTxt)?_c('li',{staticClass:"link-iterm"}):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 644:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 678:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 679:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tc_2_2"},[_c('div',{staticClass:"tc_2_1"},[_c('span',{staticClass:"tc_2_1_1"},[_vm._v(_vm._s(_vm.$t('home.liveTitle3')))])]),_vm._v(" "),(_vm.noattention)?_c('div',{staticClass:"wrap"},_vm._l((_vm.attentionList),function(item,index){return _c('div',{key:index,staticClass:"topicitem",on:{"click":function($event){return _vm.toLive(item.tag)}}},[_c('div',{staticClass:"outimg"},[_c('div',{staticClass:"imgbox floatleft",staticStyle:{"display":"table-cell","vertical-align":"middle","text-align":"center"}},[_c('img',{staticClass:"picavatar",attrs:{"src":item.image_url}})]),_vm._v(" "),_c('div',{staticClass:"ti_txt ti_dec floatleft"},[_c('p',{staticClass:"topic_text"},[_c('a',{staticClass:"topic_text_1",attrs:{"href":'/topic/' +item.tag}},[_vm._v("#"+_vm._s(item.tag)+"#")]),_vm._v(" "),_c('span',{staticClass:"topic_text_2"},[_vm._v(_vm._s(item.total_feeds)+"人参与")])]),_vm._v(" "),_c('p',{staticClass:"topic_text topic_text_3"},[_vm._v(_vm._s(item.desc))])])])])}),0):_c('div',[_c('div',{staticClass:"novideo"},[_vm._v(_vm._s(_vm.$t('home.liveTitle3_1')))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 680:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 681:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 683:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ti_main"},[_c('el-row',{staticClass:"ti_header"},[(_vm.topicinfo.new_role !=='4')?_c('el-col',{attrs:{"span":2}},[_c('el-badge',{staticClass:"ti_h_1",attrs:{"value":_vm.getRole(_vm.topicinfo.new_role),"type":_vm.getRoleColor(_vm.topicinfo.new_role)}},[_c('img',{staticClass:"ti_u_1",staticStyle:{"cursor":"pointer"},attrs:{"src":_vm.topicinfo.avatar},on:{"click":_vm.gotoUserInfo}})])],1):_c('el-col',{attrs:{"span":2}},[_c('img',{staticClass:"ti_u_1",staticStyle:{"cursor":"pointer"},attrs:{"src":_vm.topicinfo.avatar},on:{"click":_vm.gotoUserInfo}})]),_vm._v(" "),_c('el-col',{attrs:{"span":22}},[_c('p',{staticClass:"ti_name_1"},[_c('span',{staticStyle:{"cursor":"pointer"},on:{"click":_vm.gotoUserInfo}},[_vm._v(_vm._s(_vm.topicinfo.nickname))])]),_vm._v(" "),_c('p',{staticClass:"ti_time_1"},[(_vm.topicinfo.is_top_post)?_c('span',{staticClass:"ti_time_1_1"},[_vm._v("置顶")]):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.getUserInfoTxt()))]),_vm._v(" "),_vm._v("\n        "+_vm._s(_vm._f("format")(_vm.topicinfo.created_at)))])])],1),_vm._v(" "),_c('el-row',{staticClass:"ti_content"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.getContentHtml(_vm.topicinfo.content))}}),_vm._v(" "),(_vm.contentIsLong)?_c('span',{staticClass:"ti_content_long",on:{"click":_vm.contentShowAll}},[_vm._v(_vm._s(_vm.contentAllShow ? '收起':'展开')+"全文")]):_vm._e()]),_vm._v(" "),(this.topicinfo.video_url && !_vm.isPhantomjs)?_c('video-player',{ref:"videoPlayer",staticClass:"video-player vjs-custom-skin LiveDialog tc_yy2 tc_remove_outling",style:({width:_vm.videowidth + 'px',height:_vm.videoHeight + 'px'}),attrs:{"options":_vm.playerOptions,"playsinline":true,"customEventName":"customstatechangedeventname"},on:{"ready":_vm.playerReadied}}):_c('el-row',{staticClass:"ti_imglist",attrs:{"gutter":4}},_vm._l((_vm.topicinfo.pics),function(item,index){return _c('el-col',{key:index,attrs:{"span":_vm.getCol(index)}},[_c('el-image',{staticClass:"ti_il_1",staticStyle:{"height":"270px","border-radius":"10px"},attrs:{"src":item,"preview-src-list":_vm.topicinfo.pics,"fit":"none"}})],1)}),1),_vm._v(" "),_c('el-row',{staticClass:"ti_likeList"},[_c('el-col',{attrs:{"span":24}},[_vm._l((_vm.topicinfo.like_list_to_return),function(item,index){return [(index<5)?_c('el-image',{key:index,staticClass:"ti_ll_2",attrs:{"src":item.avatar,"fit":"contain"}}):_vm._e()]}),_vm._v(" "),(_vm.topicinfo.like>0)?_c('div',{staticClass:"ti_ll_1"},[_vm._v(_vm._s(_vm.topicinfo.like)+_vm._s(_vm.$t('topicItem.content1')))]):_vm._e(),_vm._v(" "),_c('el-image',{staticStyle:{"height":"32px","width":"32px","margin-left":"200px","cursor":"pointer"},attrs:{"src":_vm.getLikeUrl,"fit":"contain"},on:{"click":_vm.btnLike}})],2)],1),_vm._v(" "),(_vm.commentscount)?_c('el-row',{staticClass:"ti_comments"},[(_vm.commentscount >2)?_c('el-row',{staticClass:"ti_cl_1"},[_c('span',{on:{"click":_vm.showAllComments2}},[_vm._v(_vm._s(_vm.$t('topicItem.content2'))+_vm._s(_vm.commentscount)+_vm._s(_vm.$t('topicItem.content3')))])]):_vm._e(),_vm._v(" "),_vm._l((_vm.commentslist),function(item,index){return [(_vm.getShowAllComments(index))?_c('el-row',{key:index,staticClass:"ti_cl_2"},[_c('div',{staticClass:"ti_cl_4",on:{"click":function($event){return _vm.itemBackComments(item)}}},[_c('span',{staticClass:"ti_cl_3"},[_vm._v(_vm._s(item.nickname))]),_vm._v(" "),(item.reply_nickname)?_c('span',[_vm._v("\n            "+_vm._s(_vm.$t('topicItem.content4'))),_c('span',{staticClass:"ti_cl_3"},[_vm._v(_vm._s(item.reply_nickname))])]):_vm._e(),_vm._v("\n          "+_vm._s("："+item.comments)+"\n        ")])]):_vm._e()]})],2):_vm._e(),_vm._v(" "),(_vm.replyid)?_c('el-row',{staticClass:"ti_ca_reply"},[_c('el-tag',{attrs:{"closable":"","type":"warning"},on:{"close":_vm.closeReply}},[_vm._v("\n      "+_vm._s(_vm.$t('topicItem.content4'))+_vm._s("："+_vm.replyname)+"\n    ")])],1):_vm._e(),_vm._v(" "),_c('el-row',{staticClass:"ti_comments_add",attrs:{"gutter":20}},[_c('el-image',{staticClass:"ti_ca_avimg",attrs:{"src":_vm.useravatar,"fit":"contain"}}),_vm._v(" "),_c('el-input',{staticClass:"ti_ca_input",attrs:{"placeholder":_vm.$t('topicItem.content5'),"clearable":""},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.btnBackComments.apply(null, arguments)}},model:{value:(_vm.commentsInput),callback:function ($$v) {_vm.commentsInput=$$v},expression:"commentsInput"}}),_vm._v(" "),_c('el-button',{staticClass:"ti_ca_btn",attrs:{"type":_vm.commentsInput==='' ?'info' :'danger',"round":""},on:{"click":_vm.btnBackComments}},[_vm._v(_vm._s(_vm.$t('topicItem.content6'))+"\n    ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 755:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 756:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 757:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 760:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 763:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',[_c('div',{staticClass:"container-mobile"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('mobile_login.title')))]),_vm._v(" "),_c('div',{staticClass:"phone-box"},[_c('div',{staticClass:"prefix-wrap",on:{"click":function($event){$event.stopPropagation();return _vm.nationalCode.apply(null, arguments)}}},[_c('div',{staticClass:"prefix-text"},[_vm._v(_vm._s(_vm.form.nationalCode ? '+' + _vm.form.nationalCode : ''))])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.phone),expression:"form.phone"}],staticClass:"phone",class:{ 'fix3': _vm.form.nationalCode.length == 3, 'fix4': _vm.form.nationalCode.length == 4 },attrs:{"type":"number","placeholder":_vm.$t('mobile_login.phoneRequired')},domProps:{"value":(_vm.form.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "phone", $event.target.value)}}})]),_vm._v(" "),_c('div',{class:['text-error', { 'hide': !_vm.phoneErrMsg }]},[_vm._v(_vm._s(_vm.phoneErrMsg))]),_vm._v(" "),_c('div',{staticClass:"code-box"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.verifyCode),expression:"form.verifyCode"}],staticClass:"code",class:{ 'code-zh': _vm.isZh},attrs:{"type":"number","placeholder":_vm.$t('mobile_login.verifyCodeRequired')},domProps:{"value":(_vm.form.verifyCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "verifyCode", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"suffix-wrap",class:{ 'suffix-text': !_vm.sendCodeDisable, 'suffix-disable': _vm.sendCodeDisable },on:{"click":function($event){$event.stopPropagation();return _vm.sendCode.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.sendCodeText))])]),_vm._v(" "),_c('div',{class:['text-error', { 'hide': !_vm.errMsg }]},[_vm._v(_vm._s(_vm.errMsg))]),_vm._v(" "),_c('div',{staticClass:"login-btn"},[_c('button',{attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.login.apply(null, arguments)}}},[_c('span',[_vm._v(_vm._s(_vm.$t('mobile_login.btnName')))])])]),_vm._v(" "),_c('div',{staticClass:"oauth-login"},[_c('img',{attrs:{"src":_vm.weixinIcon},on:{"click":function($event){$event.stopPropagation();return _vm.wxLogin.apply(null, arguments)}}}),_vm._v(" "),_c('img',{attrs:{"src":_vm.qqIcon},on:{"click":function($event){$event.stopPropagation();return _vm.qqLogin.apply(null, arguments)}}}),_vm._v(" "),_c('img',{attrs:{"src":_vm.facebookIcon},on:{"click":function($event){$event.stopPropagation();return _vm.fbLogin.apply(null, arguments)}}})]),_vm._v(" "),_c('div',{staticClass:"text-license"},[_c('span',[_vm._v(_vm._s(_vm.$t('mobile_login.agreeLic')))]),_vm._v(" "),_c('span',[_c('a',{attrs:{"target":"_blank","href":_vm.goLinkUrl['terms'][_vm.goLinkeKey]}},[_vm._v(_vm._s(_vm.$t('mobile_login.lic')))])])])]),_vm._v(" "),_c('div',{staticClass:"mask",on:{"click":function($event){$event.stopPropagation();return _vm.hideLogin.apply(null, arguments)}}}),_vm._v(" "),_c('VueCountryIntl',{ref:"vci",attrs:{"modalClass":"national-code-modal","schema":"modal","listZIndex":5000,"visible":_vm.codeModalStatus,"iso2":_vm.iso2},on:{"update:visible":function($event){_vm.codeModalStatus=$event}},model:{value:(_vm.form.nationalCode),callback:function ($$v) {_vm.$set(_vm.form, "nationalCode", $$v)},expression:"form.nationalCode"}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 764:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 765:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"wrap"},[_c('div',{staticClass:"download"},[_c('div',{staticClass:"text-title"},[_vm._t("title",function(){return [_vm._v(_vm._s(_vm.$t('downloadTip.title')))]})],2),_vm._v(" "),_c('div',{staticClass:"text-btn",on:{"click":function($event){$event.stopPropagation();return _vm.gotoApp.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('downloadTip.textBtn')))])]),_vm._v(" "),_c('div',{staticClass:"mask",on:{"click":function($event){$event.stopPropagation();return _vm.hide.apply(null, arguments)}}}),_vm._v(" "),(_vm.isMask)?_c('div',{attrs:{"id":"mask"},on:{"click":function($event){_vm.isMask=false}}},[_c('img',{attrs:{"src":"http://static.lespark.cn/activity/img/mark.png","alt":""}})]):_vm._e()]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 766:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 767:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row bar"},[_c('img',{attrs:{"src":_vm.lesparkIcon}}),_vm._v(" "),_c('div',{staticClass:"text-logo"},[_c('div',[_vm._v("LesPark")]),_vm._v(" "),_c('div',[_vm._t("title",function(){return [_vm._v(_vm._s(_vm.$t('bottomBar.profile')))]})],2)]),_vm._v(" "),_c('div',{staticClass:"gas-btn"},[_c('div',{on:{"click":function($event){$event.stopPropagation();return _vm.gotoApp.apply(null, arguments)}}},[_vm._t("button-text",function(){return [_vm._v(_vm._s(_vm.$t('common.goAndSeed')))]})],2)])]),_vm._v(" "),(_vm.isMask)?_c('div',{attrs:{"id":"mask"},on:{"click":function($event){_vm.isMask=false}}},[_c('img',{attrs:{"src":"http://static.lespark.cn/activity/img/mark.png","alt":""}})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 77:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 78:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_menu_vue__ = __webpack_require__(259);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3abbfb6b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_menu_vue__ = __webpack_require__(623);
function injectStyle (ssrContext) {
  __webpack_require__(622)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3abbfb6b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_menu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3abbfb6b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_menu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 79:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mobilefoot_vue__ = __webpack_require__(260);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f9f16fc_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mobilefoot_vue__ = __webpack_require__(625);
function injectStyle (ssrContext) {
  __webpack_require__(624)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0f9f16fc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mobilefoot_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f9f16fc_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mobilefoot_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 98:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 99:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// js/common.5c3b6604fb879c8b0718.js